var cgjsCryptModule = (function ($) {
  function cgjsCrypt() {
    function a(b) {
      if (!b) {
        b = 8;
      }
      var c = new Array(b);
      var e = [];
      for (var d = 0; d < 256; d++) {
        e[d] = d;
      }
      for (d = 0; d < c.length; d++) {
        c[d] = e[Math.floor(Math.random() * e.length)];
      }
      return c;
    }
    this.setDefaults = function () {
      this.params.nBits = 256;
      this.params.salt = a(8);
      this.params.salt = cgjsCryptUtil.byteArray2String(this.params.salt);
      this.params.salt = cgjsCryptUtil.convertToHex(this.params.salt);
      this.params.blockSize = 16;
      this.params.UTF8 = true;
      this.params.A0_PAD = true;
    };
    this.debug = true;
    this.params = {};
    this.params.dataIn = "";
    this.params.dataOut = "";
    this.params.decryptIn = "";
    this.params.decryptOut = "";
    this.params.encryptIn = "";
    this.params.encryptOut = "";
    this.params.key = "";
    this.params.iv = "";
    this.params.clear = true;
    this.setDefaults();
    this.errors = "";
    this.warnings = "";
    this.infos = "";
    this.debugMsg = "";
    this.setParams = function (c) {
      if (!c) {
        c = {};
      }
      for (var b in c) {
        this.params[b] = c[b];
      }
    };
    this.getParams = function () {
      return this.params;
    };
    this.getParam = function (b) {
      return this.params[b] || "";
    };
    this.clearParams = function () {
      this.params = {};
    };
    this.getNBits = function () {
      return this.params.nBits;
    };
    this.getOutput = function () {
      return this.params.dataOut;
    };
    this.setError = function (b) {
      this.error = b;
    };
    this.appendError = function (b) {
      this.errors += b;
      return "";
    };
    this.getErrors = function () {
      return this.errors;
    };
    this.isError = function () {
      if (this.errors.length > 0) {
        return true;
      }
      return false;
    };
    this.appendInfo = function (b) {
      this.infos += b;
      return "";
    };
    this.getInfos = function () {
      return this.infos;
    };
    this.setDebug = function (b) {
      this.debug = b;
    };
    this.appendDebug = function (b) {
      this.debugMsg += b;
      return "";
    };
    this.isDebug = function () {
      return this.debug;
    };
    this.getAllMessages = function (c) {
      var g = {
        lf: "\n",
        clr_mes: false,
        verbose: 15,
      };
      if (!c) {
        c = g;
      }
      for (var h in g) {
        if (typeof c[h] == "undefined") {
          c[h] = g[h];
        }
      }
      var b = "";
      var e = "";
      for (var f in this.params) {
        switch (f) {
          case "encryptOut":
            e = cgjsCryptUtil.toByteArray(this.params[f].toString());
            e = cgjsCryptUtil.fragment(e.join(), 64, c.lf);
            break;
          case "key":
          case "iv":
            e = cgjsCryptUtil.formatHex(this.params[f], 48);
            break;
          default:
            e = cgjsCryptUtil.fragment(this.params[f].toString(), 64, c.lf);
        }
        b += "<p><b>" + f + "</b>:<pre>" + e + "</pre></p>";
      }
      if (this.debug) {
        b += "debug: " + this.debug + c.lf;
      }
      if (this.errors.length > 0 && (c.verbose & 1) == 1) {
        b += "Errors:" + c.lf + this.errors + c.lf;
      }
      if (this.warnings.length > 0 && (c.verbose & 2) == 2) {
        b += "Warnings:" + c.lf + this.warnings + c.lf;
      }
      if (this.infos.length > 0 && (c.verbose & 4) == 4) {
        b += "Infos:" + c.lf + this.infos + c.lf;
      }
      if (this.debug && (c.verbose & 8) == 8) {
        b += "Debug messages:" + c.lf + this.debugMsg + c.lf;
      }
      if (c.clr_mes) {
        this.errors = this.infos = this.warnings = this.debug = "";
      }
      return b;
    };
    this.getRandomBytes = function (b) {
      return a(b);
    };
  }
  cgjsCryptUtil = {};
  cgjsCryptUtil.encodeBase64 = function (n, p) {
    if (!n) {
      n = "";
    }
    var g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    p = typeof p == "undefined" ? false : p;
    var f,
      b,
      a,
      r,
      o,
      k,
      j,
      h,
      i = [],
      d = "",
      m,
      q,
      l;
    q = p ? cgjsCryptUtil.encodeUTF8(n) : n;
    m = q.length % 3;
    if (m > 0) {
      while (m++ < 3) {
        d += "=";
        q += "\0";
      }
    }
    for (m = 0; m < q.length; m += 3) {
      f = q.charCodeAt(m);
      b = q.charCodeAt(m + 1);
      a = q.charCodeAt(m + 2);
      r = (f << 16) | (b << 8) | a;
      o = (r >> 18) & 63;
      k = (r >> 12) & 63;
      j = (r >> 6) & 63;
      h = r & 63;
      i[m / 3] = g.charAt(o) + g.charAt(k) + g.charAt(j) + g.charAt(h);
    }
    l = i.join("");
    l = l.slice(0, l.length - d.length) + d;
    return l;
  };
  cgjsCryptUtil.decodeBase64 = function (n, e) {
    if (!n) {
      n = "";
    }
    var g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    e = typeof e == "undefined" ? false : e;
    var f,
      b,
      a,
      o,
      k,
      i,
      h,
      q,
      j = [],
      p,
      m;
    m = e ? cgjsCryptUtil.decodeUTF8(n) : n;
    for (var l = 0; l < m.length; l += 4) {
      o = g.indexOf(m.charAt(l));
      k = g.indexOf(m.charAt(l + 1));
      i = g.indexOf(m.charAt(l + 2));
      h = g.indexOf(m.charAt(l + 3));
      q = (o << 18) | (k << 12) | (i << 6) | h;
      f = (q >>> 16) & 255;
      b = (q >>> 8) & 255;
      a = q & 255;
      j[l / 4] = String.fromCharCode(f, b, a);
      if (h == 64) {
        j[l / 4] = String.fromCharCode(f, b);
      }
      if (i == 64) {
        j[l / 4] = String.fromCharCode(f);
      }
    }
    p = j.join("");
    p = e ? cgjsCryptUtil.decodeUTF8(p) : p;
    return p;
  };
  cgjsCryptUtil.encodeUTF8 = function (a) {
    if (!a) {
      a = "";
    }
    a = a.replace(/[\u0080-\u07ff]/g, function (d) {
      var b = d.charCodeAt(0);
      return String.fromCharCode(192 | (b >> 6), 128 | (b & 63));
    });
    a = a.replace(/[\u0800-\uffff]/g, function (d) {
      var b = d.charCodeAt(0);
      return String.fromCharCode(
        224 | (b >> 12),
        128 | ((b >> 6) & 63),
        128 | (b & 63)
      );
    });
    return a;
  };
  cgjsCryptUtil.decodeUTF8 = function (a) {
    if (!a) {
      a = "";
    }
    a = a.replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function (d) {
      var b = ((d.charCodeAt(0) & 31) << 6) | (d.charCodeAt(1) & 63);
      return String.fromCharCode(b);
    });
    a = a.replace(
      /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
      function (d) {
        var b =
          ((d.charCodeAt(0) & 15) << 12) |
          ((d.charCodeAt(1) & 63) << 6) |
          (d.charCodeAt(2) & 63);
        return String.fromCharCode(b);
      }
    );
    return a;
  };
  cgjsCryptUtil.convertToHex = function (d) {
    if (!d) {
      d = "";
    }
    var c = "";
    var a = "";
    for (var b = 0; b < d.length; b++) {
      a = d.charCodeAt(b).toString(16);
      c += a.length == 1 ? "0" + a : a;
    }
    return c;
  };
  cgjsCryptUtil.convertFromHex = function (c) {
    if (!c) {
      c = "";
    }
    var b = "";
    for (var a = 0; a < c.length; a += 2) {
      b += String.fromCharCode(parseInt(c.substring(a, a + 2), 16));
    }
    return b;
  };
  cgjsCryptUtil.stripLineFeeds = function (b) {
    if (!b) {
      b = "";
    }
    var a = "";
    a = b.replace(/\n/g, "");
    a = a.replace(/\r/g, "");
    return a;
  };
  cgjsCryptUtil.toByteArray = function (b) {
    if (!b) {
      b = "";
    }
    var c = [];
    for (var a = 0; a < b.length; a++) {
      c[a] = b.charCodeAt(a);
    }
    return c;
  };
  cgjsCryptUtil.fragment = function (e, d, a) {
    if (!e) {
      e = "";
    }
    if (!d || d >= e.length) {
      return e;
    }
    if (!a) {
      a = "\n";
    }
    var c = "";
    for (var b = 0; b < e.length; b += d) {
      c += e.substr(b, d) + a;
    }
    return c;
  };
  cgjsCryptUtil.formatHex = function (f, e) {
    if (!f) {
      f = "";
    }
    if (!e) {
      e = 45;
    }
    var a = "";
    var b = 0;
    var d = f.toLowerCase();
    for (var c = 0; c < d.length; c += 2) {
      a += d.substr(c, 2) + ":";
    }
    d = this.fragment(a, e);
    return d;
  };
  cgjsCryptUtil.byteArray2String = function (a) {
    var d = "";
    for (var c = 0; c < a.length; c++) {
      d += String.fromCharCode(a[c]);
    }
    return d;
  };

  function Stream(a, b) {
    if (a instanceof Stream) {
      this.enc = a.enc;
      this.pos = a.pos;
    } else {
      this.enc = a;
      this.pos = b;
    }
  }
  Stream.prototype.parseStringHex = function (e, a) {
    if (typeof a == "undefined") {
      a = this.enc.length;
    }
    var d = "";
    for (var b = e; b < a; ++b) {
      var c = this.get(b);
      d += this.hexDigits.charAt(c >> 4) + this.hexDigits.charAt(c & 15);
    }
    return d;
  };
  Stream.prototype.get = function (a) {
    if (a == undefined) {
      a = this.pos++;
    }
    if (a >= this.enc.length) {
      throw (
        "Requesting byte offset " +
        a +
        " on a stream of length " +
        this.enc.length
      );
    }
    return this.enc[a];
  };
  Stream.prototype.hexDigits = "0123456789ABCDEF";
  Stream.prototype.hexDump = function (e, a) {
    var d = "";
    for (var b = e; b < a; ++b) {
      var c = this.get(b);
      d += this.hexDigits.charAt(c >> 4) + this.hexDigits.charAt(c & 15);
      if ((b & 15) == 7) {
        d += " ";
      }
      d += (b & 15) == 15 ? "\n" : " ";
    }
    return d;
  };
  Stream.prototype.parseStringISO = function (d, a) {
    var c = "";
    for (var b = d; b < a; ++b) {
      c += String.fromCharCode(this.get(b));
    }
    return c;
  };
  Stream.prototype.parseStringUTF = function (f, a) {
    var d = "",
      e = 0;
    for (var b = f; b < a; ) {
      var e = this.get(b++);
      if (e < 128) {
        d += String.fromCharCode(e);
      } else {
        if (e > 191 && e < 224) {
          d += String.fromCharCode(((e & 31) << 6) | (this.get(b++) & 63));
        } else {
          d += String.fromCharCode(
            ((e & 15) << 12) |
              ((this.get(b++) & 63) << 6) |
              (this.get(b++) & 63)
          );
        }
      }
    }
    return d;
  };
  Stream.prototype.reTime =
    /^((?:1[89]|2\d)?\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
  Stream.prototype.parseTime = function (d, b) {
    var c = this.parseStringISO(d, b);
    var a = this.reTime.exec(c);
    if (!a) {
      return "Unrecognized time: " + c;
    }
    c = a[1] + "-" + a[2] + "-" + a[3] + " " + a[4];
    if (a[5]) {
      c += ":" + a[5];
      if (a[6]) {
        c += ":" + a[6];
        if (a[7]) {
          c += "." + a[7];
        }
      }
    }
    if (a[8]) {
      c += " UTC";
      if (a[8] != "Z") {
        c += a[8];
        if (a[9]) {
          c += ":" + a[9];
        }
      }
    }
    return c;
  };
  Stream.prototype.parseInteger = function (d, a) {
    if (a - d > 4) {
      return undefined;
    }
    var c = 0;
    for (var b = d; b < a; ++b) {
      c = (c << 8) | this.get(b);
    }
    return c;
  };
  Stream.prototype.parseOID = function (g, a) {
    var d,
      f = 0,
      e = 0;
    for (var c = g; c < a; ++c) {
      var b = this.get(c);
      f = (f << 7) | (b & 127);
      e += 7;
      if (!(b & 128)) {
        if (d == undefined) {
          d = parseInt(f / 40) + "." + (f % 40);
        } else {
          d += "." + (e >= 31 ? "big" : f);
        }
        f = e = 0;
      }
      d += String.fromCharCode();
    }
    return d;
  };
  if (typeof cgjsCrypt != "undefined") {
    cgjsCrypt.ASN1 = function (d, e, c, a, b) {
      this.stream = d;
      this.header = e;
      this.length = c;
      this.tag = a;
      this.sub = b;
    };
    cgjsCrypt.ASN1.prototype.toHexTree = function () {
      var c = {};
      c.type = this.typeName();
      if (c.type != "SEQUENCE") {
        c.value = this.stream.parseStringHex(this.posContent(), this.posEnd());
      }
      if (this.sub != null) {
        c.sub = [];
        for (var b = 0, a = this.sub.length; b < a; ++b) {
          c.sub[b] = this.sub[b].toHexTree();
        }
      }
      return c;
    };
    cgjsCrypt.ASN1.prototype.typeName = function () {
      if (this.tag == undefined) {
        return "unknown";
      }
      var c = this.tag >> 6;
      var a = (this.tag >> 5) & 1;
      var b = this.tag & 31;
      switch (c) {
        case 0:
          switch (b) {
            case 0:
              return "EOC";
            case 1:
              return "BOOLEAN";
            case 2:
              return "INTEGER";
            case 3:
              return "BIT_STRING";
            case 4:
              return "OCTET_STRING";
            case 5:
              return "NULL";
            case 6:
              return "OBJECT_IDENTIFIER";
            case 7:
              return "ObjectDescriptor";
            case 8:
              return "EXTERNAL";
            case 9:
              return "REAL";
            case 10:
              return "ENUMERATED";
            case 11:
              return "EMBEDDED_PDV";
            case 12:
              return "UTF8String";
            case 16:
              return "SEQUENCE";
            case 17:
              return "SET";
            case 18:
              return "NumericString";
            case 19:
              return "PrintableString";
            case 20:
              return "TeletexString";
            case 21:
              return "VideotexString";
            case 22:
              return "IA5String";
            case 23:
              return "UTCTime";
            case 24:
              return "GeneralizedTime";
            case 25:
              return "GraphicString";
            case 26:
              return "VisibleString";
            case 27:
              return "GeneralString";
            case 28:
              return "UniversalString";
            case 30:
              return "BMPString";
            default:
              return "Universal_" + b.toString(16);
          }
        case 1:
          return "Application_" + b.toString(16);
        case 2:
          return "[" + b + "]";
        case 3:
          return "Private_" + b.toString(16);
      }
    };
    cgjsCrypt.ASN1.prototype.content = function () {
      if (this.tag == undefined) {
        return null;
      }
      var d = this.tag >> 6;
      if (d != 0) {
        return null;
      }
      var b = this.tag & 31;
      var c = this.posContent();
      var a = Math.abs(this.length);
      switch (b) {
        case 1:
          return this.stream.get(c) == 0 ? "false" : "true";
        case 2:
          return this.stream.parseInteger(c, c + a);
        case 6:
          return this.stream.parseOID(c, c + a);
        case 12:
          return this.stream.parseStringUTF(c, c + a);
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 26:
          return this.stream.parseStringISO(c, c + a);
        case 23:
        case 24:
          return this.stream.parseTime(c, c + a);
      }
      return null;
    };
    cgjsCrypt.ASN1.prototype.toString = function () {
      return (
        this.typeName() +
        "@" +
        this.stream.pos +
        "[header:" +
        this.header +
        ",length:" +
        this.length +
        ",sub:" +
        (this.sub == null ? "null" : this.sub.length) +
        "]"
      );
    };
    cgjsCrypt.ASN1.prototype.print = function (b) {
      if (b == undefined) {
        b = "";
      }
      document.writeln(b + this);
      if (this.sub != null) {
        b += "  ";
        for (var c = 0, a = this.sub.length; c < a; ++c) {
          this.sub[c].print(b);
        }
      }
    };
    cgjsCrypt.ASN1.prototype.toPrettyString = function (b) {
      if (b == undefined) {
        b = "";
      }
      var d = b + this.typeName() + " @" + this.stream.pos;
      if (this.length >= 0) {
        d += "+";
      }
      d += this.length;
      if (this.tag & 32) {
        d += " (constructed)";
      } else {
        if ((this.tag == 3 || this.tag == 4) && this.sub != null) {
          d += " (encapsulates)";
        }
      }
      d += "\n";
      if (this.sub != null) {
        b += "  ";
        for (var c = 0, a = this.sub.length; c < a; ++c) {
          d += this.sub[c].toPrettyString(b);
        }
      }
      return d;
    };
    cgjsCrypt.ASN1.prototype.toDOM = function () {
      var b = document.createElement("div");
      b.className = "node";
      b.asn1 = this;
      var g = document.createElement("div");
      g.className = "head";
      var j = this.typeName();
      g.innerHTML = j;
      b.appendChild(g);
      this.head = g;
      var h = document.createElement("div");
      h.className = "value";
      j = "Offset: " + this.stream.pos + "<br/>";
      j += "Length: " + this.header + "+";
      if (this.length >= 0) {
        j += this.length;
      } else {
        j += -this.length + " (undefined)";
      }
      if (this.tag & 32) {
        j += "<br/>(constructed)";
      } else {
        if ((this.tag == 3 || this.tag == 4) && this.sub != null) {
          j += "<br/>(encapsulates)";
        }
      }
      var e = this.content();
      if (e != null) {
        j += "<br/>Value:<br/><b>" + e + "</b>";
        if (typeof oids == "object" && this.tag == 6) {
          var c = oids[e];
          if (c) {
            if (c.d) {
              j += "<br/>" + c.d;
            }
            if (c.c) {
              j += "<br/>" + c.c;
            }
            if (c.w) {
              j += "<br/>(warning!)";
            }
          }
        }
      }
      h.innerHTML = j;
      b.appendChild(h);
      var a = document.createElement("div");
      a.className = "sub";
      if (this.sub != null) {
        for (var d = 0, f = this.sub.length; d < f; ++d) {
          a.appendChild(this.sub[d].toDOM());
        }
      }
      b.appendChild(a);
      g.switchNode = b;
      g.onclick = function () {
        var i = this.switchNode;
        i.className =
          i.className == "node collapsed" ? "node" : "node collapsed";
      };
      return b;
    };
    cgjsCrypt.ASN1.prototype.posStart = function () {
      return this.stream.pos;
    };
    cgjsCrypt.ASN1.prototype.posContent = function () {
      return this.stream.pos + this.header;
    };
    cgjsCrypt.ASN1.prototype.posEnd = function () {
      return this.stream.pos + this.header + Math.abs(this.length);
    };
    cgjsCrypt.ASN1.prototype.toHexDOM_sub = function (d, c, e, f, a) {
      if (f >= a) {
        return;
      }
      var b = document.createElement("span");
      b.className = c;
      b.appendChild(document.createTextNode(e.hexDump(f, a)));
      d.appendChild(b);
    };
    cgjsCrypt.ASN1.prototype.toHexDOM = function () {
      var d = document.createElement("span");
      d.className = "hex";
      this.head.hexNode = d;
      this.head.onmouseover = function () {
        this.hexNode.className = "hexCurrent";
      };
      this.head.onmouseout = function () {
        this.hexNode.className = "hex";
      };
      this.toHexDOM_sub(
        d,
        "tag",
        this.stream,
        this.posStart(),
        this.posStart() + 1
      );
      this.toHexDOM_sub(
        d,
        this.length >= 0 ? "dlen" : "ulen",
        this.stream,
        this.posStart() + 1,
        this.posContent()
      );
      if (this.sub == null) {
        d.appendChild(
          document.createTextNode(
            this.stream.hexDump(this.posContent(), this.posEnd())
          )
        );
      } else {
        if (this.sub.length > 0) {
          var e = this.sub[0];
          var c = this.sub[this.sub.length - 1];
          this.toHexDOM_sub(
            d,
            "intro",
            this.stream,
            this.posContent(),
            e.posStart()
          );
          for (var b = 0, a = this.sub.length; b < a; ++b) {
            d.appendChild(this.sub[b].toHexDOM());
          }
          this.toHexDOM_sub(d, "outro", this.stream, c.posEnd(), this.posEnd());
        }
      }
      return d;
    };
    cgjsCrypt.ASN1.decodeLength = function (d) {
      var b = d.get();
      var a = b & 127;
      if (a == b) {
        return a;
      }
      if (a > 3) {
        throw "Length over 24 bits not supported at position " + (d.pos - 1);
      }
      if (a == 0) {
        return -1;
      }
      b = 0;
      for (var c = 0; c < a; ++c) {
        b = (b << 8) | d.get();
      }
      return b;
    };
    cgjsCrypt.ASN1.hasContent = function (b, a, g) {
      if (b & 32) {
        return true;
      }
      if (b < 3 || b > 4) {
        return false;
      }
      var f = new Stream(g);
      if (b == 3) {
        f.get();
      }
      var e = f.get();
      if ((e >> 6) & 1) {
        return false;
      }
      try {
        var d = cgjsCrypt.ASN1.decodeLength(f);
        return f.pos - g.pos + d == a;
      } catch (c) {
        return false;
      }
    };
    cgjsCrypt.ASN1.decode = function (i) {
      if (!(i instanceof Stream)) {
        i = new Stream(i, 0);
      }
      var h = new Stream(i);
      var k = i.get();
      var f = cgjsCrypt.ASN1.decodeLength(i);
      var d = i.pos - h.pos;
      var a = null;
      if (cgjsCrypt.ASN1.hasContent(k, f, i)) {
        var b = i.pos;
        if (k == 3) {
          i.get();
        }
        a = [];
        if (f >= 0) {
          var c = b + f;
          while (i.pos < c) {
            a[a.length] = cgjsCrypt.ASN1.decode(i);
          }
          if (i.pos != c) {
            throw (
              "Content size is not correct for container starting at offset " +
              b
            );
          }
        } else {
          try {
            for (;;) {
              var j = cgjsCrypt.ASN1.decode(i);
              if (j.tag == 0) {
                break;
              }
              a[a.length] = j;
            }
            f = b - i.pos;
          } catch (g) {
            throw "Exception while decoding undefined length content: " + g;
          }
        }
      } else {
        i.pos += f;
      }
      return new cgjsCrypt.ASN1(h, d, f, k, a);
    };
    cgjsCrypt.ASN1.test = function () {
      var f = [
        {
          value: [39],
          expected: 39,
        },
        {
          value: [129, 201],
          expected: 201,
        },
        {
          value: [131, 254, 220, 186],
          expected: 16702650,
        },
      ];
      for (var c = 0, a = f.length; c < a; ++c) {
        var e = 0;
        var d = new Stream(f[c].value, 0);
        var b = cgjsCrypt.ASN1.decodeLength(d);
        if (b != f[c].expected) {
          document.write(
            "In test[" + c + "] expected " + f[c].expected + " got " + b + "\n"
          );
        }
      }
    };
  }
  var dbits;
  var canary = 244837814094590;
  var j_lm = (canary & 16777215) == 15715070;

  function BigInteger(e, d, f) {
    if (e != null) {
      if ("number" == typeof e) {
        this.fromNumber(e, d, f);
      } else {
        if (d == null && "string" != typeof e) {
          this.fromString(e, 256);
        } else {
          this.fromString(e, d);
        }
      }
    }
  }

  function nbi() {
    return new BigInteger(null);
  }

  function am1(f, a, b, e, h, g) {
    while (--g >= 0) {
      var d = a * this[f++] + b[e] + h;
      h = Math.floor(d / 67108864);
      b[e++] = d & 67108863;
    }
    return h;
  }

  function am2(f, q, r, e, o, a) {
    var k = q & 32767,
      p = q >> 15;
    while (--a >= 0) {
      var d = this[f] & 32767;
      var g = this[f++] >> 15;
      var b = p * d + g * k;
      d = k * d + ((b & 32767) << 15) + r[e] + (o & 1073741823);
      o = (d >>> 30) + (b >>> 15) + p * g + (o >>> 30);
      r[e++] = d & 1073741823;
    }
    return o;
  }

  function am3(f, q, r, e, o, a) {
    var k = q & 16383,
      p = q >> 14;
    while (--a >= 0) {
      var d = this[f] & 16383;
      var g = this[f++] >> 14;
      var b = p * d + g * k;
      d = k * d + ((b & 16383) << 14) + r[e] + o;
      o = (d >> 28) + (b >> 14) + p * g;
      r[e++] = d & 268435455;
    }
    return o;
  }
  if (j_lm && navigator.appName == "Microsoft Internet Explorer") {
    BigInteger.prototype.am = am2;
    dbits = 30;
  } else {
    if (j_lm && navigator.appName != "Netscape") {
      BigInteger.prototype.am = am1;
      dbits = 26;
    } else {
      BigInteger.prototype.am = am3;
      dbits = 28;
    }
  }
  BigInteger.prototype.DB = dbits;
  BigInteger.prototype.DM = (1 << dbits) - 1;
  BigInteger.prototype.DV = 1 << dbits;
  var BI_FP = 52;
  BigInteger.prototype.FV = Math.pow(2, BI_FP);
  BigInteger.prototype.F1 = BI_FP - dbits;
  BigInteger.prototype.F2 = 2 * dbits - BI_FP;
  var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
  var BI_RC = new Array();
  var rr, vv;
  rr = "0".charCodeAt(0);
  for (vv = 0; vv <= 9; ++vv) {
    BI_RC[rr++] = vv;
  }
  rr = "a".charCodeAt(0);
  for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
  }
  rr = "A".charCodeAt(0);
  for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
  }

  function int2char(a) {
    return BI_RM.charAt(a);
  }

  function intAt(b, a) {
    var d = BI_RC[b.charCodeAt(a)];
    return d == null ? -1 : d;
  }

  function bnpCopyTo(b) {
    for (var a = this.t - 1; a >= 0; --a) {
      b[a] = this[a];
    }
    b.t = this.t;
    b.s = this.s;
  }

  function bnpFromInt(a) {
    this.t = 1;
    this.s = a < 0 ? -1 : 0;
    if (a > 0) {
      this[0] = a;
    } else {
      if (a < -1) {
        this[0] = a + DV;
      } else {
        this.t = 0;
      }
    }
  }

  function nbv(a) {
    var b = nbi();
    b.fromInt(a);
    return b;
  }

  function bnpFromString(h, c) {
    var e;
    if (c == 16) {
      e = 4;
    } else {
      if (c == 8) {
        e = 3;
      } else {
        if (c == 256) {
          e = 8;
        } else {
          if (c == 2) {
            e = 1;
          } else {
            if (c == 32) {
              e = 5;
            } else {
              if (c == 4) {
                e = 2;
              } else {
                this.fromRadix(h, c);
                return;
              }
            }
          }
        }
      }
    }
    this.t = 0;
    this.s = 0;
    var g = h.length,
      d = false,
      f = 0;
    while (--g >= 0) {
      var a = e == 8 ? h[g] & 255 : intAt(h, g);
      if (a < 0) {
        if (h.charAt(g) == "-") {
          d = true;
        }
        continue;
      }
      d = false;
      if (f == 0) {
        this[this.t++] = a;
      } else {
        if (f + e > this.DB) {
          this[this.t - 1] |= (a & ((1 << (this.DB - f)) - 1)) << f;
          this[this.t++] = a >> (this.DB - f);
        } else {
          this[this.t - 1] |= a << f;
        }
      }
      f += e;
      if (f >= this.DB) {
        f -= this.DB;
      }
    }
    if (e == 8 && (h[0] & 128) != 0) {
      this.s = -1;
      if (f > 0) {
        this[this.t - 1] |= ((1 << (this.DB - f)) - 1) << f;
      }
    }
    this.clamp();
    if (d) {
      BigInteger.ZERO.subTo(this, this);
    }
  }

  function bnpClamp() {
    var a = this.s & this.DM;
    while (this.t > 0 && this[this.t - 1] == a) {
      --this.t;
    }
  }

  function bnToString(c) {
    if (this.s < 0) {
      return "-" + this.negate().toString(c);
    }
    var e;
    if (c == 16) {
      e = 4;
    } else {
      if (c == 8) {
        e = 3;
      } else {
        if (c == 2) {
          e = 1;
        } else {
          if (c == 32) {
            e = 5;
          } else {
            if (c == 4) {
              e = 2;
            } else {
              return this.toRadix(c);
            }
          }
        }
      }
    }
    var g = (1 << e) - 1,
      l,
      a = false,
      h = "",
      f = this.t;
    var j = this.DB - ((f * this.DB) % e);
    if (f-- > 0) {
      if (j < this.DB && (l = this[f] >> j) > 0) {
        a = true;
        h = int2char(l);
      }
      while (f >= 0) {
        if (j < e) {
          l = (this[f] & ((1 << j) - 1)) << (e - j);
          l |= this[--f] >> (j += this.DB - e);
        } else {
          l = (this[f] >> (j -= e)) & g;
          if (j <= 0) {
            j += this.DB;
            --f;
          }
        }
        if (l > 0) {
          a = true;
        }
        if (a) {
          h += int2char(l);
        }
      }
    }
    return a ? h : "0";
  }

  function bnNegate() {
    var a = nbi();
    BigInteger.ZERO.subTo(this, a);
    return a;
  }

  function bnAbs() {
    return this.s < 0 ? this.negate() : this;
  }

  function bnCompareTo(b) {
    var d = this.s - b.s;
    if (d != 0) {
      return d;
    }
    var c = this.t;
    d = c - b.t;
    if (d != 0) {
      return d;
    }
    while (--c >= 0) {
      if ((d = this[c] - b[c]) != 0) {
        return d;
      }
    }
    return 0;
  }

  function nbits(a) {
    var c = 1,
      b;
    if ((b = a >>> 16) != 0) {
      a = b;
      c += 16;
    }
    if ((b = a >> 8) != 0) {
      a = b;
      c += 8;
    }
    if ((b = a >> 4) != 0) {
      a = b;
      c += 4;
    }
    if ((b = a >> 2) != 0) {
      a = b;
      c += 2;
    }
    if ((b = a >> 1) != 0) {
      a = b;
      c += 1;
    }
    return c;
  }

  function bnBitLength() {
    if (this.t <= 0) {
      return 0;
    }
    return (
      this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM))
    );
  }

  function bnpDLShiftTo(c, b) {
    var a;
    for (a = this.t - 1; a >= 0; --a) {
      b[a + c] = this[a];
    }
    for (a = c - 1; a >= 0; --a) {
      b[a] = 0;
    }
    b.t = this.t + c;
    b.s = this.s;
  }

  function bnpDRShiftTo(c, b) {
    for (var a = c; a < this.t; ++a) {
      b[a - c] = this[a];
    }
    b.t = Math.max(this.t - c, 0);
    b.s = this.s;
  }

  function bnpLShiftTo(j, e) {
    var b = j % this.DB;
    var a = this.DB - b;
    var g = (1 << a) - 1;
    var f = Math.floor(j / this.DB),
      h = (this.s << b) & this.DM,
      d;
    for (d = this.t - 1; d >= 0; --d) {
      e[d + f + 1] = (this[d] >> a) | h;
      h = (this[d] & g) << b;
    }
    for (d = f - 1; d >= 0; --d) {
      e[d] = 0;
    }
    e[f] = h;
    e.t = this.t + f + 1;
    e.s = this.s;
    e.clamp();
  }

  function bnpRShiftTo(g, d) {
    d.s = this.s;
    var e = Math.floor(g / this.DB);
    if (e >= this.t) {
      d.t = 0;
      return;
    }
    var b = g % this.DB;
    var a = this.DB - b;
    var f = (1 << b) - 1;
    d[0] = this[e] >> b;
    for (var c = e + 1; c < this.t; ++c) {
      d[c - e - 1] |= (this[c] & f) << a;
      d[c - e] = this[c] >> b;
    }
    if (b > 0) {
      d[this.t - e - 1] |= (this.s & f) << a;
    }
    d.t = this.t - e;
    d.clamp();
  }

  function bnpSubTo(d, f) {
    var e = 0,
      g = 0,
      b = Math.min(d.t, this.t);
    while (e < b) {
      g += this[e] - d[e];
      f[e++] = g & this.DM;
      g >>= this.DB;
    }
    if (d.t < this.t) {
      g -= d.s;
      while (e < this.t) {
        g += this[e];
        f[e++] = g & this.DM;
        g >>= this.DB;
      }
      g += this.s;
    } else {
      g += this.s;
      while (e < d.t) {
        g -= d[e];
        f[e++] = g & this.DM;
        g >>= this.DB;
      }
      g -= d.s;
    }
    f.s = g < 0 ? -1 : 0;
    if (g < -1) {
      f[e++] = this.DV + g;
    } else {
      if (g > 0) {
        f[e++] = g;
      }
    }
    f.t = e;
    f.clamp();
  }

  function bnpMultiplyTo(c, e) {
    var b = this.abs(),
      f = c.abs();
    var d = b.t;
    e.t = d + f.t;
    while (--d >= 0) {
      e[d] = 0;
    }
    for (d = 0; d < f.t; ++d) {
      e[d + b.t] = b.am(0, f[d], e, d, 0, b.t);
    }
    e.s = 0;
    e.clamp();
    if (this.s != c.s) {
      BigInteger.ZERO.subTo(e, e);
    }
  }

  function bnpSquareTo(d) {
    var a = this.abs();
    var b = (d.t = 2 * a.t);
    while (--b >= 0) {
      d[b] = 0;
    }
    for (b = 0; b < a.t - 1; ++b) {
      var e = a.am(b, a[b], d, 2 * b, 0, 1);
      if (
        (d[b + a.t] += a.am(b + 1, 2 * a[b], d, 2 * b + 1, e, a.t - b - 1)) >=
        a.DV
      ) {
        d[b + a.t] -= a.DV;
        d[b + a.t + 1] = 1;
      }
    }
    if (d.t > 0) {
      d[d.t - 1] += a.am(b, a[b], d, 2 * b, 0, 1);
    }
    d.s = 0;
    d.clamp();
  }

  function bnpDivRemTo(n, h, g) {
    var w = n.abs();
    if (w.t <= 0) {
      return;
    }
    var k = this.abs();
    if (k.t < w.t) {
      if (h != null) {
        h.fromInt(0);
      }
      if (g != null) {
        this.copyTo(g);
      }
      return;
    }
    if (g == null) {
      g = nbi();
    }
    var d = nbi(),
      a = this.s,
      l = n.s;
    var v = this.DB - nbits(w[w.t - 1]);
    if (v > 0) {
      w.lShiftTo(v, d);
      k.lShiftTo(v, g);
    } else {
      w.copyTo(d);
      k.copyTo(g);
    }
    var p = d.t;
    var b = d[p - 1];
    if (b == 0) {
      return;
    }
    var o = b * (1 << this.F1) + (p > 1 ? d[p - 2] >> this.F2 : 0);
    var A = this.FV / o,
      z = (1 << this.F1) / o,
      x = 1 << this.F2;
    var u = g.t,
      s = u - p,
      f = h == null ? nbi() : h;
    d.dlShiftTo(s, f);
    if (g.compareTo(f) >= 0) {
      g[g.t++] = 1;
      g.subTo(f, g);
    }
    BigInteger.ONE.dlShiftTo(p, f);
    f.subTo(d, d);
    while (d.t < p) {
      d[d.t++] = 0;
    }
    while (--s >= 0) {
      var c = g[--u] == b ? this.DM : Math.floor(g[u] * A + (g[u - 1] + x) * z);
      if ((g[u] += d.am(0, c, g, s, 0, p)) < c) {
        d.dlShiftTo(s, f);
        g.subTo(f, g);
        while (g[u] < --c) {
          g.subTo(f, g);
        }
      }
    }
    if (h != null) {
      g.drShiftTo(p, h);
      if (a != l) {
        BigInteger.ZERO.subTo(h, h);
      }
    }
    g.t = p;
    g.clamp();
    if (v > 0) {
      g.rShiftTo(v, g);
    }
    if (a < 0) {
      BigInteger.ZERO.subTo(g, g);
    }
  }

  function bnMod(b) {
    var c = nbi();
    this.abs().divRemTo(b, null, c);
    if (this.s < 0 && c.compareTo(BigInteger.ZERO) > 0) {
      b.subTo(c, c);
    }
    return c;
  }

  function Classic(a) {
    this.m = a;
  }

  function cConvert(a) {
    if (a.s < 0 || a.compareTo(this.m) >= 0) {
      return a.mod(this.m);
    } else {
      return a;
    }
  }

  function cRevert(a) {
    return a;
  }

  function cReduce(a) {
    a.divRemTo(this.m, null, a);
  }

  function cMulTo(a, c, b) {
    a.multiplyTo(c, b);
    this.reduce(b);
  }

  function cSqrTo(a, b) {
    a.squareTo(b);
    this.reduce(b);
  }
  Classic.prototype.convert = cConvert;
  Classic.prototype.revert = cRevert;
  Classic.prototype.reduce = cReduce;
  Classic.prototype.mulTo = cMulTo;
  Classic.prototype.sqrTo = cSqrTo;

  function bnpInvDigit() {
    if (this.t < 1) {
      return 0;
    }
    var a = this[0];
    if ((a & 1) == 0) {
      return 0;
    }
    var b = a & 3;
    b = (b * (2 - (a & 15) * b)) & 15;
    b = (b * (2 - (a & 255) * b)) & 255;
    b = (b * (2 - (((a & 65535) * b) & 65535))) & 65535;
    b = (b * (2 - ((a * b) % this.DV))) % this.DV;
    return b > 0 ? this.DV - b : -b;
  }

  function Montgomery(a) {
    this.m = a;
    this.mp = a.invDigit();
    this.mpl = this.mp & 32767;
    this.mph = this.mp >> 15;
    this.um = (1 << (a.DB - 15)) - 1;
    this.mt2 = 2 * a.t;
  }

  function montConvert(a) {
    var b = nbi();
    a.abs().dlShiftTo(this.m.t, b);
    b.divRemTo(this.m, null, b);
    if (a.s < 0 && b.compareTo(BigInteger.ZERO) > 0) {
      this.m.subTo(b, b);
    }
    return b;
  }

  function montRevert(a) {
    var b = nbi();
    a.copyTo(b);
    this.reduce(b);
    return b;
  }

  function montReduce(a) {
    while (a.t <= this.mt2) {
      a[a.t++] = 0;
    }
    for (var c = 0; c < this.m.t; ++c) {
      var b = a[c] & 32767;
      var d =
        (b * this.mpl +
          (((b * this.mph + (a[c] >> 15) * this.mpl) & this.um) << 15)) &
        a.DM;
      b = c + this.m.t;
      a[b] += this.m.am(0, d, a, c, 0, this.m.t);
      while (a[b] >= a.DV) {
        a[b] -= a.DV;
        a[++b]++;
      }
    }
    a.clamp();
    a.drShiftTo(this.m.t, a);
    if (a.compareTo(this.m) >= 0) {
      a.subTo(this.m, a);
    }
  }

  function montSqrTo(a, b) {
    a.squareTo(b);
    this.reduce(b);
  }

  function montMulTo(a, c, b) {
    a.multiplyTo(c, b);
    this.reduce(b);
  }
  Montgomery.prototype.convert = montConvert;
  Montgomery.prototype.revert = montRevert;
  Montgomery.prototype.reduce = montReduce;
  Montgomery.prototype.mulTo = montMulTo;
  Montgomery.prototype.sqrTo = montSqrTo;

  function bnpIsEven() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
  }

  function bnpExp(h, j) {
    if (h > 4294967295 || h < 1) {
      return BigInteger.ONE;
    }
    var f = nbi(),
      a = nbi(),
      d = j.convert(this),
      c = nbits(h) - 1;
    d.copyTo(f);
    while (--c >= 0) {
      j.sqrTo(f, a);
      if ((h & (1 << c)) > 0) {
        j.mulTo(a, d, f);
      } else {
        var b = f;
        f = a;
        a = b;
      }
    }
    return j.revert(f);
  }

  function bnModPowInt(b, a) {
    var c;
    if (b < 256 || a.isEven()) {
      c = new Classic(a);
    } else {
      c = new Montgomery(a);
    }
    return this.exp(b, c);
  }
  BigInteger.prototype.copyTo = bnpCopyTo;
  BigInteger.prototype.fromInt = bnpFromInt;
  BigInteger.prototype.fromString = bnpFromString;
  BigInteger.prototype.clamp = bnpClamp;
  BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
  BigInteger.prototype.drShiftTo = bnpDRShiftTo;
  BigInteger.prototype.lShiftTo = bnpLShiftTo;
  BigInteger.prototype.rShiftTo = bnpRShiftTo;
  BigInteger.prototype.subTo = bnpSubTo;
  BigInteger.prototype.multiplyTo = bnpMultiplyTo;
  BigInteger.prototype.squareTo = bnpSquareTo;
  BigInteger.prototype.divRemTo = bnpDivRemTo;
  BigInteger.prototype.invDigit = bnpInvDigit;
  BigInteger.prototype.isEven = bnpIsEven;
  BigInteger.prototype.exp = bnpExp;
  BigInteger.prototype.toString = bnToString;
  BigInteger.prototype.negate = bnNegate;
  BigInteger.prototype.abs = bnAbs;
  BigInteger.prototype.compareTo = bnCompareTo;
  BigInteger.prototype.bitLength = bnBitLength;
  BigInteger.prototype.mod = bnMod;
  BigInteger.prototype.modPowInt = bnModPowInt;
  BigInteger.ZERO = nbv(0);
  BigInteger.ONE = nbv(1);

  function bnClone() {
    var a = nbi();
    this.copyTo(a);
    return a;
  }

  function bnIntValue() {
    if (this.s < 0) {
      if (this.t == 1) {
        return this[0] - this.DV;
      } else {
        if (this.t == 0) {
          return -1;
        }
      }
    } else {
      if (this.t == 1) {
        return this[0];
      } else {
        if (this.t == 0) {
          return 0;
        }
      }
    }
    return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
  }

  function bnByteValue() {
    return this.t == 0 ? this.s : (this[0] << 24) >> 24;
  }

  function bnShortValue() {
    return this.t == 0 ? this.s : (this[0] << 16) >> 16;
  }

  function bnpChunkSize(a) {
    return Math.floor((Math.LN2 * this.DB) / Math.log(a));
  }

  function bnSigNum() {
    if (this.s < 0) {
      return -1;
    } else {
      if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
        return 0;
      } else {
        return 1;
      }
    }
  }

  function bnpToRadix(c) {
    if (c == null) {
      c = 10;
    }
    if (this.signum() == 0 || c < 2 || c > 36) {
      return "0";
    }
    var f = this.chunkSize(c);
    var e = Math.pow(c, f);
    var i = nbv(e),
      j = nbi(),
      h = nbi(),
      g = "";
    this.divRemTo(i, j, h);
    while (j.signum() > 0) {
      g = (e + h.intValue()).toString(c).substr(1) + g;
      j.divRemTo(i, j, h);
    }
    return h.intValue().toString(c) + g;
  }

  function bnpFromRadix(m, h) {
    this.fromInt(0);
    if (h == null) {
      h = 10;
    }
    var f = this.chunkSize(h);
    var g = Math.pow(h, f),
      e = false,
      a = 0,
      l = 0;
    for (var c = 0; c < m.length; ++c) {
      var k = intAt(m, c);
      if (k < 0) {
        if (m.charAt(c) == "-" && this.signum() == 0) {
          e = true;
        }
        continue;
      }
      l = h * l + k;
      if (++a >= f) {
        this.dMultiply(g);
        this.dAddOffset(l, 0);
        a = 0;
        l = 0;
      }
    }
    if (a > 0) {
      this.dMultiply(Math.pow(h, a));
      this.dAddOffset(l, 0);
    }
    if (e) {
      BigInteger.ZERO.subTo(this, this);
    }
  }

  function bnpFromNumber(f, e, h) {
    if ("number" == typeof e) {
      if (f < 2) {
        this.fromInt(1);
      } else {
        this.fromNumber(f, h);
        if (!this.testBit(f - 1)) {
          this.bitwiseTo(BigInteger.ONE.shiftLeft(f - 1), op_or, this);
        }
        if (this.isEven()) {
          this.dAddOffset(1, 0);
        }
        while (!this.isProbablePrime(e)) {
          this.dAddOffset(2, 0);
          if (this.bitLength() > f) {
            this.subTo(BigInteger.ONE.shiftLeft(f - 1), this);
          }
        }
      }
    } else {
      var d = new Array(),
        g = f & 7;
      d.length = (f >> 3) + 1;
      e.nextBytes(d);
      if (g > 0) {
        d[0] &= (1 << g) - 1;
      } else {
        d[0] = 0;
      }
      this.fromString(d, 256);
    }
  }

  function bnToByteArray() {
    var b = this.t,
      c = new Array();
    c[0] = this.s;
    var e = this.DB - ((b * this.DB) % 8),
      f,
      a = 0;
    if (b-- > 0) {
      if (e < this.DB && (f = this[b] >> e) != (this.s & this.DM) >> e) {
        c[a++] = f | (this.s << (this.DB - e));
      }
      while (b >= 0) {
        if (e < 8) {
          f = (this[b] & ((1 << e) - 1)) << (8 - e);
          f |= this[--b] >> (e += this.DB - 8);
        } else {
          f = (this[b] >> (e -= 8)) & 255;
          if (e <= 0) {
            e += this.DB;
            --b;
          }
        }
        if ((f & 128) != 0) {
          f |= -256;
        }
        if (a == 0 && (this.s & 128) != (f & 128)) {
          ++a;
        }
        if (a > 0 || f != this.s) {
          c[a++] = f;
        }
      }
    }
    return c;
  }

  function bnEquals(b) {
    return this.compareTo(b) == 0;
  }

  function bnMin(b) {
    return this.compareTo(b) < 0 ? this : b;
  }

  function bnMax(b) {
    return this.compareTo(b) > 0 ? this : b;
  }

  function bnpBitwiseTo(c, h, e) {
    var d,
      g,
      b = Math.min(c.t, this.t);
    for (d = 0; d < b; ++d) {
      e[d] = h(this[d], c[d]);
    }
    if (c.t < this.t) {
      g = c.s & this.DM;
      for (d = b; d < this.t; ++d) {
        e[d] = h(this[d], g);
      }
      e.t = this.t;
    } else {
      g = this.s & this.DM;
      for (d = b; d < c.t; ++d) {
        e[d] = h(g, c[d]);
      }
      e.t = c.t;
    }
    e.s = h(this.s, c.s);
    e.clamp();
  }

  function op_and(a, b) {
    return a & b;
  }

  function bnAnd(b) {
    var c = nbi();
    this.bitwiseTo(b, op_and, c);
    return c;
  }

  function op_or(a, b) {
    return a | b;
  }

  function bnOr(b) {
    var c = nbi();
    this.bitwiseTo(b, op_or, c);
    return c;
  }

  function op_xor(a, b) {
    return a ^ b;
  }

  function bnXor(b) {
    var c = nbi();
    this.bitwiseTo(b, op_xor, c);
    return c;
  }

  function op_andnot(a, b) {
    return a & ~b;
  }

  function bnAndNot(b) {
    var c = nbi();
    this.bitwiseTo(b, op_andnot, c);
    return c;
  }

  function bnNot() {
    var b = nbi();
    for (var a = 0; a < this.t; ++a) {
      b[a] = this.DM & ~this[a];
    }
    b.t = this.t;
    b.s = ~this.s;
    return b;
  }

  function bnShiftLeft(b) {
    var a = nbi();
    if (b < 0) {
      this.rShiftTo(-b, a);
    } else {
      this.lShiftTo(b, a);
    }
    return a;
  }

  function bnShiftRight(b) {
    var a = nbi();
    if (b < 0) {
      this.lShiftTo(-b, a);
    } else {
      this.rShiftTo(b, a);
    }
    return a;
  }

  function lbit(a) {
    if (a == 0) {
      return -1;
    }
    var b = 0;
    if ((a & 65535) == 0) {
      a >>= 16;
      b += 16;
    }
    if ((a & 255) == 0) {
      a >>= 8;
      b += 8;
    }
    if ((a & 15) == 0) {
      a >>= 4;
      b += 4;
    }
    if ((a & 3) == 0) {
      a >>= 2;
      b += 2;
    }
    if ((a & 1) == 0) {
      ++b;
    }
    return b;
  }

  function bnGetLowestSetBit() {
    for (var a = 0; a < this.t; ++a) {
      if (this[a] != 0) {
        return a * this.DB + lbit(this[a]);
      }
    }
    if (this.s < 0) {
      return this.t * this.DB;
    }
    return -1;
  }

  function cbit(a) {
    var b = 0;
    while (a != 0) {
      a &= a - 1;
      ++b;
    }
    return b;
  }

  function bnBitCount() {
    var c = 0,
      a = this.s & this.DM;
    for (var b = 0; b < this.t; ++b) {
      c += cbit(this[b] ^ a);
    }
    return c;
  }

  function bnTestBit(b) {
    var a = Math.floor(b / this.DB);
    if (a >= this.t) {
      return this.s != 0;
    }
    return (this[a] & (1 << b % this.DB)) != 0;
  }

  function bnpChangeBit(c, b) {
    var a = BigInteger.ONE.shiftLeft(c);
    this.bitwiseTo(a, b, a);
    return a;
  }

  function bnSetBit(a) {
    return this.changeBit(a, op_or);
  }

  function bnClearBit(a) {
    return this.changeBit(a, op_andnot);
  }

  function bnFlipBit(a) {
    return this.changeBit(a, op_xor);
  }

  function bnpAddTo(d, f) {
    var e = 0,
      g = 0,
      b = Math.min(d.t, this.t);
    while (e < b) {
      g += this[e] + d[e];
      f[e++] = g & this.DM;
      g >>= this.DB;
    }
    if (d.t < this.t) {
      g += d.s;
      while (e < this.t) {
        g += this[e];
        f[e++] = g & this.DM;
        g >>= this.DB;
      }
      g += this.s;
    } else {
      g += this.s;
      while (e < d.t) {
        g += d[e];
        f[e++] = g & this.DM;
        g >>= this.DB;
      }
      g += d.s;
    }
    f.s = g < 0 ? -1 : 0;
    if (g > 0) {
      f[e++] = g;
    } else {
      if (g < -1) {
        f[e++] = this.DV + g;
      }
    }
    f.t = e;
    f.clamp();
  }

  function bnAdd(b) {
    var c = nbi();
    this.addTo(b, c);
    return c;
  }

  function bnSubtract(b) {
    var c = nbi();
    this.subTo(b, c);
    return c;
  }

  function bnMultiply(b) {
    var c = nbi();
    this.multiplyTo(b, c);
    return c;
  }

  function bnDivide(b) {
    var c = nbi();
    this.divRemTo(b, c, null);
    return c;
  }

  function bnRemainder(b) {
    var c = nbi();
    this.divRemTo(b, null, c);
    return c;
  }

  function bnDivideAndRemainder(b) {
    var d = nbi(),
      c = nbi();
    this.divRemTo(b, d, c);
    return new Array(d, c);
  }

  function bnpDMultiply(a) {
    this[this.t] = this.am(0, a - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
  }

  function bnpDAddOffset(b, a) {
    while (this.t <= a) {
      this[this.t++] = 0;
    }
    this[a] += b;
    while (this[a] >= this.DV) {
      this[a] -= this.DV;
      if (++a >= this.t) {
        this[this.t++] = 0;
      }
      ++this[a];
    }
  }

  function NullExp() {}

  function nNop(a) {
    return a;
  }

  function nMulTo(a, c, b) {
    a.multiplyTo(c, b);
  }

  function nSqrTo(a, b) {
    a.squareTo(b);
  }
  NullExp.prototype.convert = nNop;
  NullExp.prototype.revert = nNop;
  NullExp.prototype.mulTo = nMulTo;
  NullExp.prototype.sqrTo = nSqrTo;

  function bnPow(a) {
    return this.exp(a, new NullExp());
  }

  function bnpMultiplyLowerTo(b, f, e) {
    var d = Math.min(this.t + b.t, f);
    e.s = 0;
    e.t = d;
    while (d > 0) {
      e[--d] = 0;
    }
    var c;
    for (c = e.t - this.t; d < c; ++d) {
      e[d + this.t] = this.am(0, b[d], e, d, 0, this.t);
    }
    for (c = Math.min(b.t, f); d < c; ++d) {
      this.am(0, b[d], e, d, 0, f - d);
    }
    e.clamp();
  }

  function bnpMultiplyUpperTo(b, e, d) {
    --e;
    var c = (d.t = this.t + b.t - e);
    d.s = 0;
    while (--c >= 0) {
      d[c] = 0;
    }
    for (c = Math.max(e - this.t, 0); c < b.t; ++c) {
      d[this.t + c - e] = this.am(e - c, b[c], d, 0, 0, this.t + c - e);
    }
    d.clamp();
    d.drShiftTo(1, d);
  }

  function Barrett(a) {
    this.r2 = nbi();
    this.q3 = nbi();
    BigInteger.ONE.dlShiftTo(2 * a.t, this.r2);
    this.mu = this.r2.divide(a);
    this.m = a;
  }

  function barrettConvert(a) {
    if (a.s < 0 || a.t > 2 * this.m.t) {
      return a.mod(this.m);
    } else {
      if (a.compareTo(this.m) < 0) {
        return a;
      } else {
        var b = nbi();
        a.copyTo(b);
        this.reduce(b);
        return b;
      }
    }
  }

  function barrettRevert(a) {
    return a;
  }

  function barrettReduce(a) {
    a.drShiftTo(this.m.t - 1, this.r2);
    if (a.t > this.m.t + 1) {
      a.t = this.m.t + 1;
      a.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while (a.compareTo(this.r2) < 0) {
      a.dAddOffset(1, this.m.t + 1);
    }
    a.subTo(this.r2, a);
    while (a.compareTo(this.m) >= 0) {
      a.subTo(this.m, a);
    }
  }

  function barrettSqrTo(a, b) {
    a.squareTo(b);
    this.reduce(b);
  }

  function barrettMulTo(a, c, b) {
    a.multiplyTo(c, b);
    this.reduce(b);
  }
  Barrett.prototype.convert = barrettConvert;
  Barrett.prototype.revert = barrettRevert;
  Barrett.prototype.reduce = barrettReduce;
  Barrett.prototype.mulTo = barrettMulTo;
  Barrett.prototype.sqrTo = barrettSqrTo;

  function bnModPow(q, f) {
    var o = q.bitLength(),
      h,
      b = nbv(1),
      v;
    if (o <= 0) {
      return b;
    } else {
      if (o < 18) {
        h = 1;
      } else {
        if (o < 48) {
          h = 3;
        } else {
          if (o < 144) {
            h = 4;
          } else {
            if (o < 768) {
              h = 5;
            } else {
              h = 6;
            }
          }
        }
      }
    }
    if (o < 8) {
      v = new Classic(f);
    } else {
      if (f.isEven()) {
        v = new Barrett(f);
      } else {
        v = new Montgomery(f);
      }
    }
    var p = new Array(),
      d = 3,
      s = h - 1,
      a = (1 << h) - 1;
    p[1] = v.convert(this);
    if (h > 1) {
      var A = nbi();
      v.sqrTo(p[1], A);
      while (d <= a) {
        p[d] = nbi();
        v.mulTo(A, p[d - 2], p[d]);
        d += 2;
      }
    }
    var l = q.t - 1,
      x,
      u = true,
      c = nbi(),
      y;
    o = nbits(q[l]) - 1;
    while (l >= 0) {
      if (o >= s) {
        x = (q[l] >> (o - s)) & a;
      } else {
        x = (q[l] & ((1 << (o + 1)) - 1)) << (s - o);
        if (l > 0) {
          x |= q[l - 1] >> (this.DB + o - s);
        }
      }
      d = h;
      while ((x & 1) == 0) {
        x >>= 1;
        --d;
      }
      if ((o -= d) < 0) {
        o += this.DB;
        --l;
      }
      if (u) {
        p[x].copyTo(b);
        u = false;
      } else {
        while (d > 1) {
          v.sqrTo(b, c);
          v.sqrTo(c, b);
          d -= 2;
        }
        if (d > 0) {
          v.sqrTo(b, c);
        } else {
          y = b;
          b = c;
          c = y;
        }
        v.mulTo(c, p[x], b);
      }
      while (l >= 0 && (q[l] & (1 << o)) == 0) {
        v.sqrTo(b, c);
        y = b;
        b = c;
        c = y;
        if (--o < 0) {
          o = this.DB - 1;
          --l;
        }
      }
    }
    return v.revert(b);
  }

  function bnGCD(c) {
    var b = this.s < 0 ? this.negate() : this.clone();
    var h = c.s < 0 ? c.negate() : c.clone();
    if (b.compareTo(h) < 0) {
      var e = b;
      b = h;
      h = e;
    }
    var d = b.getLowestSetBit(),
      f = h.getLowestSetBit();
    if (f < 0) {
      return b;
    }
    if (d < f) {
      f = d;
    }
    if (f > 0) {
      b.rShiftTo(f, b);
      h.rShiftTo(f, h);
    }
    while (b.signum() > 0) {
      if ((d = b.getLowestSetBit()) > 0) {
        b.rShiftTo(d, b);
      }
      if ((d = h.getLowestSetBit()) > 0) {
        h.rShiftTo(d, h);
      }
      if (b.compareTo(h) >= 0) {
        b.subTo(h, b);
        b.rShiftTo(1, b);
      } else {
        h.subTo(b, h);
        h.rShiftTo(1, h);
      }
    }
    if (f > 0) {
      h.lShiftTo(f, h);
    }
    return h;
  }

  function bnpModInt(e) {
    if (e <= 0) {
      return 0;
    }
    var c = this.DV % e,
      b = this.s < 0 ? e - 1 : 0;
    if (this.t > 0) {
      if (c == 0) {
        b = this[0] % e;
      } else {
        for (var a = this.t - 1; a >= 0; --a) {
          b = (c * b + this[a]) % e;
        }
      }
    }
    return b;
  }

  function bnModInverse(f) {
    var j = f.isEven();
    if ((this.isEven() && j) || f.signum() == 0) {
      return BigInteger.ZERO;
    }
    var i = f.clone(),
      h = this.clone();
    var g = nbv(1),
      e = nbv(0),
      l = nbv(0),
      k = nbv(1);
    while (i.signum() != 0) {
      while (i.isEven()) {
        i.rShiftTo(1, i);
        if (j) {
          if (!g.isEven() || !e.isEven()) {
            g.addTo(this, g);
            e.subTo(f, e);
          }
          g.rShiftTo(1, g);
        } else {
          if (!e.isEven()) {
            e.subTo(f, e);
          }
        }
        e.rShiftTo(1, e);
      }
      while (h.isEven()) {
        h.rShiftTo(1, h);
        if (j) {
          if (!l.isEven() || !k.isEven()) {
            l.addTo(this, l);
            k.subTo(f, k);
          }
          l.rShiftTo(1, l);
        } else {
          if (!k.isEven()) {
            k.subTo(f, k);
          }
        }
        k.rShiftTo(1, k);
      }
      if (i.compareTo(h) >= 0) {
        i.subTo(h, i);
        if (j) {
          g.subTo(l, g);
        }
        e.subTo(k, e);
      } else {
        h.subTo(i, h);
        if (j) {
          l.subTo(g, l);
        }
        k.subTo(e, k);
      }
    }
    if (h.compareTo(BigInteger.ONE) != 0) {
      return BigInteger.ZERO;
    }
    if (k.compareTo(f) >= 0) {
      return k.subtract(f);
    }
    if (k.signum() < 0) {
      k.addTo(f, k);
    } else {
      return k;
    }
    if (k.signum() < 0) {
      return k.add(f);
    } else {
      return k;
    }
  }
  var lowprimes = [
    2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71,
    73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151,
    157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233,
    239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317,
    331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419,
    421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503,
    509,
  ];
  var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];

  function bnIsProbablePrime(e) {
    var d,
      b = this.abs();
    if (b.t == 1 && b[0] <= lowprimes[lowprimes.length - 1]) {
      for (d = 0; d < lowprimes.length; ++d) {
        if (b[0] == lowprimes[d]) {
          return true;
        }
      }
      return false;
    }
    if (b.isEven()) {
      return false;
    }
    d = 1;
    while (d < lowprimes.length) {
      var a = lowprimes[d],
        c = d + 1;
      while (c < lowprimes.length && a < lplim) {
        a *= lowprimes[c++];
      }
      a = b.modInt(a);
      while (d < c) {
        if (a % lowprimes[d++] == 0) {
          return false;
        }
      }
    }
    return b.millerRabin(e);
  }

  function bnpMillerRabin(f) {
    var g = this.subtract(BigInteger.ONE);
    var c = g.getLowestSetBit();
    if (c <= 0) {
      return false;
    }
    var h = g.shiftRight(c);
    f = (f + 1) >> 1;
    if (f > lowprimes.length) {
      f = lowprimes.length;
    }
    var b = nbi();
    for (var e = 0; e < f; ++e) {
      b.fromInt(lowprimes[e]);
      var l = b.modPow(h, this);
      if (l.compareTo(BigInteger.ONE) != 0 && l.compareTo(g) != 0) {
        var d = 1;
        while (d++ < c && l.compareTo(g) != 0) {
          l = l.modPowInt(2, this);
          if (l.compareTo(BigInteger.ONE) == 0) {
            return false;
          }
        }
        if (l.compareTo(g) != 0) {
          return false;
        }
      }
    }
    return true;
  }
  BigInteger.prototype.chunkSize = bnpChunkSize;
  BigInteger.prototype.toRadix = bnpToRadix;
  BigInteger.prototype.fromRadix = bnpFromRadix;
  BigInteger.prototype.fromNumber = bnpFromNumber;
  BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
  BigInteger.prototype.changeBit = bnpChangeBit;
  BigInteger.prototype.addTo = bnpAddTo;
  BigInteger.prototype.dMultiply = bnpDMultiply;
  BigInteger.prototype.dAddOffset = bnpDAddOffset;
  BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
  BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
  BigInteger.prototype.modInt = bnpModInt;
  BigInteger.prototype.millerRabin = bnpMillerRabin;
  BigInteger.prototype.clone = bnClone;
  BigInteger.prototype.intValue = bnIntValue;
  BigInteger.prototype.byteValue = bnByteValue;
  BigInteger.prototype.shortValue = bnShortValue;
  BigInteger.prototype.signum = bnSigNum;
  BigInteger.prototype.toByteArray = bnToByteArray;
  BigInteger.prototype.equals = bnEquals;
  BigInteger.prototype.min = bnMin;
  BigInteger.prototype.max = bnMax;
  BigInteger.prototype.and = bnAnd;
  BigInteger.prototype.or = bnOr;
  BigInteger.prototype.xor = bnXor;
  BigInteger.prototype.andNot = bnAndNot;
  BigInteger.prototype.not = bnNot;
  BigInteger.prototype.shiftLeft = bnShiftLeft;
  BigInteger.prototype.shiftRight = bnShiftRight;
  BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
  BigInteger.prototype.bitCount = bnBitCount;
  BigInteger.prototype.testBit = bnTestBit;
  BigInteger.prototype.setBit = bnSetBit;
  BigInteger.prototype.clearBit = bnClearBit;
  BigInteger.prototype.flipBit = bnFlipBit;
  BigInteger.prototype.add = bnAdd;
  BigInteger.prototype.subtract = bnSubtract;
  BigInteger.prototype.multiply = bnMultiply;
  BigInteger.prototype.divide = bnDivide;
  BigInteger.prototype.remainder = bnRemainder;
  BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
  BigInteger.prototype.modPow = bnModPow;
  BigInteger.prototype.modInverse = bnModInverse;
  BigInteger.prototype.pow = bnPow;
  BigInteger.prototype.gcd = bnGCD;
  BigInteger.prototype.isProbablePrime = bnIsProbablePrime;

  function SecureRandom() {
    this.rng_state;
    this.rng_pool;
    this.rng_pptr;
    this.rng_seed_int = function (c) {
      this.rng_pool[this.rng_pptr++] ^= c & 255;
      this.rng_pool[this.rng_pptr++] ^= (c >> 8) & 255;
      this.rng_pool[this.rng_pptr++] ^= (c >> 16) & 255;
      this.rng_pool[this.rng_pptr++] ^= (c >> 24) & 255;
      if (this.rng_pptr >= rng_psize) {
        this.rng_pptr -= rng_psize;
      }
    };
    this.rng_seed_time = function () {
      this.rng_seed_int(new Date().getTime());
    };
    if (this.rng_pool == null) {
      this.rng_pool = new Array();
      this.rng_pptr = 0;
      var a;
      if (
        navigator.appName == "Netscape" &&
        navigator.appVersion < "5" &&
        window.crypto
      ) {
        var b = window.crypto.random(32);
        for (a = 0; a < b.length; ++a) {
          this.rng_pool[this.rng_pptr++] = b.charCodeAt(a) & 255;
        }
      }
      while (this.rng_pptr < rng_psize) {
        a = Math.floor(65536 * Math.random());
        this.rng_pool[this.rng_pptr++] = a >>> 8;
        this.rng_pool[this.rng_pptr++] = a & 255;
      }
      this.rng_pptr = 0;
      this.rng_seed_time();
    }
    this.rng_get_byte = function () {
      if (this.rng_state == null) {
        this.rng_seed_time();
        this.rng_state = prng_newstate();
        this.rng_state.init(this.rng_pool);
        for (
          this.rng_pptr = 0;
          this.rng_pptr < this.rng_pool.length;
          ++this.rng_pptr
        ) {
          this.rng_pool[this.rng_pptr] = 0;
        }
        this.rng_pptr = 0;
      }
      return this.rng_state.next();
    };
    this.nextBytes = function (d) {
      var c;
      for (c = 0; c < d.length; ++c) {
        d[c] = this.rng_get_byte();
      }
    };
  }

  function Arcfour() {
    this.i = 0;
    this.j = 0;
    this.S = new Array();
  }

  function ARC4init(d) {
    var c, a, b;
    for (c = 0; c < 256; ++c) {
      this.S[c] = c;
    }
    a = 0;
    for (c = 0; c < 256; ++c) {
      a = (a + this.S[c] + d[c % d.length]) & 255;
      b = this.S[c];
      this.S[c] = this.S[a];
      this.S[a] = b;
    }
    this.i = 0;
    this.j = 0;
  }

  function ARC4next() {
    var a;
    this.i = (this.i + 1) & 255;
    this.j = (this.j + this.S[this.i]) & 255;
    a = this.S[this.i];
    this.S[this.i] = this.S[this.j];
    this.S[this.j] = a;
    return this.S[(a + this.S[this.i]) & 255];
  }
  Arcfour.prototype.init = ARC4init;
  Arcfour.prototype.next = ARC4next;

  function prng_newstate() {
    return new Arcfour();
  }
  var rng_psize = 256;
  if (
    typeof cgjsCrypt != "undefined" &&
    typeof BigInteger != "undefined" &&
    typeof SecureRandom != "undefined" &&
    typeof Arcfour != "undefined"
  ) {
    function parseBigInt(b, a) {
      return new BigInteger(b, a);
    }

    function linebrk(c, d) {
      var a = "";
      var b = 0;
      while (b + d < c.length) {
        a += c.substring(b, b + d) + "\n";
        b += d;
      }
      return a + c.substring(b, c.length);
    }

    function byte2Hex(a) {
      if (a < 16) {
        return "0" + a.toString(16);
      } else {
        return a.toString(16);
      }
    }

    function pkcs1unpad2(f, g) {
      var a = f.toByteArray();
      var e = 0;
      while (e < a.length && a[e] == 0) {
        ++e;
      }
      if (a.length - e != g - 1 || a[e] != 2) {
        return null;
      }
      ++e;
      while (a[e] != 0) {
        if (++e >= a.length) {
          return null;
        }
      }
      var c = "";
      while (++e < a.length) {
        c += String.fromCharCode(a[e]);
      }
      return c;
    }

    function pkcs1pad2(d, f) {
      if (f < d.length + 11) {
        alert("Message too long for RSA");
        return null;
      }
      var e = new Array();
      var c = d.length - 1;
      while (c >= 0 && f > 0) {
        e[--f] = d.charCodeAt(c--);
      }
      e[--f] = 0;
      var b = new SecureRandom();
      var a = new Array();
      while (f > 2) {
        a[0] = 0;
        while (a[0] == 0) {
          b.nextBytes(a);
        }
        e[--f] = a[0];
      }
      e[--f] = 2;
      e[--f] = 0;
      return new BigInteger(e);
    }
    cgjsCrypt.RSA = function () {
      this.n = null;
      this.e = 0;
      this.d = null;
      this.p = null;
      this.q = null;
      this.dmp1 = null;
      this.dmq1 = null;
      this.coeff = null;
    };
    cgjsCrypt.RSA.prototype.doPrivate = function (a) {
      if (this.p == null || this.q == null) {
        return a.modPow(this.d, this.n);
      }
      var c = a.mod(this.p).modPow(this.dmp1, this.p);
      var b = a.mod(this.q).modPow(this.dmq1, this.q);
      while (c.compareTo(b) < 0) {
        c = c.add(this.p);
      }
      return c
        .subtract(b)
        .multiply(this.coeff)
        .mod(this.p)
        .multiply(this.q)
        .add(b);
    };
    cgjsCrypt.RSA.prototype.setPublic = function (c, b, a) {
      if (typeof a == "undefined") {
        a = 16;
      }
      if (c != null && b != null && c.length > 0 && b.length > 0) {
        this.n = parseBigInt(c, a);
        this.e = parseInt(b, a);
      } else {
        alert("Invalid RSA public key");
      }
    };
    cgjsCrypt.RSA.prototype.doPublic = function (a) {
      return a.modPowInt(this.e, this.n);
    };
    cgjsCrypt.RSA.prototype.encryptRaw = function (d) {
      var a = pkcs1pad2(d, (this.n.bitLength() + 7) >> 3);
      if (a == null) {
        return null;
      }
      var e = this.doPublic(a);
      if (e == null) {
        return null;
      }
      var b = e.toString(16);
      if ((b.length & 1) == 0) {
        return b;
      } else {
        return "0" + b;
      }
    };
    cgjsCrypt.RSA.prototype.encrypt = function (a) {
      return this.encryptRaw(a);
    };
    cgjsCrypt.RSA.prototype.decryptRaw = function (b) {
      var d = parseBigInt(b, 16);
      var a = this.doPrivate(d);
      if (a == null) {
        return null;
      }
      return pkcs1unpad2(a, (this.n.bitLength() + 7) >> 3);
    };
    cgjsCrypt.RSA.prototype.decrypt = function (b) {
      var a = this.decryptRaw(b);
      a = a ? cgjsCryptUtil.decodeBase64(a) : "";
      return a;
    };
    cgjsCrypt.RSA.prototype.setPrivate = function (d, b, c, a) {
      if (typeof a == "undefined") {
        a = 16;
      }
      if (d != null && b != null && d.length > 0 && b.length > 0) {
        this.n = parseBigInt(d, a);
        this.e = parseInt(b, a);
        this.d = parseBigInt(c, a);
      } else {
        alert("Invalid RSA private key");
      }
    };
    cgjsCrypt.RSA.prototype.setPrivateEx = function (
      e,
      i,
      a,
      d,
      c,
      h,
      g,
      b,
      f
    ) {
      if (typeof f == "undefined") {
        f = 16;
      }
      if (e != null && i != null && e.length > 0 && i.length > 0) {
        this.n = parseBigInt(e, f);
        this.e = parseInt(i, f);
        this.d = parseBigInt(a, f);
        this.p = parseBigInt(d, f);
        this.q = parseBigInt(c, f);
        this.dmp1 = parseBigInt(h, f);
        this.dmq1 = parseBigInt(g, f);
        this.coeff = parseBigInt(b, f);
      } else {
        alert("Invalid RSA private key");
      }
    };
    cgjsCrypt.RSA.prototype.generate = function (b, i) {
      var a = new SecureRandom();
      var f = b >> 1;
      this.e = parseInt(i, 16);
      var c = new BigInteger(i, 16);
      for (;;) {
        for (;;) {
          this.p = new BigInteger(b - f, 1, a);
          if (
            this.p.subtract(BigInteger.ONE).gcd(c).compareTo(BigInteger.ONE) ==
              0 &&
            this.p.isProbablePrime(10)
          ) {
            break;
          }
        }
        for (;;) {
          this.q = new BigInteger(f, 1, a);
          if (
            this.q.subtract(BigInteger.ONE).gcd(c).compareTo(BigInteger.ONE) ==
              0 &&
            this.q.isProbablePrime(10)
          ) {
            break;
          }
        }
        if (this.p.compareTo(this.q) <= 0) {
          var h = this.p;
          this.p = this.q;
          this.q = h;
        }
        var g = this.p.subtract(BigInteger.ONE);
        var d = this.q.subtract(BigInteger.ONE);
        var e = g.multiply(d);
        if (e.gcd(c).compareTo(BigInteger.ONE) == 0) {
          this.n = this.p.multiply(this.q);
          this.d = c.modInverse(e);
          this.dmp1 = this.d.mod(g);
          this.dmq1 = this.d.mod(d);
          this.coeff = this.q.modInverse(this.p);
          break;
        }
      }
    };
    cgjsCrypt.RSA.prototype.getASNData = function (a) {
      var e = {};
      var c = [];
      var d = 0;
      if (a.value && a.type == "INTEGER") {
        c[d++] = a.value;
      }
      if (a.sub) {
        for (var b = 0; b < a.sub.length; b++) {
          c = c.concat(this.getASNData(a.sub[b]));
        }
      }
      return c;
    };
    cgjsCrypt.RSA.prototype.setKeyFromASN = function (c, e) {
      var d = ["N", "E", "D", "P", "Q", "DP", "DQ", "C"];
      var f = {};
      var a = this.getASNData(e);
      switch (c) {
        case "Public":
        case "public":
          for (var b = 0; b < a.length; b++) {
            f[d[b]] = a[b].toLowerCase();
          }
          this.setPublic(f.N, f.E, 16);
          break;
        case "Private":
        case "private":
          for (var b = 1; b < a.length; b++) {
            f[d[b - 1]] = a[b].toLowerCase();
          }
          this.setPrivateEx(f.N, f.E, f.D, f.P, f.Q, f.DP, f.DQ, f.C, 16);
          break;
      }
    };
    cgjsCrypt.RSA.prototype.setPublicKeyFromASN = function (a) {
      this.setKeyFromASN("public", a);
    };
    cgjsCrypt.RSA.prototype.setPrivateKeyFromASN = function (a) {
      this.setKeyFromASN("private", a);
    };
    cgjsCrypt.RSA.prototype.getParameters = function () {
      var a = {};
      if (this.n != null) {
        a.n = this.n;
      }
      a.e = this.e;
      if (this.d != null) {
        a.d = this.d;
      }
      if (this.p != null) {
        a.p = this.p;
      }
      if (this.q != null) {
        a.q = this.q;
      }
      if (this.dmp1 != null) {
        a.dmp1 = this.dmp1;
      }
      if (this.dmq1 != null) {
        a.dmq1 = this.dmq1;
      }
      if (this.coeff != null) {
        a.c = this.coeff;
      }
      return a;
    };
  }

  function certParser(f) {
    var l = f.split("\n");
    var a = false;
    var b = false;
    var c = false;
    var h = "";
    var d = {};
    d.info = "";
    d.salt = "";
    d.iv;
    d.b64 = "";
    d.aes = false;
    d.mode = "";
    d.bits = 0;
    for (var g = 0; g < l.length; g++) {
      h = l[g].substr(0, 9);
      if (g == 1 && h != "Proc-Type" && h.indexOf("M") == 0) {
        b = true;
      }
      switch (h) {
        case "-----BEGI":
          a = true;
          break;
        case "Proc-Type":
          if (a) {
            d.info = l[g];
          }
          break;
        case "DEK-Info:":
          if (a) {
            var e = l[g].split(",");
            var k = e[0].split(": ");
            var j = k[1].split("-");
            d.aes = j[0] == "AES" ? true : false;
            d.mode = j[2];
            d.bits = parseInt(j[1]);
            d.salt = e[1].substr(0, 16);
            d.iv = e[1];
          }
          break;
        case "":
          if (a) {
            b = true;
          }
          break;
        case "-----END ":
          if (a) {
            b = false;
            a = false;
          }
          break;
        default:
          if (a && b) {
            d.b64 += cgjsCryptUtil.stripLineFeeds(l[g]);
          }
      }
    }
    return d;
  }
  cgjsCrypt.CertEncrypt = function (a, h, e) {
    var c = {};
    var l = "";
    var d = "";
    var g = "";
    c = certParser(a);
    if (c.b64) {
      var i = cgjsCryptUtil.decodeBase64(c.b64);
      var f = new cgjsCrypt.RSA();
      var b = cgjsCrypt.ASN1.decode(cgjsCryptUtil.toByteArray(i));
      var k = b.toHexTree();
      f.setPublicKeyFromASN(k);
      var j = new Date();
      g = f.encrypt(h);
      g = cgjsCryptUtil.fragment(
        cgjsCryptUtil.encodeBase64(cgjsCryptUtil.convertFromHex(g)),
        64
      );
    } else {
      alert("Could not find public key.");
    }
    return g;
  };

  return cgjsCrypt;
})($);

// 瀏覽器環境中，將 PswModule 設置為全域變數
if (typeof window !== "undefined") {
  window.cgjsCryptModule = cgjsCryptModule;
}

// Node.js 環境中，使用 module.exports
if (typeof module !== "undefined" && module.exports) {
  module.exports = cgjsCryptModule;
}

var PswModule = (function ($) {
  function pswValidate(psw) {
    if (!testSymbols(psw)) {
      return false;
    }

    if (!testLength(psw)) {
      return false;
    }

    if (testIdentical(psw)) {
      return false;
    }

    if (testConsecutive(psw)) {
      return false;
    }

    return true;
  }

  function testSymbols(psw) {
    var reg = /^[A-Za-z0-9]+$/;

    return reg.test(psw);
  }

  function testLength(psw) {
   var  reg = /^([\w]){6,10}$/;

    return reg.test(psw);
  }

  function testIdentical(psw) {
    var reg = /(.)\1{5,}/;

    return reg.test(psw);
  }

  function testConsecutive(psw) {
    var count = 1;

    var lastCharCode = 0;

    var currentCharCode = 0;

    var flag = false;

    for (var i = 0; i < psw.length; i++) {
      currentCharCode = psw.charCodeAt(i);

      if (currentCharCode - lastCharCode == 1) {
        count++;

        if (count == 6) {
          flag = true;

          return flag;
        }
      } else {
        count = 1;
      }

      lastCharCode = currentCharCode;
    }

    return flag;
  }

  //===================================以上的程式，為全景提供

  return {
    pswValidate: function (value) {
      return pswValidate(value);
    },
  };
})($);

// 瀏覽器環境中，將 PswModule 設置為全域變數
if (typeof window !== "undefined") {
  window.PswModule = PswModule;
}

// Node.js 環境中，使用 module.exports
if (typeof module !== "undefined" && module.exports) {
  module.exports = PswModule;
}

var ESBXMLP11AdapterModule = (function ($) {

	var ServiSignErrorCode = 61001;
	
	String.prototype.replaceAll = function(search, replacement) {
		var target = this;
		return target.split(search).join(replacement);
	};
	
	function getESBXMLP11AdapterObj() {
		
		//如有任何參數問題，請參考第 10, 11點
		//https://redmine.changingtec.com/redmine/projects/servisign/wiki/%E5%95%8F%E9%A1%8C%E8%88%87%E8%A7%A3%E7%AD%94
	
		//最低 ServiSign 版本 0.0.0.0 = 預設不開啟
		var minServiSignVersion = "0.0.0.0"
		//最低元件版本 0.0.0.0 = 預設不開啟
		var minLibVersion = "0.0.0.0"
	
		//底層元件 Adapter 名稱
		var LibName = ""
		//底層元件 Adapter 所在位置
		var LibDir = ""
		//Path ID
		var PathID = "C9D09E4822CD4CFD8820D9CC5172EAAA"
	
		//最低不需更新安裝包版本
		var MinimalInstallerVersion = ""
		var MinimalInstallerVersion_Mac = "1.0.20.0622"
		var MinimalInstallerVersion_Linux = ""
		//JS 模板版本號 ServiSign 主程式會做相容性版本確認
		var JSVersion = "1.0.20.0622"
	
		//Tab 以分頁做為轉換模式，行為模式與 ActiveX 元件相同
		var ServiSignTabMode_Tab = 			0x0
		//Browser 模式則是以瀏覽器為單位，整個瀏覽器關掉才會釋放元件
		var ServiSignTabMode_Browser = 		0x1
	
		var ServiSignTabMode = ServiSignTabMode_Tab
	
		//預設不使用 cookie 儲存 Try port 的結果
		var useCookieTryPort = false
		
		//路徑保護
		//DataObj.pfxpath_servisignflag = true;
		//DataObj.pfxpath = pfxpath.replace(/\\/g, "*");
		
		//開啟元件 UI 置頂功能
		//DataObj.topuidetect = true;
		//開啟全系統 UI 置頂功能
		//DataObj.topuialldetect = true;
		//開啟非同步功能
		//DataObj.asynchronously = true;
		
		//資料斜線保護功能
		//DataObj.XXXXX_ServiSignSlashFlag = true;
		//DataObj.XXXXX = inputXXXXXX.replaceAll("\\", "==ServiSignSlash==");
		//資料 Base64 保護功能
		//DataObj.XXXXX_ServiSignBase64Flag = true;
		//DataObj.XXXXX = Base64Encode(XXXXX);
		//使用主線程呼叫 API
		//DataObj.ServiSignMainThread = true;
		
		function ServiSignConnectError() {
			//ServiSign_RTN_CONNECTION_ERROR
			ServiSignErrorCode = 61006
		}
		function ServiSignLoadComponentError() {
			//Handing load component error
		}
		function ServiSignDisconnectError() {
			//Handing disconnect error
			ServiSignErrorCode = 61015
		}
		
		var VersionCompare_Error = 			0x00
		var VersionCompare_Bigger =			0x01
		var VersionCompare_Smaller = 		0x02
		var VersionCompare_Same = 			0x03
	
		function ServiSignLog(LogMessage) {
			console.log("[ServiSign Log] " + LogMessage)
		}
		function Sleep(milliseconds) {
			var start = new Date().getTime()
			for (var i = 0; i < 1e7; i++) {
				if ((new Date().getTime() - start) > milliseconds){
					break
				}
			}
		}
		function Base64Encode(input) {
			return encodeURIComponent(window.btoa(unescape(encodeURIComponent(input))))
		}
		function Base64Decode(input) {
			if(input == undefined) return ""
			return decodeURIComponent(escape(window.atob(input)))
		}
		function FixArray(inputArray) {
			ServiSignLog("FixArray: " + inputArray)
			var array = inputArray.split(";")
	
			// while(array.indexOf("") != -1){
			// 	var EmptyIndex = array.indexOf("")
			// 	array.splice(EmptyIndex, 1)
			// }
			
			array.toArray = function(){
				return this
			}
			array.splice(-1, 1);
			return array
		}
		function KeepAlive(DataObj) {
			var temp = ""
			DataObj.KeepAlive = true
			DataObj.topuidetect = true
			DataObj.ServiSignMainThread = true
			do{
				temp = ServiSignObj.Send(DataObj)
			}while(temp == "heartbeat")
			return temp
		}
		function isServiSignErrorCode(input) {
			var ErrorCode = parseInt(input) || 0
			return (61000 < ErrorCode && ErrorCode < 61999)
		}
		function getCookie(CookieName) {
			var TargetName = CookieName + "="
			var CookieArray = document.cookie.split(';')
			for (var i = 0; i < CookieArray.length; i++) {
				var CookieElement = CookieArray[i]
				while (CookieElement.charAt(0) == ' ') {
					CookieElement = CookieElement.substring(1)
				}
				if (CookieElement.indexOf(TargetName) == 0) {
					return CookieElement.substring(TargetName.length, CookieElement.length)
				}
			}
			return ""
		}
		function VersionCompare(VersionA, VersionB) {
			var iVersionA = parseInt(VersionA.replaceAll(",","").replaceAll(".","").replaceAll(" ","")) || 0
			var iVersionB = parseInt(VersionB.replaceAll(",","").replaceAll(".","").replaceAll(" ","")) || 0
			
			if(iVersionA == 0 || iVersionB == 0) return VersionCompare_Error
			if(iVersionA > iVersionB) return VersionCompare_Bigger
			if(iVersionA < iVersionB) return VersionCompare_Smaller
			return VersionCompare_Same
		}
		function BrowserDetection() {
			var sBrowser, sUsrAg = navigator.userAgent
	
			if(sUsrAg.indexOf("Edge") > -1){
				sBrowser = "Edge"
			} else if(sUsrAg.indexOf("Chrome") > -1) {
				sBrowser = "Chrome"
			} else if (sUsrAg.indexOf("Safari") > -1) {
				sBrowser = "Safari"
			} else if (sUsrAg.indexOf("Opera") > -1) {
				sBrowser = "Opera"
			} else if (sUsrAg.indexOf("Firefox") > -1) {
				sBrowser = "Firefox"
			} else if (sUsrAg.indexOf("MSIE") > -1 || sUsrAg.indexOf("Trident/7.0") > -1) {
				sBrowser = "Internet Explorer"
			} else {
				sBrowser = "unknown"
			}
			
			return sBrowser
		}
		function detectOS() {
			// https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js
			var userAgent = window.navigator.userAgent,
				platform = window.navigator.platform,
				macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
				windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
				os = null;
		
			if (macosPlatforms.indexOf(platform) !== -1) {
				os = 'Mac'
			}
			else if (windowsPlatforms.indexOf(platform) !== -1) {
				os = 'Windows'
			}
			else if (!os && /Linux/.test(platform)) {
				os = 'Linux'
			}
		
			return os
		}
		function verifyURL(input){
			
			if(input.indexOf("alert(") >= 0){
				return ""
			}
	
			if(input.indexOf('https://localhost:') != 0 && input.indexOf('https://127.0.0.1:') != 0){
				return ""
			}
	
			return encodeURI(input)
		}
		function getServiSignObj() {
			var portList = [56425, 56525, 56625]
			var InstallerName = "ESBServiSignMacSetup"
			
			var Url_Part1_DNS = 'https://localhost:'
			var Url_Part1_IP = 'https://127.0.0.1:'
			var SessionID =""
			var ServiSignUrl = ""
	
			var realServiSignVersion = ""
			var realLibVersion = ""
			var realInstallerVersion = ""
			var CurrenOSMinimalInstallerVersion = null
			
			var needUpdate = false
			var Browser = ""
			var OS = null
	
			var ServiSignObjResultObj = undefined
	
			var CallbackFunction = []
			var CallbackFunctionIndex = 0
			var isCloseAsynchronously = false
			
			var ServiSignObj = 
			{
				clearServiSignCallback : function(){
					ServiSignLog("CallbackFunction empty")
					CallbackFunction = []
					CallbackFunctionIndex = 0
				},
				setServiSignCallback : function(InputFunction){
					if(typeof InputFunction != "function"){
						CallbackFunction.splice(CallbackFunctionIndex + 1, 0, function(){return ;})
					}
					else{
						CallbackFunction.splice(CallbackFunctionIndex + 1, 0, InputFunction)
					}
				},
				sendData : function(url, DataObj){
					var XMLHttpRequestAsynchronously = (CallbackFunction.length != 0)
					var xhr = new XMLHttpRequest()
					
					try{
						if(verifyURL(url) == ""){
							return undefined
						}
						xhr.open('MagicMethodA|POST|MagicMethodB'.split('|')[1], verifyURL(url), XMLHttpRequestAsynchronously)
					}
					catch(err) {
						return undefined
					}
					xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
					var onLoadHandler = function(event){
						try {
							ServiSignObjResultObj = JSON.parse(this.responseText)
						}
						catch(err) {
							return undefined
						}
	
						if(XMLHttpRequestAsynchronously){
							CallbackFunction[CallbackFunctionIndex++](Base64Decode(ServiSignObjResultObj.result), this.ServiSignUrl);
							
							if(CallbackFunctionIndex == CallbackFunction.length){
								ServiSignObj.clearServiSignCallback();
							}
						}
					}
					xhr.onload = onLoadHandler
	
					DataObj.comname = LibName
					DataObj.libdir = LibDir
					if(ServiSignTabMode == ServiSignTabMode_Tab){
						DataObj.sessionid = SessionID
					}
					else if(ServiSignTabMode == ServiSignTabMode_Browser){
						DataObj.sessionid = Browser
					}
					DataObj.ServiSignTabMode = ServiSignTabMode
					DataObj.ServiSignBrowser = Browser
					DataObj.JSVersion = JSVersion
					DataObj.minlibversion = minLibVersion
					DataObj.minserverversion = minServiSignVersion
					DataObj.InstallerName = InstallerName
					DataObj.PathID = PathID
					
					// For new version form 20190416
					DataObj.AdapterJsonKeyCheck = false				
	
					var readyDataObj = "Parameter=" + Base64Encode(JSON.stringify(DataObj))
					
					try {
						xhr.send(readyDataObj)
					}
					catch(err) {
						var header = xhr.getResponseHeader("via")
						if (header) {
							ServiSignErrorCode = 61014
						}
						else{
							ServiSignDisconnectError()
						}
						return undefined
					}
					return ServiSignObjResultObj
				},
				TryPort : function() {
					var resultObj
					var DataObj = new Object()
					var ErrorCode = 0
	
					OS = detectOS()
					Browser = BrowserDetection()
	
					ServiSignLog(OS)
					ServiSignLog(Browser)
	
					// DataObj.functionname = "ServiSignEcho"
					DataObj.functionname = "Echo"
	
					ServiSignUrl = ""
	
					if(ServiSignUrl == "" || ServiSignUrl == "fail") {
						var EchoSuccess = false
						for (var i = 0; i < portList.length; i++) {
							var url
							if(OS == "Mac"){
								url = Url_Part1_DNS + (portList[i] - 2000)
							}
							else{
								url = Url_Part1_DNS + portList[i]
							}
	
							ServiSignLog("Echo URL: " + url)
	
							resultObj = this.sendData(url, DataObj)
							if(resultObj != undefined){
								
								ErrorCode = Base64Decode(resultObj.result)
					
								if(ErrorCode != "" && ErrorCode != "0") {
									ServiSignLog("Error code: " + ErrorCode)
									ServiSignErrorCode = parseInt(ErrorCode)
									continue
								}
								ServiSignUrl = url
								EchoSuccess = true
								break
							}
							if(ServiSignErrorCode == 61014){
	
								ServiSignLog("Using proxy")
								return false
							}
						}
						if(!EchoSuccess){
							for (var i = 0; i < portList.length; i++) {
								var url
								if(OS == "Mac"){
									url = Url_Part1_IP + (portList[i] - 2000)
								}
								else{
									url = Url_Part1_IP + portList[i]
								}
	
								ServiSignLog("Echo URL: " + url)
	
								resultObj = this.sendData(url, DataObj)
								if(resultObj != undefined){
									
									ErrorCode = Base64Decode(resultObj.result)
						
									if(ErrorCode != "" && ErrorCode != "0") {
										ServiSignLog("Error code: " + ErrorCode)
										continue
									}
									ServiSignUrl = url
									break
								}
								if(ServiSignErrorCode == 61014){
	
									ServiSignLog("Using proxy")
									return false
								}
							}
						}
					}
					else{
						ServiSignLog("Echo URL: " + url)
						resultObj = this.sendData(ServiSignUrl, DataObj)
					}
	
					if(resultObj == undefined){
						ServiSignConnectError()
						return false
					}
					
					ServiSignErrorCode = parseInt(ErrorCode) || 0
					if(ServiSignErrorCode == 0){
						
					}
					else{
						return false
					}
					
					realServiSignVersion = Base64Decode(resultObj.ServerVersion)
					realLibVersion = Base64Decode(resultObj.LibVersion)
					realInstallerVersion = Base64Decode(resultObj.InstallerVersion)
					
					if(SessionID == "") {
						SessionID = Base64Decode(resultObj.SessionID)
					}
	
					if(OS == "Windows"){
						CurrenOSMinimalInstallerVersion = MinimalInstallerVersion
					}
					else if(OS == "Mac"){
						CurrenOSMinimalInstallerVersion = MinimalInstallerVersion_Mac
					}
					else if(OS == "Linux"){
						CurrenOSMinimalInstallerVersion = MinimalInstallerVersion_Linux
					}
					
					needUpdate = (VersionCompare(CurrenOSMinimalInstallerVersion, realInstallerVersion) == VersionCompare_Bigger || VersionCompare(CurrenOSMinimalInstallerVersion, realInstallerVersion) == VersionCompare_Error)
					
					ServiSignErrorCode = 0
					return true
				},
				Send : function(DataObj) {
					DataObj.comname = LibName
					var resultObj = this.sendData(ServiSignUrl, DataObj)
					try {
						return Base64Decode(resultObj.result)
					}
					catch(err) {
						return ""
					}
				},
				getCGServiSignVersion : function() {
					return realServiSignVersion
				},
				getLibVersion : function() {
					return realLibVersion
				},
				getInstallerVersion : function() {
					return realInstallerVersion
				},
				getMinimalInstallerVersion : function() {
					return CurrenOSMinimalInstallerVersion
				},
				ServiSigninit : function() {
					var XMLHttpRequestSupported = typeof new XMLHttpRequest().responseType === 'string'
					
					if(!XMLHttpRequestSupported) {
						alert("This Browser does NOT support XMLHttpRequest")
						return false
					}
					return this.TryPort()
				},
				ServiSignRelease : function() {
					if(ServiSignErrorCode != 0){
						return
					}
					var DataObj = new Object()
					DataObj.functionname = "ServiSignRelease"
					DataObj.minlibversion = minLibVersion
					this.Send(DataObj)
	
					realServiSignVersion = ""
					realLibVersion = ""
					realInstallerVersion = ""
					CurrenOSMinimalInstallerVersion = null
					
					SessionID = ""
					needUpdate = false
					ServiSignErrorCode = 0
				},
				ServiSignForceRelease : function() {
					var DataObj = new Object()
					DataObj.functionname = "ServiSignForceRelease"
					DataObj.minlibversion = minLibVersion
					this.Send(DataObj)
	
					realServiSignVersion = ""
					realLibVersion = ""
					realInstallerVersion = ""
					CurrenOSMinimalInstallerVersion = null
					
					SessionID = ""
					needUpdate = false
					ServiSignErrorCode = 0
				},
				needUpdateInstaller : function() {
					return needUpdate
				}
			}
			return ServiSignObj
		}
		var ServiSignObj = getServiSignObj()
		var ServiSignInterface = 
		{
			GetServiSignVersion : function() {
				return ServiSignObj.getCGServiSignVersion()
			},
			GetLibVersion : function() {
				return ServiSignObj.getLibVersion()
			},
			GetInstallerVersion : function() {
				return ServiSignObj.getInstallerVersion()
			},
			GetMinimalInstallerVersion : function() {
				return ServiSignObj.getMinimalInstallerVersion()
			},
			SetServiSignCallback : function(InputFunction) {
				ServiSignObj.setServiSignCallback(InputFunction)
			},
			NeedUpdateInstaller : function() {
				return ServiSignObj.needUpdateInstaller()
			},
			ServiSignForceRelease : function() {
				return ServiSignObj.ServiSignForceRelease()
			},
			GetVersion : function(){
				var DataObj = new Object()
				DataObj.functionname = "GetVersion"
				DataObj.ServiSignFunctionIndex = 0
	
				return ServiSignObj.Send(DataObj)
			},
			SetCodePage : function(codepage){
				var DataObj = new Object()
				DataObj.functionname = "SetCodePage"
				DataObj.codepage = codepage
				DataObj.ServiSignFunctionIndex = 1
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			SetLanguage : function(cstrLanguage){
				var DataObj = new Object()
				DataObj.functionname = "SetLanguage"
				DataObj.cstrLanguage = cstrLanguage
				DataObj.ServiSignFunctionIndex = 2
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			GetErrorCode : function(){
				var DataObj = new Object()
				DataObj.functionname = "GetErrorCode"
				DataObj.ServiSignFunctionIndex = 3
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			DetectReplug : function(cstrReader, iFlags, ReplugTime){
				var DataObj = new Object()
				DataObj.functionname = "DetectReplug"
				DataObj.cstrReader = cstrReader
				DataObj.iFlags = iFlags
				DataObj.ReplugTime = ReplugTime
				DataObj.ServiSignFunctionIndex = 4
	
				DataObj.topuidetect = true;
				return parseInt(KeepAlive(DataObj))
			},
			CryptCertGetSubject : function(cstrCert, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "CryptCertGetSubject"
				DataObj.cstrCert = cstrCert
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 5
	
				return ServiSignObj.Send(DataObj)
			},
			CryptCertGetSerialNumber : function(cstrCert, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "CryptCertGetSerialNumber"
				DataObj.cstrCert = cstrCert
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 6
	
				return ServiSignObj.Send(DataObj)
			},
			CryptCertGetNotBefore : function(cstrCert, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "CryptCertGetNotBefore"
				DataObj.cstrCert = cstrCert
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 7
	
				return ServiSignObj.Send(DataObj)
			},
			CryptCertGetNotAfter : function(cstrCert, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "CryptCertGetNotAfter"
				DataObj.cstrCert = cstrCert
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 8
	
				return ServiSignObj.Send(DataObj)
			},
			P11Init : function(cstrLoadLibName){
				var DataObj = new Object()
				DataObj.functionname = "P11Init"
				DataObj.cstrLoadLibName = cstrLoadLibName
				DataObj.ServiSignFunctionIndex = 9
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11SetCurrentSlot : function(SlotNumber){
				var DataObj = new Object()
				DataObj.functionname = "P11SetCurrentSlot"
				DataObj.SlotNumber = SlotNumber
				DataObj.ServiSignFunctionIndex = 10
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11SessionOpen : function(){
				var DataObj = new Object()
				DataObj.functionname = "P11SessionOpen"
				DataObj.ServiSignFunctionIndex = 11
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11Login : function(cstrUserPIN, Login_Type, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11Login"
				DataObj.cstrUserPIN = cstrUserPIN
				DataObj.Login_Type = Login_Type
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 12
	
				return parseInt(KeepAlive(DataObj))
			},
			P11Logout : function(){
				var DataObj = new Object()
				DataObj.functionname = "P11Logout"
				DataObj.ServiSignFunctionIndex = 13
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11SessionClose : function(){
				var DataObj = new Object()
				DataObj.functionname = "P11SessionClose"
				DataObj.ServiSignFunctionIndex = 14
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11Final : function(){
				var DataObj = new Object()
				DataObj.functionname = "P11Final"
				DataObj.ServiSignFunctionIndex = 15
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11GetSerialNumber : function(){
				var DataObj = new Object()
				DataObj.functionname = "P11GetSerialNumber"
				DataObj.ServiSignFunctionIndex = 16
	
				return ServiSignObj.Send(DataObj)
			},
			P11GenerateCertRequest : function(cstrPriKeyLabel, cstrPriKeyID, cstrPubKeyLabel, cstrPubKeyID, KeyLength, cstrSubject, iFlags, iHashFlag){
				var DataObj = new Object()
				DataObj.functionname = "P11GenerateCertRequest"
				DataObj.cstrPriKeyLabel = cstrPriKeyLabel
				DataObj.cstrPriKeyID = cstrPriKeyID
				DataObj.cstrPubKeyLabel = cstrPubKeyLabel
				DataObj.cstrPubKeyID = cstrPubKeyID
				DataObj.KeyLength = KeyLength
				DataObj.cstrSubject = cstrSubject
				DataObj.iFlags = iFlags
				DataObj.iHashFlag = iHashFlag
				DataObj.ServiSignFunctionIndex = 17
	
				return KeepAlive(DataObj)
			},
			DetectToken : function(cstrToken){
				var DataObj = new Object()
				DataObj.functionname = "DetectToken"
				DataObj.cstrToken = cstrToken
				DataObj.ServiSignFunctionIndex = 18
	
				return parseInt(KeepAlive(DataObj))
			},
			GetReaderList : function(){
				var DataObj = new Object()
				DataObj.functionname = "GetReaderList"
				DataObj.ServiSignFunctionIndex = 19
	
				return FixArray(ServiSignObj.Send(DataObj))
			},
			HexEncode : function(cstrStr){
				var DataObj = new Object()
				DataObj.functionname = "HexEncode"
				DataObj.cstrStr = cstrStr
				DataObj.ServiSignFunctionIndex = 20
	
				return ServiSignObj.Send(DataObj)
			},
			P11IFXSign : function(cstrXML, cstrId, cstrSignedIds, iFlags, iHashFlag){
				var DataObj = new Object()
				DataObj.functionname = "P11IFXSign"
				DataObj.cstrXML_ServiSignBase64Flag = true
				DataObj.cstrXML = Base64Encode(cstrXML)
				DataObj.cstrId = cstrId
				DataObj.cstrSignedIds = cstrSignedIds
				DataObj.iFlags = iFlags
				DataObj.iHashFlag = iHashFlag
				DataObj.ServiSignFunctionIndex = 21
	
				return KeepAlive(DataObj)
			},
			P11FEDISign : function(cstrData, iFlags, iHashFlag){
				var DataObj = new Object()
				DataObj.functionname = "P11FEDISign"
				DataObj.cstrData_ServiSignBase64Flag = true
				DataObj.cstrData = Base64Encode(cstrData)
				DataObj.iFlags = iFlags
				DataObj.iHashFlag = iHashFlag
				DataObj.ServiSignFunctionIndex = 22
	
				return KeepAlive(DataObj)
			},
			P11SelectCert : function(cstrLabel, cstrSubject, cstrIssuer, iFlags, iKeyUsage){
				var DataObj = new Object()
				DataObj.functionname = "P11SelectCert"
				DataObj.cstrLabel = cstrLabel
				DataObj.cstrSubject = cstrSubject
				DataObj.cstrIssuer = cstrIssuer
				DataObj.iFlags = iFlags
				DataObj.iKeyUsage = iKeyUsage
				DataObj.ServiSignFunctionIndex = 23
	
				return parseInt(KeepAlive(DataObj))
			},
			P11DeleteNoCertRSAKey : function(cstrExceptKeyLabelt){
				var DataObj = new Object()
				DataObj.functionname = "P11DeleteNoCertRSAKey"
				DataObj.cstrExceptKeyLabelt = cstrExceptKeyLabelt
				DataObj.ServiSignFunctionIndex = 24
	
				return parseInt(KeepAlive(DataObj))
			},
			P11DeleteUsrCert : function(){
				var DataObj = new Object()
				DataObj.functionname = "P11DeleteUsrCert"
				DataObj.ServiSignFunctionIndex = 25
	
				return parseInt(KeepAlive(DataObj))
			},
			P11SetUserPIN : function(cstrServerKey, cstrTransportKey, cstrHexUserPIN, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11SetUserPIN"
				DataObj.cstrServerKey = cstrServerKey
				DataObj.cstrTransportKey = cstrTransportKey
				DataObj.cstrHexUserPIN = cstrHexUserPIN
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 26
	
				return parseInt(KeepAlive(DataObj))
			},
			SetPasswordLength : function(iMaxPwdLen){
				var DataObj = new Object()
				DataObj.functionname = "SetPasswordLength"
				DataObj.iMaxPwdLen = iMaxPwdLen
				DataObj.ServiSignFunctionIndex = 27
	
				return parseInt(ServiSignObj.Send(DataObj))
			},
			P11ChangePin : function(cstrOldPIN, cstrNewPIN, iType, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11ChangePin"
				DataObj.cstrOldPIN = cstrOldPIN
				DataObj.cstrNewPIN = cstrNewPIN
				DataObj.iType = iType
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 28
	
				return parseInt(KeepAlive(DataObj))
			},
			CryptCertGetIssuer : function(cstrCert, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "CryptCertGetIssuer"
				DataObj.cstrCert = cstrCert
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 29
	
				return ServiSignObj.Send(DataObj)
			},
			P11AcceptCert : function(cstrCert, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11AcceptCert"
				DataObj.cstrCert = cstrCert
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 30
	
				return parseInt(KeepAlive(DataObj))
			},
			P11ReadData : function(cstrLabel, iPrivate, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11ReadData"
				DataObj.cstrLabel = cstrLabel
				DataObj.iPrivate = iPrivate
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 31
	
				return KeepAlive(DataObj)
			},
			P11Sign : function(cstrData, iFlags, iHashFlag){
				var DataObj = new Object()
				DataObj.functionname = "P11Sign"
				DataObj.cstrData_ServiSignBase64Flag = true
				DataObj.cstrData = Base64Encode(cstrData)
				DataObj.iFlags = iFlags
				DataObj.iHashFlag = iHashFlag
				DataObj.ServiSignFunctionIndex = 32
	
				return KeepAlive(DataObj)
			},
			P11PureSign : function(cstrData, iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11PureSign"
				DataObj.cstrData_ServiSignBase64Flag = true
				DataObj.cstrData = Base64Encode(cstrData)
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 33
	
				return KeepAlive(DataObj)
			},
			GetCertificate : function(){
				var DataObj = new Object()
				DataObj.functionname = "GetCertificate"
				DataObj.ServiSignFunctionIndex = 34
	
				return ServiSignObj.Send(DataObj)
			},
			P11GetObjectList : function(iFlags){
				var DataObj = new Object()
				DataObj.functionname = "P11GetObjectList"
				DataObj.iFlags = iFlags
				DataObj.ServiSignFunctionIndex = 35
	
				return parseInt(KeepAlive(DataObj))
			}
		}
	
		window.addEventListener("beforeunload", function (e) {
			if(ServiSignTabMode == ServiSignTabMode_Tab){
				ServiSignObj.ServiSignRelease()
			}
			else if(ServiSignTabMode == ServiSignTabMode_Browser){
				//Do nothing
			}
		})
		if(!ServiSignObj.ServiSigninit()){
			ServiSignLoadComponentError()
			return undefined
		}
		
		return ServiSignInterface
	}
	
	function ServiSign_GetErrorCode(){
		return ServiSignErrorCode
	}


    return {
        getESBXMLP11AdapterObj: function () {
            return getESBXMLP11AdapterObj();
        },
        ServiSign_GetErrorCode: function () {
            return ServiSign_GetErrorCode();
        }
    }

})($);

try {
    module.exports = ESBXMLP11AdapterModule;
} catch (e) {

}
﻿var ESUNCGP11CryptoATLADPTModule = (function ($) {

    var ServiSignErrorCode = 61001;

    String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
    };

    function getESUNCGP11CryptoATLADPTObj() {

        //如有任何參數問題，請參考第 10, 11點
        //https://redmine.changingtec.com/redmine/projects/servisign/wiki/%E5%95%8F%E9%A1%8C%E8%88%87%E8%A7%A3%E7%AD%94

        //最低 ServiSign 版本 0.0.0.0 = 預設不開啟
        var minServiSignVersion = "0.0.0.0"
        //最低元件版本 0.0.0.0 = 預設不開啟
        var minLibVersion = "0.0.0.0"

        //底層元件 Adapter 名稱
        var LibName = "ESUNCGP11CryptoSSATLADPT"
        //底層元件 Adapter 所在位置
        var LibDir = "ESUN"
        //Path ID
        var PathID = ""

        //最低不需更新安裝包版本
        var MinimalInstallerVersion = "1.0.19.0417"
        var MinimalInstallerVersion_Mac = ""
        var MinimalInstallerVersion_Linux = ""
        //JS 模板版本號 ServiSign 主程式會做相容性版本確認
        var JSVersion = "1.0.18.1219"

        //Tab 以分頁做為轉換模式，行為模式與 ActiveX 元件相同
        var ServiSignTabMode_Tab = 0x0
        //Browser 模式則是以瀏覽器為單位，整個瀏覽器關掉才會釋放元件
        var ServiSignTabMode_Browser = 0x1

        var ServiSignTabMode = ServiSignTabMode_Tab

        //預設不使用 cookie 儲存 Try port 的結果
        var useCookieTryPort = false

        //路徑保護
        //DataObj.pfxpath_servisignflag = true;
        //DataObj.pfxpath = pfxpath.replace(/\\/g, "*");

        //開啟元件 UI 置頂功能
        //DataObj.topuidetect = true;
        //開啟全系統 UI 置頂功能
        //DataObj.topuialldetect = true;
        //開啟非同步功能
        //DataObj.asynchronously = true;

        //資料斜線保護功能
        //DataObj.XXXXX_ServiSignSlashFlag = true;
        //DataObj.XXXXX = inputXXXXXX.replaceAll("\\", "==ServiSignSlash==");
        //資料 Base64 保護功能
        //DataObj.XXXXX_ServiSignBase64Flag = true;
        //DataObj.XXXXX = Base64Encode(XXXXX);
        //使用主線程呼叫 API
        //DataObj.ServiSignMainThread = true;

        function ServiSignConnectError() {
            //ServiSign_RTN_CONNECTION_ERROR
            ServiSignErrorCode = 61006
        }

        function ServiSignLoadComponentError() {
            //Handing load component error
        }

        function ServiSignDisconnectError() {
            //Handing disconnect error
            ServiSignErrorCode = 61015
        }

        var VersionCompare_Error = 0x00
        var VersionCompare_Bigger = 0x01
        var VersionCompare_Smaller = 0x02
        var VersionCompare_Same = 0x03

        function ServiSignLog(LogMessage) {
            console.log("[ServiSign Log] " + LogMessage)
        }

        function Sleep(milliseconds) {
            var start = new Date().getTime()
            for (var i = 0; i < 1e7; i++) {
                if ((new Date().getTime() - start) > milliseconds) {
                    break
                }
            }
        }

        function Base64Encode(input) {
            return encodeURIComponent(window.btoa(unescape(encodeURIComponent(input))))
        }

        function Base64Decode(input) {
            if (input == undefined) return ""
            return decodeURIComponent(escape(window.atob(input)))
        }

        function FixArray(inputArray) {
            ServiSignLog("FixArray: " + inputArray)
            var array = inputArray.split(";")

            // while(array.indexOf("") != -1){
            // 	var EmptyIndex = array.indexOf("")
            // 	array.splice(EmptyIndex, 1)
            // }

            array.toArray = function () {
                return this
            }
            array.splice(-1, 1);
            return array
        }

        function KeepAlive(DataObj) {
            var temp = ""
            DataObj.KeepAlive = true
            DataObj.topuidetect = true
            DataObj.ServiSignMainThread = true
            do {
                temp = ServiSignObj.Send(DataObj)
            } while (temp == "heartbeat")
            return temp
        }

        function isServiSignErrorCode(input) {
            var ErrorCode = parseInt(input) || 0
            return (61000 < ErrorCode && ErrorCode < 61999)
        }

        function getCookie(CookieName) {
            var TargetName = CookieName + "="
            var CookieArray = document.cookie.split(';')
            for (var i = 0; i < CookieArray.length; i++) {
                var CookieElement = CookieArray[i]
                while (CookieElement.charAt(0) == ' ') {
                    CookieElement = CookieElement.substring(1)
                }
                if (CookieElement.indexOf(TargetName) == 0) {
                    return CookieElement.substring(TargetName.length, CookieElement.length)
                }
            }
            return ""
        }

        function VersionCompare(VersionA, VersionB) {
            var iVersionA = parseInt(VersionA.replaceAll(",", "").replaceAll(".", "").replaceAll(" ", "")) || 0
            var iVersionB = parseInt(VersionB.replaceAll(",", "").replaceAll(".", "").replaceAll(" ", "")) || 0

            if (iVersionA == 0 || iVersionB == 0) return VersionCompare_Error
            if (iVersionA > iVersionB) return VersionCompare_Bigger
            if (iVersionA < iVersionB) return VersionCompare_Smaller
            return VersionCompare_Same
        }

        function BrowserDetection() {
            var sBrowser, sUsrAg = navigator.userAgent

            if (sUsrAg.indexOf("Edge") > -1) {
                sBrowser = "Edge"
            } else if (sUsrAg.indexOf("Chrome") > -1) {
                sBrowser = "Chrome"
            } else if (sUsrAg.indexOf("Safari") > -1) {
                sBrowser = "Safari"
            } else if (sUsrAg.indexOf("Opera") > -1) {
                sBrowser = "Opera"
            } else if (sUsrAg.indexOf("Firefox") > -1) {
                sBrowser = "Firefox"
            } else if (sUsrAg.indexOf("MSIE") > -1 || sUsrAg.indexOf("Trident/7.0") > -1) {
                sBrowser = "Internet Explorer"
            } else {
                sBrowser = "unknown"
            }

            return sBrowser
        }

        function detectOS() {
            // https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js
            var userAgent = window.navigator.userAgent,
                platform = window.navigator.platform,
                macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                os = null;

            if (macosPlatforms.indexOf(platform) !== -1) {
                os = 'Mac'
            } else if (windowsPlatforms.indexOf(platform) !== -1) {
                os = 'Windows'
            } else if (!os && /Linux/.test(platform)) {
                os = 'Linux'
            }

            return os
        }

        function verifyURL(input) {

            if (input.indexOf("alert(") >= 0) {
                return ""
            }

            if (input.indexOf('https://localhost:') != 0 && input.indexOf('https://127.0.0.1:') != 0) {
                return ""
            }

            return encodeURI(input)
        }

        function getServiSignObj() {
            var portList = [56308, 56318, 56338]
            var InstallerName = "ESUNServiSignADPTSetup"

            var Url_Part1_DNS = 'https://localhost:'
            var Url_Part1_IP = 'https://127.0.0.1:'
            var SessionID = ""
            var ServiSignUrl = ""

            var WebURL = ""

            var realServiSignVersion = ""
            var realLibVersion = ""
            var realInstallerVersion = ""
            var CurrenOSMinimalInstallerVersion = null

            var needUpdate = false
            var Browser = ""
            var OS = null

            var ServiSignObjResultObj = undefined

            var CallbackFunction = []
            var CallbackFunctionIndex = 0
            var isCloseAsynchronously = false

            var ServiSignObj = {
                clearServiSignCallback: function () {
                    ServiSignLog("CallbackFunction empty")
                    CallbackFunction = []
                    CallbackFunctionIndex = 0
                },
                setServiSignCallback: function (InputFunction) {
                    if (typeof InputFunction != "function") {
                        CallbackFunction.splice(CallbackFunctionIndex + 1, 0, function () {
                            return;
                        })
                    } else {
                        CallbackFunction.splice(CallbackFunctionIndex + 1, 0, InputFunction)
                    }
                },
                sendData: function (url, DataObj) {
                    var XMLHttpRequestAsynchronously = (CallbackFunction.length != 0)
                    var xhr = new XMLHttpRequest()

                    try {
                        if (verifyURL(url) == "") {
                            return ""
                        }
                        xhr.open('POST', verifyURL(url), XMLHttpRequestAsynchronously)
                    } catch (err) {
                        return ""
                    }
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
                    var onLoadHandler = function (event) {
                        try {
                            ServiSignObjResultObj = JSON.parse(this.responseText)
                        } catch (err) {
                            if (this.responseText != undefined) {
                                ServiSignObjResultObj = new Object()
                                ServiSignObjResultObj.result = this.responseText.substring(11, this.responseText.length - 2)
                            } else {
                                ServiSignObjResultObj = ""
                            }
                        }

                        if (XMLHttpRequestAsynchronously) {
                            CallbackFunction[CallbackFunctionIndex++](Base64Decode(ServiSignObjResultObj.result), this.ServiSignUrl);

                            if (CallbackFunctionIndex == CallbackFunction.length) {
                                ServiSignObj.clearServiSignCallback();
                            }
                        }
                    }
                    xhr.onload = onLoadHandler

                    DataObj.comname = LibName
                    DataObj.libdir = LibDir
                    if (ServiSignTabMode == ServiSignTabMode_Tab) {
                        DataObj.sessionid = SessionID
                    } else if (ServiSignTabMode == ServiSignTabMode_Browser) {
                        DataObj.sessionid = Browser
                    }
                    DataObj.ServiSignTabMode = ServiSignTabMode
                    DataObj.ServiSignBrowser = Browser
                    DataObj.JSVersion = JSVersion
                    DataObj.minlibversion = minLibVersion
                    DataObj.url = WebURL
                    DataObj.minserverversion = minServiSignVersion
                    DataObj.InstallerName = InstallerName
                    DataObj.PathID = PathID

                    // For new version form 20190416
                    DataObj.AdapterJsonKeyCheck = true

                    var readyDataObj = "Parameter=" + Base64Encode(JSON.stringify(DataObj))

                    try {
                        xhr.send(readyDataObj)
                    } catch (err) {
                        var header = xhr.getResponseHeader("via")
                        if (header) {
                            ServiSignErrorCode = 61014
                        } else {
                            ServiSignDisconnectError()
                        }
                        return undefined
                    }
                    return ServiSignObjResultObj
                },
                TryPort: function () {
                    var resultObj
                    var DataObj = new Object()
                    var ErrorCode = 0

                    OS = detectOS()
                    Browser = BrowserDetection()

                    ServiSignLog(OS)
                    ServiSignLog(Browser)

                    DataObj.functionname = "ServiSignEcho"

                    ServiSignUrl = ""

                    WebURL = document.URL.substring(0, document.URL.indexOf("/", document.URL.indexOf("/") + 2))

                    if (ServiSignUrl == "" || ServiSignUrl == "fail") {
                        var EchoSuccess = false
                        for (var i = 0; i < portList.length; i++) {
                            var url
                            if (OS == "Mac") {
                                url = Url_Part1_DNS + (portList[i] - 2000)
                            } else {
                                url = Url_Part1_DNS + portList[i]
                            }

                            ServiSignLog("Echo URL: " + url)

                            resultObj = this.sendData(url, DataObj)
                            if (resultObj != undefined) {

                                ErrorCode = Base64Decode(resultObj.result)

                                if (ErrorCode != "" && ErrorCode != "0") {
                                    ServiSignLog("Error code: " + ErrorCode)
                                    continue
                                }
                                ServiSignUrl = url
                                EchoSuccess = true
                                break
                            }
                            if (ServiSignErrorCode == 61014) {
                                // 使用了 Proxy
                                // if(useCookieTryPort){
                                // 	document.cookie = "ServiSignUrl=fail"
                                // }
                                ServiSignLog("Using proxy")
                                return false
                            }
                        }
                        if (!EchoSuccess) {
                            for (var i = 0; i < portList.length; i++) {
                                var url
                                if (OS == "Mac") {
                                    url = Url_Part1_IP + (portList[i] - 2000)
                                } else {
                                    url = Url_Part1_IP + portList[i]
                                }

                                ServiSignLog("Echo URL: " + url)

                                resultObj = this.sendData(url, DataObj)
                                if (resultObj != undefined) {

                                    ErrorCode = Base64Decode(resultObj.result)

                                    if (ErrorCode != "" && ErrorCode != "0") {
                                        ServiSignLog("Error code: " + ErrorCode)
                                        continue
                                    }
                                    ServiSignUrl = url
                                    break
                                }
                                if (ServiSignErrorCode == 61014) {
                                    // 使用了 Proxy
                                    // if(useCookieTryPort){
                                    // 	document.cookie = "ServiSignUrl=fail"
                                    // }
                                    ServiSignLog("Using proxy")
                                    return false
                                }
                            }
                        }
                    } else {
                        ServiSignLog("Echo URL: " + url)
                        resultObj = this.sendData(ServiSignUrl, DataObj)
                    }

                    if (resultObj == undefined) {
                        // if(useCookieTryPort){
                        // 	document.cookie = "ServiSignUrl=fail"
                        // }
                        ServiSignConnectError()
                        return false
                    }

                    ServiSignErrorCode = parseInt(ErrorCode) || 0
                    if (ServiSignErrorCode == 0) {
                        // if(useCookieTryPort){
                        // 	document.cookie = "ServiSignUrl=" + ServiSignUrl
                        // }
                    } else {
                        // if(useCookieTryPort){
                        // 	document.cookie = "ServiSignUrl=fail"
                        // }
                        return false
                    }

                    realServiSignVersion = Base64Decode(resultObj.ServerVersion)
                    realLibVersion = Base64Decode(resultObj.LibVersion)
                    realInstallerVersion = Base64Decode(resultObj.InstallerVersion)

                    if (SessionID == "") {
                        SessionID = Base64Decode(resultObj.SessionID)
                    }

                    if (OS == "Windows") {
                        CurrenOSMinimalInstallerVersion = MinimalInstallerVersion
                    } else if (OS == "Mac") {
                        CurrenOSMinimalInstallerVersion = MinimalInstallerVersion_Mac
                    } else if (OS == "Linux") {
                        CurrenOSMinimalInstallerVersion = MinimalInstallerVersion_Linux
                    }

                    needUpdate = (VersionCompare(CurrenOSMinimalInstallerVersion, realInstallerVersion) == VersionCompare_Bigger || VersionCompare(CurrenOSMinimalInstallerVersion, realInstallerVersion) == VersionCompare_Error)

                    ServiSignErrorCode = 0
                    return true
                },
                Send: function (DataObj) {
                    DataObj.comname = LibName
                    var resultObj = this.sendData(ServiSignUrl, DataObj)
                    try {
                        return Base64Decode(resultObj.result)
                    } catch (err) {
                        return ""
                    }
                },
                getCGServiSignVersion: function () {
                    return realServiSignVersion
                },
                getLibVersion: function () {
                    return realLibVersion
                },
                getInstallerVersion: function () {
                    return realInstallerVersion
                },
                getMinimalInstallerVersion: function () {
                    return CurrenOSMinimalInstallerVersion
                },
                ServiSigninit: function () {
                    var XMLHttpRequestSupported = typeof new XMLHttpRequest().responseType === 'string'

                    if (!XMLHttpRequestSupported) {
                        alert("This Browser does NOT support XMLHttpRequest")
                        return false
                    }
                    return this.TryPort()
                },
                ServiSignRelease: function () {
                    if (ServiSignErrorCode != 0) {
                        return
                    }
                    var DataObj = new Object()
                    DataObj.functionname = "ServiSignRelease"
                    DataObj.minlibversion = minLibVersion
                    this.Send(DataObj)

                    realServiSignVersion = ""
                    realLibVersion = ""
                    realInstallerVersion = ""
                    CurrenOSMinimalInstallerVersion = null

                    SessionID = ""
                    needUpdate = false
                    ServiSignErrorCode = 0
                },
                ServiSignForceRelease: function () {
                    var DataObj = new Object()
                    DataObj.functionname = "ServiSignForceRelease"
                    DataObj.minlibversion = minLibVersion
                    this.Send(DataObj)

                    realServiSignVersion = ""
                    realLibVersion = ""
                    realInstallerVersion = ""
                    CurrenOSMinimalInstallerVersion = null

                    SessionID = ""
                    needUpdate = false
                    ServiSignErrorCode = 0
                },
                needUpdateInstaller: function () {
                    return needUpdate
                }
            }
            return ServiSignObj
        }
        var ServiSignObj = getServiSignObj()
        var ServiSignInterface = {
            GetServiSignVersion: function () {
                return ServiSignObj.getCGServiSignVersion()
            },
            GetLibVersion: function () {
                return ServiSignObj.getLibVersion()
            },
            GetInstallerVersion: function () {
                return ServiSignObj.getInstallerVersion()
            },
            GetMinimalInstallerVersion: function () {
                return ServiSignObj.getMinimalInstallerVersion()
            },
            SetServiSignCallback: function (InputFunction) {
                ServiSignObj.setServiSignCallback(InputFunction)
            },
            NeedUpdateInstaller: function () {
                return ServiSignObj.needUpdateInstaller()
            },
            ServiSignForceRelease: function () {
                return ServiSignObj.ServiSignForceRelease()
            },
            GetVersion: function () {
                var DataObj = new Object()
                DataObj.functionname = "GetVersion"
                DataObj.ServiSignFunctionIndex = 0

                return ServiSignObj.Send(DataObj)
            },
            Init: function (bInitCode, bInitPath) {
                var DataObj = new Object()
                DataObj.functionname = "Init"
                DataObj.bInitCode_ServiSignBase64Flag = true
                DataObj.bInitCode = Base64Encode(bInitCode)
                DataObj.bInitPath = bInitPath.replace(/\\/g, "*")
                DataObj.bInitPath_servisignflag = true
                DataObj.ServiSignFunctionIndex = 1

                return ServiSignObj.Send(DataObj)
            },
            SetLanguage: function (bLanguage) {
                var DataObj = new Object()
                DataObj.functionname = "SetLanguage"
                DataObj.bLanguage_ServiSignBase64Flag = true
                DataObj.bLanguage = Base64Encode(bLanguage)
                DataObj.ServiSignFunctionIndex = 2

                return parseInt(ServiSignObj.Send(DataObj))
            },
            DetectToken: function (bToken) {
                var DataObj = new Object()
                DataObj.functionname = "DetectToken"
                DataObj.bToken_ServiSignBase64Flag = true
                DataObj.bToken = Base64Encode(bToken)
                DataObj.ServiSignFunctionIndex = 3

                return parseInt(ServiSignObj.Send(DataObj))
            },
            DetectReplug: function (bToken, iFlags, iReplugTime) {
                var DataObj = new Object()
                DataObj.functionname = "DetectReplug"
                DataObj.bToken_ServiSignBase64Flag = true
                DataObj.bToken = Base64Encode(bToken)
                DataObj.iFlags = iFlags
                DataObj.iReplugTime = iReplugTime
                DataObj.ServiSignFunctionIndex = 4

                DataObj.topuidetect = true;
                return parseInt(ServiSignObj.Send(DataObj))
            },
            SetPasswordLength: function (length) {
                var DataObj = new Object()
                DataObj.functionname = "SetPasswordLength"
                DataObj.length = length
                DataObj.ServiSignFunctionIndex = 5

                return parseInt(ServiSignObj.Send(DataObj))
            },
            SetCodePage: function (codepage) {
                var DataObj = new Object()
                DataObj.functionname = "SetCodePage"
                DataObj.codepage = codepage
                DataObj.ServiSignFunctionIndex = 6

                return parseInt(ServiSignObj.Send(DataObj))
            },
            GetErrorCode: function () {
                var DataObj = new Object()
                DataObj.functionname = "GetErrorCode"
                DataObj.ServiSignFunctionIndex = 7

                return parseInt(ServiSignObj.Send(DataObj))
            },
            HexEncode: function (bStr) {
                var DataObj = new Object()
                DataObj.functionname = "HexEncode"
                DataObj.bStr_ServiSignBase64Flag = true
                DataObj.bStr = Base64Encode(bStr)
                DataObj.ServiSignFunctionIndex = 8

                return ServiSignObj.Send(DataObj)
            },
            P11Init: function (bLoadLibName) {
                var DataObj = new Object()
                DataObj.functionname = "P11Init"
                DataObj.bLoadLibName_ServiSignBase64Flag = true
                DataObj.bLoadLibName = Base64Encode(bLoadLibName)
                DataObj.ServiSignFunctionIndex = 9

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11SetCurrentSlot: function (iSlotNumber) {
                var DataObj = new Object()
                DataObj.functionname = "P11SetCurrentSlot"
                DataObj.iSlotNumber = iSlotNumber
                DataObj.ServiSignFunctionIndex = 10

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11SessionOpen: function () {
                var DataObj = new Object()
                DataObj.functionname = "P11SessionOpen"
                DataObj.ServiSignFunctionIndex = 11

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11Login: function (bUserPIN, iType, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11Login"
                DataObj.bUserPIN_ServiSignBase64Flag = true
                DataObj.bUserPIN = Base64Encode(bUserPIN)
                DataObj.iType = iType
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 12

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11Logout: function () {
                var DataObj = new Object()
                DataObj.functionname = "P11Logout"
                DataObj.ServiSignFunctionIndex = 13

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11SessionClose: function () {
                var DataObj = new Object()
                DataObj.functionname = "P11SessionClose"
                DataObj.ServiSignFunctionIndex = 14

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11Final: function () {
                var DataObj = new Object()
                DataObj.functionname = "P11Final"
                DataObj.ServiSignFunctionIndex = 15

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11ChangePin: function (bOldPIN, bNewPIN, iType, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11ChangePin"
                DataObj.bOldPIN_ServiSignBase64Flag = true
                DataObj.bOldPIN = Base64Encode(bOldPIN)
                DataObj.bNewPIN_ServiSignBase64Flag = true
                DataObj.bNewPIN = Base64Encode(bNewPIN)
                DataObj.iType = iType
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 16

                return parseInt(ServiSignObj.Send(DataObj))
            },
            GetCertificate: function () {
                var DataObj = new Object()
                DataObj.functionname = "GetCertificate"
                DataObj.ServiSignFunctionIndex = 17

                return ServiSignObj.Send(DataObj)
            },
            CryptCertGetSubject: function (bCert, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "CryptCertGetSubject"
                DataObj.bCert_ServiSignBase64Flag = true
                DataObj.bCert = Base64Encode(bCert)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 18

                return ServiSignObj.Send(DataObj)
            },
            CryptCertGetSerialNumber: function (bCert, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "CryptCertGetSerialNumber"
                DataObj.bCert_ServiSignBase64Flag = true
                DataObj.bCert = Base64Encode(bCert)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 19

                return ServiSignObj.Send(DataObj)
            },
            CryptCertGetNotBefore: function (bCert, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "CryptCertGetNotBefore"
                DataObj.bCert_ServiSignBase64Flag = true
                DataObj.bCert = Base64Encode(bCert)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 20

                return ServiSignObj.Send(DataObj)
            },
            CryptCertGetNotAfter: function (bCert, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "CryptCertGetNotAfter"
                DataObj.bCert_ServiSignBase64Flag = true
                DataObj.bCert = Base64Encode(bCert)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 21

                return ServiSignObj.Send(DataObj)
            },
            CryptCertGetIssuer: function (bCert, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "CryptCertGetIssuer"
                DataObj.bCert_ServiSignBase64Flag = true
                DataObj.bCert = Base64Encode(bCert)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 22

                return ServiSignObj.Send(DataObj)
            },
            P11GenerateCertRequest: function (bPriKeyLabel, bPriKeyID, bPubKeyLabel, bPubKeyID, iKeyLength, bSubject, iFlags, iHashFlag) {
                var DataObj = new Object()
                DataObj.functionname = "P11GenerateCertRequest"
                DataObj.bPriKeyLabel_ServiSignBase64Flag = true
                DataObj.bPriKeyLabel = Base64Encode(bPriKeyLabel)
                DataObj.bPriKeyID_ServiSignBase64Flag = true
                DataObj.bPriKeyID = Base64Encode(bPriKeyID)
                DataObj.bPubKeyLabel_ServiSignBase64Flag = true
                DataObj.bPubKeyLabel = Base64Encode(bPubKeyLabel)
                DataObj.bPubKeyID_ServiSignBase64Flag = true
                DataObj.bPubKeyID = Base64Encode(bPubKeyID)
                DataObj.iKeyLength = iKeyLength
                DataObj.bSubject_ServiSignBase64Flag = true
                DataObj.bSubject = Base64Encode(bSubject)
                DataObj.iFlags = iFlags
                DataObj.iHashFlag = iHashFlag
                DataObj.ServiSignFunctionIndex = 23

                return ServiSignObj.Send(DataObj)
            },
            P11AcceptCert: function (bCert, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11AcceptCert"
                DataObj.bCert_ServiSignBase64Flag = true
                DataObj.bCert = Base64Encode(bCert)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 24

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11GetSerialNumber: function () {
                var DataObj = new Object()
                DataObj.functionname = "P11GetSerialNumber"
                DataObj.ServiSignFunctionIndex = 25

                return ServiSignObj.Send(DataObj)
            },
            P11ReadData: function (bLabel, iPrivate, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11ReadData"
                DataObj.bLabel_ServiSignBase64Flag = true
                DataObj.bLabel = Base64Encode(bLabel)
                DataObj.iPrivate = iPrivate
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 26

                return ServiSignObj.Send(DataObj)
            },
            P11Sign: function (bData, iFlags, iHashFlag) {
                var DataObj = new Object()
                DataObj.functionname = "P11Sign"
                DataObj.bData_ServiSignBase64Flag = true
                DataObj.bData = Base64Encode(bData)
                DataObj.iFlags = iFlags
                DataObj.iHashFlag = iHashFlag
                DataObj.ServiSignFunctionIndex = 27

                return ServiSignObj.Send(DataObj)
            },
            P11IFXSign: function (bXML, bId, bSignId, iFlags, iHashFlag) {
                var DataObj = new Object()
                DataObj.functionname = "P11IFXSign"
                DataObj.bXML_ServiSignBase64Flag = true
                DataObj.bXML = Base64Encode(bXML)
                DataObj.bId_ServiSignBase64Flag = true
                DataObj.bId = Base64Encode(bId)
                DataObj.bSignId_ServiSignBase64Flag = true
                DataObj.bSignId = Base64Encode(bSignId)
                DataObj.iFlags = iFlags
                DataObj.iHashFlag = iHashFlag
                DataObj.ServiSignFunctionIndex = 28

                return ServiSignObj.Send(DataObj)
            },
            P11FEDISign: function (bData, iFlags, iHashFlag) {
                var DataObj = new Object()
                DataObj.functionname = "P11FEDISign"
                DataObj.bData_ServiSignBase64Flag = true
                DataObj.bData = Base64Encode(bData)
                DataObj.iFlags = iFlags
                DataObj.iHashFlag = iHashFlag
                DataObj.ServiSignFunctionIndex = 29

                return ServiSignObj.Send(DataObj)
            },
            P11SelectCert: function (bLabel, bSubject, bIssuer, iFlags, iKeyUsage) {
                var DataObj = new Object()
                DataObj.functionname = "P11SelectCert"
                DataObj.bLabel_ServiSignBase64Flag = true
                DataObj.bLabel = Base64Encode(bLabel)
                DataObj.bSubject_ServiSignBase64Flag = true
                DataObj.bSubject = Base64Encode(bSubject)
                DataObj.bIssuer_ServiSignBase64Flag = true
                DataObj.bIssuer = Base64Encode(bIssuer)
                DataObj.iFlags = iFlags
                DataObj.iKeyUsage = iKeyUsage
                DataObj.ServiSignFunctionIndex = 30

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11PureSign: function (bData, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11PureSign"
                DataObj.bData_ServiSignBase64Flag = true
                DataObj.bData = Base64Encode(bData)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 31

                return ServiSignObj.Send(DataObj)
            },
            P11DeleteNoCertRSAKey: function (bExceptKeyLabel) {
                var DataObj = new Object()
                DataObj.functionname = "P11DeleteNoCertRSAKey"
                DataObj.bExceptKeyLabel_ServiSignBase64Flag = true
                DataObj.bExceptKeyLabel = Base64Encode(bExceptKeyLabel)
                DataObj.ServiSignFunctionIndex = 32

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11DeleteUsrCert: function () {
                var DataObj = new Object()
                DataObj.functionname = "P11DeleteUsrCert"
                DataObj.ServiSignFunctionIndex = 33

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11GetObjectList: function (iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11GetObjectList"
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 34

                return parseInt(ServiSignObj.Send(DataObj))
            },
            P11SetUserPIN: function (bServerKey, bTransportKey, bHexUserPIN, iFlags) {
                var DataObj = new Object()
                DataObj.functionname = "P11SetUserPIN"
                DataObj.bServerKey_ServiSignBase64Flag = true
                DataObj.bServerKey = Base64Encode(bServerKey)
                DataObj.bTransportKey_ServiSignBase64Flag = true
                DataObj.bTransportKey = Base64Encode(bTransportKey)
                DataObj.bHexUserPIN_ServiSignBase64Flag = true
                DataObj.bHexUserPIN = Base64Encode(bHexUserPIN)
                DataObj.iFlags = iFlags
                DataObj.ServiSignFunctionIndex = 35

                return parseInt(ServiSignObj.Send(DataObj))
            }
        }

        window.addEventListener("beforeunload", function (e) {
            if (ServiSignTabMode == ServiSignTabMode_Tab) {
                ServiSignObj.ServiSignRelease()
            } else if (ServiSignTabMode == ServiSignTabMode_Browser) {
                //Do nothing
            }
        })
        if (!ServiSignObj.ServiSigninit()) {
            ServiSignLoadComponentError()
            return undefined
        }

        return ServiSignInterface
    }

    function ServiSign_GetErrorCode() {
        return ServiSignErrorCode
    }

    return {
        getESUNCGP11CryptoATLADPTObj: function () {
            return getESUNCGP11CryptoATLADPTObj();
        },
        ServiSign_GetErrorCode: function () {
            return ServiSign_GetErrorCode();
        }
    }

})($);

try {
    module.exports = ESUNCGP11CryptoATLADPTModule;
} catch (e) {

}
var mac = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;
var myobj = null;
var esunCryptModule = null;

if (mac) {
  // 直接引用全域變數，而不是使用 require
  if (typeof ESBXMLP11AdapterModule !== "undefined") {
    esunCryptModule = ESBXMLP11AdapterModule;
    // myobj = esunCryptModule.getESBXMLP11AdapterObj();
  } else {
    console.error(
      "ESBXMLP11AdapterModule 未載入，請確認 ESBXMLP11Adapter.js 已正確載入"
    );
  }
} else {
  // 直接引用全域變數，而不是使用 require
  if (typeof ESUNCGP11CryptoATLADPTModule !== "undefined") {
    esunCryptModule = ESUNCGP11CryptoATLADPTModule;
    // myobj = esunCryptModule.getESUNCGP11CryptoATLADPTObj();
  } else {
    console.error(
      "ESUNCGP11CryptoATLADPTModule 未載入，請確認 ESUNCGP11CryptoSSATLADPT.js 已正確載入"
    );
  }
}

var VAModule = (function ($) {
  var CG_RTN_SUCCESS = 0;
  var EOI_RTN_ERROR = 1;
  var EOI_RTN_OPENFILE_ERROR = 10;
  var EOI_RTN_CRYPT_ERROR = 1000;
  var EOI_RTN_APP_ERROR = 10000;
  var EOI_RTN_INVALID_FEDICERT = 10001;
  var EOI_RTN_GETFEDIX509_ERROR = 10002;
  var EOI_RTN_GETPUBKEY_ERROR = 10003;
  var EOI_RTN_INVALID_CAPRIPK = 10004;
  var EOI_RTN_VERIFYCACERT_ERROR = 10005;
  var EOI_RTN_VERIFYUSERCERT_ERROR = 10006;
  var EOI_RTN_P11_NOTLOGIN = 10007;
  var EOI_RTN_KEY_NOTMATCH = 10008;
  var EOI_RTN_READ_PUBKEY_ERROR = 10009;
  var EOI_RTN_ENCRYPT_ERROR = 1001;
  var EOI_RTN_SET_PRIKEY_ERROR = 10010;
  var EOI_RTN_DECRYPT_ERROR = 1002;
  var EOI_RTN_SIGN_ERROR = 1003;
  var EOI_RTN_VERIFY_ERROR = 1004;
  var EOI_RTN_WRITE_ERROR = 11;
  var EOI_RTN_READ_ERROR = 12;
  var EOI_RTN_P11_ERROR = 1500;
  var EOI_RTN_P11INIT_ERROR = 1510;
  var EOI_RTN_P11_NOTOKEN = 1511;
  var EOI_RTN_P11OPEN_ERROR = 1512;
  var EOI_RTN_P11PIN_INVALID = 1513;
  var EOI_RTN_P11DELETE_ERROR = 1514;
  var EOI_RTN_P11GENKEY_ERROR = 1515;
  var EOI_RTN_P11MEM_ERROR = 1516;
  var EOI_RTN_P11PIN_LOCKED = 1517;
  var EOI_RTN_MEMALLOC_ERROR = 2;
  var EOI_RTN_TWCA_2401 = 2401;
  var EOI_RTN_TWCA_2404 = 2404;
  var EOI_RTN_TWCA_2406 = 2406;
  var EOI_RTN_TWCA_2420 = 2420;
  var EOI_RTN_TWCA_2421 = 2421;
  var EOI_RTN_TWCA_2710 = 2710;
  var EOI_RTN_TWCA_2802 = 2802;
  var EOI_RTN_INVALID_PARAM = 3;
  var EOI_RTN_WININET_ERROR = 3000;
  var EOI_RTN_INVALID_FORMAT = 4;
  var EOI_RTN_LIBRARY_EXPIRED = 5;
  var EOI_RTN_CODEC_ERROR = 500;
  var EOI_RTN_BASE64_ERROR = 501;
  var EOI_RTN_WSTR2MCHAR_ERROR = 502;
  var EOI_RTN_MCHAR2WSTR_ERROR = 503;
  var CG_RTN_CMS_CARD_ISSUED = 12101;
  var CG_RTN_CMS_CARD_CLEANED_OR_NO_USER = 12102;
  var CG_RTN_CMS_USER_EXIST = 12103;
  var CG_RTN_CMS_DB_ERROR = 12104;
  var CG_RTN_CMS_KEY_LENGTH_ERROR = 12105;
  var CG_RTN_CMS_MAKE_MD5_DIGEST_ERROR = 12106;
  var CG_RTN_CMS_MAC_NOT_MATCH = 12107;
  var VB_OBJECT_REQUIRED = "1A8";
  var VB_OBJECT_DOES_NOT_SUPPORT = "1B6";
  var API_RTN_ACCESS_DENIED = 26000;
  var API_RTN_USER_CANCEL = 26001;
  var API_RTN_GENMAC_FAIL = 26002;
  var API_RTN_LABEL_NOT_EXIST = 26003;
  var API_RTN_PARAMETER_EMPTY = 26004;
  var API_RTN_PARAMETER_FORMAT_ERROR = 26005;
  var API_RTN_INVALID_ENCODING = 26006;
  var API_RTN_FORMAT_ERROR = 26007;
  var API_RTN_NO_DATA = 26008;
  var API_RTN_NEWPIN_AND_REPEATPIN_NOT_MATCH = 26101;
  var API_RTN_NEW_PIN_LENGTH_ERROR = 26102;
  var API_RTN_NEWPIN_EQUAL_OLDPIN = 26103;
  var API_RTN_NEWPIN_NO_NUMBER = 26104;
  var API_RTN_NEWPIN_NO_CAPITALLETTER = 26105;
  var API_RTN_NEWPIN_NO_SMALLLETTER = 26106;
  var API_RTN_NEWPIN_NO_SYMBOLMARK = 26107;
  var API_RTN_NEWPIN_INCLUDE_SPACE = 26108;
  var API_RTN_USER_NOT_FIRST_LOGIN = 26109;
  var API_RTN_LOGINCOUNT_CHANGED = 26110;
  var API_RTN_PARSE_ERROR = 26111;
  var API_RTN_NO_NEED_TO_DELETE = 26112;
  var API_RTN_CONNECT_ERROR = 26801;
  var CG_RTN_ERROR = 5001;
  var CG_RTN_MEMALLOC_ERROR = 5002;
  var CG_RTN_BUFFER_TOO_SMALL = 5003;
  var CG_RTN_FUNCTION_UNSUPPORT = 5004;
  var CG_RTN_INVALID_PARAM = 5005;
  var CG_RTN_INVALID_HANDLE = 5006;
  var CG_RTN_LIB_EXPIRE = 5007;
  var CG_RTN_BASE64_ERROR = 5008;
  var CG_RTN_CERT_NOT_FOUND = 5010;
  var CG_RTN_CERT_EXPIRED = 5011;
  var CG_RTN_CERT_NOT_YET_VALID = 5012;
  var CG_RTN_CERT_EXPIRE_OR_NOT_YET_USE = 5013;
  var CG_RTN_CERT_DENIED = 5014;
  var CG_RTN_CERT_NOISSUER = 5015;
  var CG_RTN_CERT_BAD_SIGNATURE = 5016;
  var CG_RTN_CERT_INVALID_KEYUSAGE = 5017;
  var CG_RTN_CERT_REVOKED = 5020;
  var CG_RTN_CERT_KEY_COMPROMISED = 5021;
  var CG_RTN_CERT_CA_COMPROMISED = 5022;
  var CG_RTN_CERT_AFFILIATION_CHANGED = 5023;
  var CG_RTN_CERT_SUPERSEDED = 5024;
  var CG_RTN_CERT_CESSATION = 5025;
  var CG_RTN_CERT_HOLD = 5026;
  var CG_RTN_CERT_REMOVEFROMCRL = 5028;
  var CG_RTN_CRL_EXPIRED = 5030;
  var CG_RTN_CRL_NOT_YET_VALID = 5031;
  var CG_RTN_CRL_NOT_FOUND = 5032;
  var CG_RTN_CRL_BAD_SIGNATURE = 5034;
  var CG_RTN_GET_DIGEST_ERROR = 5035;
  var CG_RTN_BAD_SIGNATURE = 5036;
  var CG_RTN_BAD_CONTENT = 5037;
  var CG_RTN_INVALID_CAPTCHA = 5038;
  var CG_RTN_INVALID_CERT = 5040;
  var CG_RTN_INVALID_CRL = 5041;
  var CG_RTN_INVALID_PKCS7 = 5042;
  var CG_RTN_INVALID_KEY = 5043;
  var CG_RTN_INVALID_CERTREQ = 5044;
  var CG_RTN_INVALID_FORMAT = 5045;
  var CG_RTN_INVALID_PKCS12 = 5046;
  var CG_RTN_OBJ_NOT_FOUND = 5050;
  var CG_RTN_PKCS7_NO_CONTENT = 5051;
  var CG_RTN_PKCS7_NO_CERTIFICATE = 5052;
  var CG_RTN_PKCS7_NO_SIGNERINFO = 5053;
  var CG_RTN_UNMATCH_CERT_KEY = 5060;
  var CG_RTN_SIGN_ERROR = 5061;
  var CG_RTN_VERIFY_ERROR = 5062;
  var CG_RTN_ENCRYPT_ERROR = 5063;
  var CG_RTN_DECRYPT_ERROR = 5064;
  var CG_RTN_GENKEY_ERROR = 5065;
  var CG_RTN_DELETE_USR_CERT_ERROR = 5066;
  var CG_RTN_OPERATION_CANCELED = 5070;
  var CG_RTN_PASSWD_INVALID = 5071;
  var CG_RTN_SCARD_BLOCKED = 5072;
  var CG_RTN_REPLUG_TIMEOUT = 5073;
  var CG_RTN_NO_SCARD_SERVICE = 5074;
  var CG_RTN_XMLPARSE_ERROR = 5080;
  var CG_RTN_XMLTAG_NOTFOUND = 5081;
  var CG_RTN_PKCS12_NO_AUTHSAFES = 5091;
  var CG_RTN_PKCS12_DECODE_BAG_ERROR = 5092;
  var CG_RTN_PKCS12_DECRYPT_ERROR = 5093;
  var CG_RTN_PKCS12_GETKEY_ERROR = 5094;
  var CG_RTN_PKCS12_GETCERT_ERROR = 5095;
  var CG_RTN_INVALID_STATE = 5100;
  var CG_RTN_OUT_OF_RANGE = 5101;
  var FSCAPI_RTN_OPENSTORE_ERROR = 5201;
  var FSCAPI_RTN_CREATECHAIN_ERROR = 5202;
  var FSCAPI_RTN_CRYPTCONTEXT_ERROR = 5203;
  var FSCAPI_RTN_NO_PRIVATE_KEY = 5204;
  var FSCAPI_RTN_UNEXPORTABLE = 5205;
  var FSCAPI_RTN_STORE_ACCESSDENY = 5206;
  var FSCRYPT_RTN_CRL_NOISSUER = 5401;
  var FSCRYPT_RTN_OCSP_NOSIGNATURE = 5410;
  var FSCRYPT_RTN_OCSP_NOSIGNCERT = 5411;
  var FSCRYPT_RTN_OCSP_NODATA = 5412;
  var FSCRYPT_RTN_OCSP_UNSUPPORTRESPONSE = 5413;
  var FSCRYPT_RTN_OCSP_INVALIDRESPONSE = 5414;
  var FSCRYPT_RTN_OCSP_NOMATCHCERTID = 5415;
  var FSCRYPT_RTN_OCSP_CERTSTATUS_UNKNOWN = 5416;
  var FSCRYPT_RTN_OCSP_INVALIDRESPID = 5417;
  var FSCRYPT_RTN_OCSP_INVALIDRESPNONCE = 5418;
  var FSCRYPT_RTN_OCSP_RSPSTATUS_INVALIDREQUEST = 5420;
  var FSCRYPT_RTN_OCSP_RSPSTATUS_INTERNALERROR = 5421;
  var FSCRYPT_RTN_OCSP_RSPSTATUS_TRYLATER = 5422;
  var FSCRYPT_RTN_OCSP_RSPSTATUS_SIGREQUIRED = 5423;
  var FSCRYPT_RTN_OCSP_RSPSTATUS_UNAUTHORIZED = 5424;
  var FSCRYPT_RTN_OCSP_RSPSTATUS_UNKNOWN = 5425;
  var BAF_RTN_TIMEOUT = 5510;
  var CG_RTN_UNICODE_ERROR = 5901;
  var CG_RTN_FILE_NOT_FOUND = 5902;
  var CG_RTN_PATH_NOT_FOUND = 5903;
  var CG_RTN_BAD_NETPATH = 5904;
  var CG_RTN_LOGON_FAILURE = 5905;
  var CG_RTN_ACCESS_DENIED = 5906;
  var CG_RTN_BAD_INITCODE = 5907;
  var CG_RTN_INITCODE_NOT_VERIFY = 5908;
  var CG_RTN_PASSWORD_RULES_DENIED = 5909;
  var RAF_RTN_ERROR = 6110;
  var RAF_RTN_NO_DATA = 6111;
  var RAF_RTN_INVALID_FORMAT = 6112;
  var RAF_RTN_CONNECT_ERROR = 6113;
  var API_RTN_ACCESS_DENIED2 = 6590;
  var SERVI_SIGN_RTN_CONNECTION_ERROR = 61006;
  var SERVI_SIGN_DISCONNECT_ERROR = 61015;
  var SERVER_RTN_GENERAL_ERROR = 66001;
  var SERVER_RTN_ARGUMENT_MISSING = 66002;
  var SERVER_RTN_ARGUMENT_ILLEGALE = 66003;
  var SERVER_RTN_CONNECT_RA_ERROR = 66004;
  var SERVER_RTN_CONNECT_CA_ERROR = 66005;
  var SERVER_RTN_PERM_USEKEY_DENIED = 66006;
  var SERVER_RTN_PERM_USEFUNC_DENIED = 66007;
  var SERVER_RTN_CRTOKEN_EXPIRED = 66008;
  var SERVER_RTN_CA_ERROR = 66009;
  var SERVER_RTN_AUTH_FAIL = 66010;
  var SERVER_RTN_SERVER_ALREADY_RUNNING = 66101;
  var SERVER_RTN_SERVER_NOT_START = 66102;
  var SERVER_RTN_SERVER_STARTING = 66103;
  var SERVER_RTN_SERVER_STOPPING = 66104;
  var SERVER_RTN_SERVER_PASSWD_INCORRECT = 66105;
  var SERVER_RTN_SERVER_PASSWD_REQUIRED = 66106;
  var SERVER_RTN_SERVER_TOKEN_LOGIN_REQUIRED = 66107;
  var SERVER_RTN_SERVER_HAS_NO_AVAILABLE_TOKEN = 66108;
  var SERVER_RTN_SERVER_FUNCTION_NOT_SUPPORT = 66109;
  var SERVER_RTN_ACCOUNT_DELETED = 66201;
  var SERVER_RTN_ACCOUNT_LOCKED = 66202;
  var SERVER_RTN_ACCOUNT_NOT_EXIST = 66203;
  var SERVER_RTN_ACCOUNT_ALREADY_EXIST = 66204;
  var SERVER_RTN_ACCOUNT_NOT_LOGIN = 66205;
  var SERVER_RTN_ACCOUNT_SUSPEND = 66206;
  var SERVER_RTN_ACCOUNT_DELAYED = 66207;
  var SERVER_RTN_ACCOUNT_NORMAL = 66208;
  var SERVER_RTN_ACCOUNT_NOT_INIT = 66209;
  var SERVER_RTN_ACCOUNT_NOT_OTP_USER = 66210;
  var SERVER_RTN_ACCOUNT_NOT_IN_INIT_STATUS = 66211;
  var SERVER_RTN_ACCOUNT_TEMPPASSWD_EXPIRED = 66212;
  var SERVER_RTN_ACCOUNT_TEMPPASSWD_INCORRECT = 66213;
  var SERVER_RTN_ACCOUNT_OTP_INCORRECT = 66214;
  var SERVER_RTN_ACCOUNT_UNALLOWED_OPERATION = 66215;
  var SERVER_RTN_ACCOUNT_UNTRUSTED_CA = 66216;
  var SERVER_RTN_CERTACCOUNT_DUPLICATE_KEY1 = 66217;
  var SERVER_RTN_INVALID_USER_OR_PASS = 66218;
  var SERVER_RTN_ACCOUNT_UNINIT_OTP_TOKEN_FOUND = 66219;
  var SERVER_RTN_ACCOUNT_TOKEN_NOT_FOUND = 66220;
  var SERVER_RTN_ACCOUNT_HAS_NO_WORKING_TOKEN = 66221;
  var SERVER_RTN_ACCOUNT_ROLENOTEXIST = 66222;
  var SERVER_RTN_ACCOUNT_HAS_NO_UNUSED_TOKEN = 66223;
  var SERVER_RTN_ACCOUNT_ALREADY_HAS_SMS_TOKEN = 66224;
  var SERVER_RTN_LICENSE_SN_ERROR = 66301;
  var SERVER_RTN_LICENSE_UNALLOWED_IP = 66302;
  var SERVER_RTN_UNALLOWED_IP = 66303;
  var SERVER_RTN_INVALID_RA = 66304;
  var SERVER_RTN_ALL_CACERT_EXPIRED = 66305;
  var SERVER_RTN_LICENSE_MISUSE = 66306;
  var SERVER_RTN_LICENSE_EXPIRED_OR_NOT_YET_VALID = 66307;
  var SERVER_RTN_LICENSE_USER_EXCEEDED = 66308;
  var SERVER_RTN_LICENSE_VERSION_NOT_MATCH = 66309;
  var SERVER_RTN_SMS_QUOTA_EXHAUSTED = 66310;
  var SERVER_RTN_SMS_SEND_FAILED = 66311;
  var SERVER_RTN_SMTP_SEND_FAILED = 66312;
  var SERVER_RTN_SMS_SETTING_ERROR = 66313;
  var SERVER_RTN_BACKUP_INVALID_SETTING = 66315;
  var SERVER_RTN_INVALID_SETTING = 66316;
  var SERVER_RTN_SETTING_FILES_NOT_FOUND = 66317;
  var SERVER_RTN_LICENSE_MAC_NOT_MATCH = 66318;
  var SERVER_RTN_UNAUTHORIZED_FUNCTION = 66319;
  var SERVER_RTN_DATABASE_FAIL = 66401;
  var SERVER_RTN_DATABASE_NODATA = 66402;
  var SERVER_RTN_DATABASE_DATA_EXIST = 66403;
  var SERVER_RTN_DATABASE_INVALID_FORMAT = 66404;
  var SERVER_RTN_CERT_STATE_EXPIRED = 66501;
  var SERVER_RTN_CERT_STATE_EXPIRING = 66502;
  var SERVER_RTN_CERT_STATE_REVOKED = 66503;
  var SERVER_RTN_CERT_STATE_REVOKING = 66504;
  var SERVER_RTN_CERT_STATE_SUSPENDED = 66505;
  var SERVER_RTN_CERT_STATE_SUSPENDING = 66506;
  var SERVER_RTN_CERT_STATE_EXTENDING = 66507;
  var SERVER_RTN_CERT_STATE_EXTENDED = 66508;
  var SERVER_RTN_CERT_STATE_RENEWING = 66509;
  var SERVER_RTN_CERT_STATE_RENEWED = 66510;
  var SERVER_RTN_CERT_STATE_NOT_YET_VALID = 66511;
  var SERVER_RTN_CERT_STATE_REMOVEFROMCRL = 66512;
  var SERVER_RTN_CERT_STATE_INVALID = 66513;
  var SERVER_RTN_CERT_FORMAT_ERROR = 66520;
  var SERVER_RTN_CERT_NOT_FOUND = 66521;
  var SERVER_RTN_CERT_BAD_SIGNATURE = 66522;
  var SERVER_RTN_CERT_NOT_EXPIRING = 66523;
  var SERVER_RTN_CERT_VALIDCERT_EXIST = 66524;
  var SERVER_RTN_CERT_APPLYREQ_EXIST = 66525;
  var SERVER_RTN_CERT_INVALID_KEYUSAGE = 66526;
  var SERVER_RTN_CERT_APPLY_FAIL = 66530;
  var SERVER_RTN_INVALID_CERTTYPE = 66531;
  var SERVER_RTN_CERT_WAIT_APPLY = 66532;
  var SERVER_RTN_INVALID_CSR = 66533;
  var SERVER_RTN_CRL_DOWN_FAIL = 66551;
  var SERVER_RTN_CRL_PARSE_ERROR = 66552;
  var SERVER_RTN_RTNMSG_FORMAT_ERROR = 66601;
  var SERVER_RTN_PROCESS_WAITING = 66700;
  var SERVER_RTN_PROCESS_FAIL = 66701;
  var SERVER_RTN_UNAVAILABLE = 66702;
  var SERVER_RTN_PKCS7_FORMAT_ERROR = 66710;
  var SERVER_RTN_PKCS7_NO_CONTENT = 66711;
  var SERVER_RTN_VERIFY_BAD_CONTENT = 66720;
  var SERVER_RTN_UNMATCH_CERT_PRIKEY = 66725;
  var SERVER_RTN_USER_UNMATCH_ID_CERT = 66801;
  var SERVER_RTN_USER_CERTREGISTEDOTHER = 66802;
  var SERVER_RTN_USER_NOT_REGISTER_CERT = 66803;
  var SERVER_RTN_CERT_EXIST = 66804;
  var SERVER_RTN_CARD_ALREADY_OPENED = 66805;
  var FSXML_RTN_ERROR = 7701;
  var FSXML_RTN_INVALID_ALGORITHM = 7704;
  var FSXML_RTN_CRYPT_FAIL = 7705;
  var FSXML_RTN_INCORRECT_SIGNATURE = 7706;
  var FSXML_RTN_INCORRECT_REFERENCE = 7707;
  var FSXML_RTN_C14N_FAIL = 7708;
  var FSXML_RTN_TRANSFORM_FAIL = 7709;
  var FSXML_RTN_RESOLVER_FAIL = 7710;
  var FSXML_RTN_NO_SIGNATURE = 7711;
  var FSXML_RTN_PARSER_ERROR = 7712;
  var FSXML_RTN_URI_NOT_EXIST = 7713;
  var FSXML_RTN_X509DATA_MISMATCH = 7714;
  var FSXML_RTN_ERROR_XML_DOC = 7715;
  var FSXML_RTN_INVALID_PARAM = 7716;
  var FSXML_RTN_INVALID_C14N_ALG = 7717;
  var FSXML_RTN_INVALID_SIGNATURE_ALG = 7718;
  var FSXML_RTN_INVALID_DIGEST_ALG = 7719;
  var FSXML_RTN_INVALID_ENCRYPTION_ALG = 7720;
  var FSXML_RTN_INVALID_ENCRYPTION_PARM = 7721;
  var FSXML_RTN_INVALID_RETRIEVAL_TYPE = 7722;
  var FSXML_RTN_NO_ENCRYPTEDKEY = 7723;
  var FSXML_RTN_NO_ENCRYPTEDDATA = 7724;
  var FSXML_RTN_NO_CIPHERVALUE = 7725;
  var FSXML_RTN_LOSE_TRANSPORTKEY = 7726;
  var E_ACCESSDENIED = "80000009";
  var E_ACCESS_DENIED = "80070005";
  var OPERATION_WAS_CANCELED = "800704C7";
  var E_NO_ACCESS = "80072004";
  var NTE_BAD_UID = "80090001";
  var NTE_BAD_HASH = "80090002";
  var NTE_BAD_KEY = "80090003";
  var NTE_BAD_LEN = "80090004";
  var NTE_BAD_DATA = "80090005";
  var NTE_BAD_SIGNATURE = "80090006";
  var NTE_BAD_VER = "80090007";
  var NTE_BAD_ALGID = "80090008";
  var NTE_BAD_FLAGS = "80090009";
  var NTE_BAD_TYPE = "8009000A";
  var NTE_BAD_KEY_STATE = "8009000B";
  var NTE_BAD_HASH_STATE = "8009000C";
  var NTE_NO_KEY = "8009000D";
  var NTE_NO_MEMORY = "8009000E";
  var NTE_EXISTS = "8009000F";
  var NTE_PERM = "80090010";
  var NTE_NOT_FOUND = "80090011";
  var NTE_DOUBLE_ENCRYPT = "80090012";
  var NTE_BAD_PROVIDER = "80090013";
  var NTE_BAD_PROV_TYPE = "80090014";
  var NTE_BAD_PUBLIC_KEY = "80090015";
  var NTE_BAD_KEYSET = "80090016";
  var NTE_PROV_TYPE_NOT_DEF = "80090017";
  var NTE_PROV_TYPE_ENTRY_BAD = "80090018";
  var NTE_KEYSET_NOT_DEF = "80090019";
  var NTE_KEYSET_ENTRY_BAD = "8009001A";
  var NTE_PROV_TYPE_NO_MATCH = "8009001B";
  var NTE_SIGNATURE_FILE_BAD = "8009001C";
  var NTE_PROVIDER_DLL_FAIL = "8009001D";
  var NTE_PROV_DLL_NOT_FOUND = "8009001E";
  var NTE_BAD_KEYSET_PARAM = "8009001F";
  var NTE_FAIL = "80090020";
  var NTE_SYS_ERR = "80090021";
  var NTE_SILENT_CONTEXT = "80090022";
  var NTE_TOKEN_KEYSET_STORAGE_FULL = "80090023";
  var NTE_TEMPORARY_PROFILE = "80090024";
  var NTE_FIXEDPARAMETER = "80090025";
  var CRYPT_E_BAD_LEN = "80092001";
  var CRYPT_E_BAD_ENCODE = "80092002";
  var CRYPT_E_FILE_ERROR = "80092003";
  var CRYPT_E_NOT_FOUND = "80092004";
  var CRYPT_E_EXISTS = "80092005";
  var CRYPT_E_NO_PROVIDER = "80092006";
  var CRYPT_E_SELF_SIGNED = "80092007";
  var CRYPT_E_DELETED_PREV = "80092008";
  var CRYPT_E_NO_MATCH = "80092009";
  var CRYPT_E_UNEXPECTED_MSG_TYPE = "8009200A";
  var CRYPT_E_NO_KEY_PROPERTY = "8009200B";
  var CRYPT_E_NO_DECRYPT_CERT = "8009200C";
  var CRYPT_E_BAD_MSG = "8009200D";
  var CRYPT_E_NO_SIGNER = "8009200E";
  var CRYPT_E_PENDING_CLOSE = "8009200F";
  var SCARD_F_INTERNAL_ERROR = "80100001";
  var SCARD_E_CANCELLED = "80100002";
  var SCARD_E_INVALID_HANDLE = "80100003";
  var SCARD_E_INVALID_PARAMETER = "80100004";
  var SCARD_E_INVALID_TARGET = "80100005";
  var SCARD_E_NO_MEMORY = "80100006";
  var SCARD_F_WAITED_TOO_LONG = "80100007";
  var SCARD_E_INSUFFICIENT_BUFFER = "80100008";
  var SCARD_E_UNKNOWN_READER = "80100009";
  var SCARD_E_TIMEOUT = "8010000A";
  var SCARD_E_SHARING_VIOLATION = "8010000B";
  var SCARD_E_NO_SMARTCARD = "8010000C";
  var SCARD_E_UNKNOWN_CARD = "8010000D";
  var SCARD_E_CANT_DISPOSE = "8010000E";
  var SCARD_E_PROTO_MISMATCH = "8010000F";
  var SCARD_E_NOT_READY = "80100010";
  var SCARD_E_INVALID_VALUE = "80100011";
  var SCARD_E_SYSTEM_CANCELLED = "80100012";
  var SCARD_F_COMM_ERROR = "80100013";
  var SCARD_F_UNKNOWN_ERROR = "80100014";
  var SCARD_E_INVALID_ATR = "80100015";
  var SCARD_E_NOT_TRANSACTED = "80100016";
  var SCARD_E_READER_UNAVAILABLE = "80100017";
  var SCARD_P_SHUTDOWN = "80100018";
  var SCARD_E_PCI_TOO_SMALL = "80100019";
  var SCARD_E_READER_UNSUPPORTED = "8010001A";
  var SCARD_E_DUPLICATE_READER = "8010001B";
  var SCARD_E_CARD_UNSUPPORTED = "8010001C";
  var SCARD_E_NO_SERVICE = "8010001D";
  var SCARD_E_SERVICE_STOPPED = "8010001E";
  var SCARD_E_UNEXPECTED = "8010001F";
  var SCARD_E_ICC_INSTALLATION = "80100020";
  var SCARD_E_ICC_CREATEORDER = "80100021";
  var SCARD_E_UNSUPPORTED_FEATURE = "80100022";
  var SCARD_E_DIR_NOT_FOUND = "80100023";
  var SCARD_E_FILE_NOT_FOUND = "80100024";
  var SCARD_E_NO_DIR = "80100025";
  var SCARD_E_NO_FILE = "80100026";
  var SCARD_E_NO_ACCESS = "80100027";
  var SCARD_E_WRITE_TOO_MANY = "80100028";
  var SCARD_E_BAD_SEEK = "80100029";
  var SCARD_E_INVALID_CHV = "8010002A";
  var SCARD_E_UNKNOWN_RES_MNG = "8010002B";
  var SCARD_E_NO_SUCH_CERTIFICATE = "8010002C";
  var SCARD_E_CERTIFICATE_UNAVAILABLE = "8010002D";
  var SCARD_E_NO_READERS_AVAILABLE = "8010002E";
  var SCARD_E_COMM_DATA_LOST = "8010002F";
  var SCARD_E_NO_KEY_CONTAINER = "80100030";
  var SCARD_E_SERVER_TOO_BUSY = "80100031";
  var SCARD_W_UNSUPPORTED_CARD = "80100065";
  var SCARD_W_UNRESPONSIVE_CARD = "80100066";
  var SCARD_W_UNPOWERED_CARD = "80100067";
  var SCARD_W_RESET_CARD = "80100068";
  var SCARD_W_REMOVED_CARD = "80100069";
  var SCARD_W_SECURITY_VIOLATION = "8010006A";
  var SCARD_W_WRONG_CHV = "8010006B";
  var SCARD_W_CHV_BLOCKED = "8010006C";
  var SCARD_W_EOF = "8010006D";
  var SCARD_W_CANCELLED_BY_USER = "8010006E";
  var SCARD_W_CARD_NOT_AUTHENTICATED = "8010006F";
  var FSP11_RTN_CANCEL = 9001;
  var FSP11_RTN_HOST_MEMORY = 9002;
  var FSP11_RTN_SLOT_ID_INVALID = 9003;
  var FSP11_RTN_GENERAL_ERROR = 9004;
  var FSP11_RTN_FUNCTION_FAILED = 9005;
  var FSP11_RTN_ARGUMENTS_BAD = 9006;
  var FSP11_RTN_NO_EVENT = 9007;
  var FSP11_RTN_NEED_TO_CREATE_THREADS = 9008;
  var FSP11_RTN_CANT_LOCK = 9009;
  var FSP11_RTN_ATTRIBUTE_READ_ONLY = 9010;
  var FSP11_RTN_ATTRIBUTE_SENSITIVE = 9011;
  var FSP11_RTN_ATTRIBUTE_TYPE_INVALID = 9012;
  var FSP11_RTN_ATTRIBUTE_VALUE_INVALID = 9013;
  var FSP11_RTN_DATA_INVALID = 9014;
  var FSP11_RTN_DATA_LEN_RANGE = 9015;
  var FSP11_RTN_DEVICE_ERROR = 9016;
  var FSP11_RTN_DEVICE_MEMORY = 9017;
  var FSP11_RTN_DEVICE_REMOVED = 9018;
  var FSP11_RTN_ENCRYPTED_DATA_INVALID = 9019;
  var FSP11_RTN_ENCRYPTED_DATA_LEN_RANGE = 9020;
  var FSP11_RTN_FUNCTION_CANCELED = 9021;
  var FSP11_RTN_FUNCTION_NOT_PARALLEL = 9022;
  var FSP11_RTN_FUNCTION_NOT_SUPPORTED = 9023;
  var FSP11_RTN_KEY_HANDLE_INVALID = 9024;
  var FSP11_RTN_KEY_SIZE_RANGE = 9025;
  var FSP11_RTN_KEY_TYPE_INCONSISTENT = 9026;
  var FSP11_RTN_KEY_NOT_NEEDED = 9027;
  var FSP11_RTN_KEY_CHANGED = 9028;
  var FSP11_RTN_KEY_NEEDED = 9029;
  var FSP11_RTN_KEY_INDIGESTIBLE = 9030;
  var FSP11_RTN_KEY_FUNCTION_NOT_PERMITTED = 9031;
  var FSP11_RTN_KEY_NOT_WRAPPABLE = 9032;
  var FSP11_RTN_KEY_UNEXTRACTABLE = 9033;
  var FSP11_RTN_MECHANISM_INVALID = 9034;
  var FSP11_RTN_MECHANISM_PARAM_INVALID = 9035;
  var FSP11_RTN_OBJECT_HANDLE_INVALID = 9036;
  var FSP11_RTN_OPERATION_ACTIVE = 9037;
  var FSP11_RTN_OPERATION_NOT_INITIALIZED = 9038;
  var FSP11_RTN_PIN_INCORRECT = 9039;
  var FSP11_RTN_PIN_INVALID = 9040;
  var FSP11_RTN_PIN_LEN_RANGE = 9041;
  var FSP11_RTN_PIN_EXPIRED = 9042;
  var FSP11_RTN_PIN_LOCKED = 9043;
  var FSP11_RTN_SESSION_CLOSED = 9044;
  var FSP11_RTN_SESSION_COUNT = 9045;
  var FSP11_RTN_SESSION_HANDLE_INVALID = 9046;
  var FSP11_RTN_SESSION_PARALLEL_NOT_SUPPORTED = 9047;
  var FSP11_RTN_SESSION_READ_ONLY = 9048;
  var FSP11_RTN_SESSION_EXISTS = 9049;
  var FSP11_RTN_SESSION_READ_ONLY_EXISTS = 9050;
  var FSP11_RTN_SESSION_READ_WRITE_SO_EXISTS = 9051;
  var FSP11_RTN_SIGNATURE_INVALID = 9052;
  var FSP11_RTN_SIGNATURE_LEN_RANGE = 9053;
  var FSP11_RTN_TEMPLATE_INCOMPLETE = 9054;
  var FSP11_RTN_TEMPLATE_INCONSISTENT = 9055;
  var FSP11_RTN_TOKEN_NOT_PRESENT = 9056;
  var FSP11_RTN_TOKEN_NOT_RECOGNIZED = 9057;
  var FSP11_RTN_TOKEN_WRITE_PROTECTED = 9058;
  var FSP11_RTN_UNWRAPPING_KEY_HANDLE_INVALID = 9059;
  var FSP11_RTN_UNWRAPPING_KEY_SIZE_RANGE = 9060;
  var FSP11_RTN_UNWRAPPING_KEY_TYPE_INCONSISTENT = 9061;
  var FSP11_RTN_USER_ALREADY_LOGGED_IN = 9062;
  var FSP11_RTN_USER_NOT_LOGGED_IN = 9063;
  var FSP11_RTN_USER_PIN_NOT_INITIALIZED = 9064;
  var FSP11_RTN_USER_TYPE_INVALID = 9065;
  var FSP11_RTN_USER_ANOTHER_ALREADY_LOGGED_IN = 9066;
  var FSP11_RTN_USER_TOO_MANY_TYPES = 9067;
  var FSP11_RTN_WRAPPED_KEY_INVALID = 9068;
  var FSP11_RTN_WRAPPED_KEY_LEN_RANGE = 9069;
  var FSP11_RTN_WRAPPING_KEY_HANDLE_INVALID = 9070;
  var FSP11_RTN_WRAPPING_KEY_SIZE_RANGE = 9071;
  var FSP11_RTN_WRAPPING_KEY_TYPE_INCONSISTENT = 9072;
  var FSP11_RTN_RANDOM_SEED_NOT_SUPPORTED = 9073;
  var FSP11_RTN_RANDOM_NO_RNG = 9074;
  var FSP11_RTN_BUFFER_TOO_SMALL = 9075;
  var FSP11_RTN_SAVED_STATE_INVALID = 9076;
  var FSP11_RTN_INFORMATION_SENSITIVE = 9077;
  var FSP11_RTN_STATE_UNSAVEABLE = 9078;
  var FSP11_RTN_CRYPTOKI_NOT_INITIALIZED = 9079;
  var FSP11_RTN_CRYPTOKI_ALREADY_INITIALIZED = 9080;
  var FSP11_RTN_MUTEX_BAD = 9081;
  var FSP11_RTN_MUTEX_NOT_LOCKED = 9082;
  var FSP11_RTN_VENDOR_DEFINED = 9083;
  var FSP11_RTN_OBJECT_NOT_EXIST = 9100;
  var FSP11_RTN_OBJECT_EXIST = 9101;
  var FSP11_RTN_OBJECT_HAS_PROBLEM = 9102;
  var FSP11_RTN_LOAD_LIBRARY_FAIL = 9110;
  var FSP11_RTN_LIBRARY_NOT_LOAD = 9111;
  var FSP11_RTN_SLOT_NOT_FOUND = 9112;
  var FSP11_RTN_FORCE_USER_CHANGE_PIN = 9990;
  var FSP11_RTN_UNKNOW_ERROR = 9999;
  // 自定義錯誤碼
  var MULTIPLE_TOKEN = -2;
  var DRIVER_NOT_FOUND = -3;
  var NOT_SUPPORT_64BIT = -4;
  var ACTIVEX_LOAD_FAIL = -5;
  var JAVA_DISABLE = -6;
  var JRE_VERSION = -7;
  var SERVICE_WINDOW_2048 = -8;
  var NOT_SUPPORT_TOKEN = -9;

  // Sign Flag
  var CG_FLAG_CERT_NOATTACH = 0x00000100;
  var CG_FLAG_CERT_ATTACHALL = 0x00000200;

  // Verify Flag
  var CG_FLAG_VERIFY_CONTENT_ONLY = 0x00000000;
  var CG_FLAG_VERIFY_CERTCHAIN = 0x00000001;
  var CG_FLAG_VERIFY_CRL = 0x00000002;
  var CG_FLAG_VERIFY_FULL = CG_FLAG_VERIFY_CERTCHAIN | CG_FLAG_VERIFY_CRL;

  // Common Flag
  var CG_FLAG_BASE64_ENCODE = 0x00001000;
  var CG_FLAG_BASE64_DECODE = 0x00002000;
  var CG_FLAG_DETACHMSG = 0x00004000;
  var CG_FLAG_ENVELOPING = 0x00008000;
  var CG_FLAG_ENVELOPED = 0x00010000;
  var CG_FLAG_MANIFEST = 0x00020000;
  var CG_TYPE_CERTIFICATE = 1;
  var CG_TYPE_CERTREQUEST = 2;
  var CG_TYPE_CRL = 3;
  var CG_TYPE_PKCS7 = 4;
  var CG_TYPE_SIGNERINFO = 5;
  var CG_TYPE_PRIVATEKEY = 6;
  var CG_TYPE_PUBLICKEY = 7;
  var CG_TYPE_STORE = 8;
  var CG_TYPE_HASH = 9;
  var CG_TYPE_SYMKEY = 10;
  var CG_ALGOR_DES = 0x01;
  var CG_ALGOR_3DES = 0x02;
  var CG_ALGOR_IDEA = 0x03;
  var CG_ALGOR_RC4 = 0x04;
  var CG_ALGOR_MD5 = 0x01;
  var CG_ALGOR_SHA1 = 0x02;
  var CG_FLAG_MODE_ECB = 0x10;
  var CG_FLAG_MODE_CBC = 0x20;
  var CG_FLAG_SUBJECT_COMMON_NAME = 0x00010000;
  var CG_FLAG_SUBJECT_RSA_EMAILADDR = 0x00020000;
  var CG_FLAG_SUBJECT_ORGANIZATION_NAME = 0x00040000;
  var CG_FLAG_SUBJECT_ORGANIZATIONAL_UNIT_NAME = 0x00080000;
  var CG_FLAG_SUBJECT_COUNTRY_NAME = 0x00100000;
  var CG_FLAG_SUBJECT_DEVICE_SERIAL_NUMBER = 0x00200000;

  // Pure Sign/Verify Flag
  var CG_FLAG_HEX_ENCODE = 0x01000000;
  var CG_FLAG_DOHASH = 0x00010000;
  var CG_FLAG_NOHASHOID = 0x00020000;

  // Key Generation Flag
  var CG_FLAG_PBKDF1 = 1;
  var CG_FLAG_PBKDF2 = 2;
  var CG_KU_DIGITAL_SIGNATURE = 0x0080;
  var CG_KU_NON_REPUDIATION = 0x0040;
  var CG_KU_KEY_ENCIPHERMENT = 0x0020;
  var CG_KU_DATA_ENCIPHERMENT = 0x0010;
  var CG_KU_KEY_AGREEMENT = 0x0008;
  var CG_KU_KEY_CERT_SIGN = 0x0004;
  var CG_KU_CRL_SIGN = 0x0002;
  var CG_KU_ENCIPHER_ONLY = 0x0001;
  var CG_KU_DECIPHER_ONLY = 0x8000;
  var CG_XKU_SSL_SERVER_AUTH = 0x1;
  var CG_XKU_SSL_CLIENT_AUTH = 0x2;
  var CG_XKU_EMAIL_PROTECTION = 0x4;
  var CG_XKU_CODE_SIGN = 0x8;
  var CG_XKU_MS_SGC = 0x10;
  var CG_XKU_NS_SGC = 0x20;

  // CAPI Sign Flag
  var CGP11_FLAG_SELCERT_MANUAL = 0x00000001;
  var CGP11_FLAG_SELCERT_AUTO = 0x00000002; //自動選擇最新的憑證
  var CGP11_FLAG_SELCERT_SELFAUTO =
    CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_MANUAL;
  var CGP11_FLAG_SELCERT_AFTER = 0x00000004;
  var CGP11_FLAG_SELCERT_OLDEST = 0x00000008;
  var CGP11_FLAG_SELCERT_CHECKVALID = 0x00000010;
  var CGP11_FLAG_DISABLE_KEYSPEC_ATSIGNATURE = 0x00000020;
  var CGP11_FLAG_ENABLE_EMPTY_PASSWORD = 0x00001000; //強制輸入密碼
  var CGP11_FLAG_SELCERT_USEIE = 0x00000200;
  var CGP11_FLAG_SUBJECT_PARTIALMATCH = 0x00080000;
  var CGP11_FLAG_SELCERT_MEMORY = 0x00400000;
  var CGP11_FLAG_DISABLE_REPLUG = 0x00800000; //可以不必插拔

  // CAPI Verify Flag
  var CGP11_FLAG_FETCH_URLOBJ = 0x00000010;
  var CGP11_FLAG_USING_CERTCHAIN = 0x00000020;
  var CGP11_FLAG_LOCALMACHINE = 0x00000040;
  // CAPI Other Flag
  var CG_FLAG_USE_REPLUG2 = 0x00020000; // 載具拔插測試
  var CGP11_FLAG_PASSWD_KEYBOARD = 0x00000400; // 無小鍵盤
  var CGP11_FLAG_PASSWD_KEYPAD = 0x00000800; // 鍵盤輸入
  var CGP11_FLAG_PASSWD_KEYBOARD_RANDOM_LETTER = 0x01000000; // 鍵盤英文字母隨機產生功能
  var CGP11_FLAG_CHECK_PASSWD = 0x00000040; // PIN碼檢核規則

  //iKeyUsage   參數值
  var CG_KU_DIGITAL_SIGNATURE = 0x0080;
  var CG_KU_NON_REPUDIATION = 0x0040;
  var FS_KU_KEY_ENCIPHERMENT = 0x0020;
  var FS_KU_DATA_ENCIPHERMENT = 0x0010;
  var FS_KU_KEY_AGREEMENT = 0x0008;
  var FS_KU_KEY_CERT_SIGN = 0x0004;
  var FS_KU_CRL_SIGN = 0x0002;
  var FS_KU_ENCIPHER_ONLY = 0x0001;
  var FS_KU_DECIPHER_ONLY = 0x8000;

  // 預設鍵盤輸入模式
  var NO_PINPAD = 1;
  var PINPAD_KEYBOARD = 2;
  var PINPAD_ONLY = 3;

  // IFX 資料分隔字元
  var IFX_MESSAGE_SPLIT_WORD = "~IFX~";

  // Token 物件
  var token = null;
  // 發動元件
  var srcObject = null;
  // NPAPI
  var ATLADPTObj = null;

  // Driver Name
  var DRIVER_IKEY = "dkck201.dll";
  var DRIVER_SLB = "slbck.dll";
  // 4、5代e-gate
  var DRIVER_MS = "esfrp11cg.dll";

  var DRIVER_ETOKEN_WIN = "eToken.dll";

  // Mac eToken
  var DRIVER_ETOKEN_MAC = "libeToken.dylib";

  // Login_Type
  var TYPE_ADMIN = 0;
  var TYPE_USER = 1;

  var CGP11_DATA_OBJECT = 0x00000010;
  var CGP11_CERTIFICATE_OBJECT = 0x00000011;
  var CGP11_RSA_PUBLIC_KEY_OBJECT = 0x00000012;
  var CGP11_RSA_PRIVATE_KEY_OBJECT = 0x00000013;

  var CGP11_FLAG_EXTRACTABLE_NONE = 0x00080000; // for iKey
  var CGP11_FLAG_WRAP = 0x00001000;
  var CGP11_FLAG_UNWRAP = 0x00002000;
  var CG_ALGOR_SHA1 = 0x02;
  var CG_ALGOR_SHA224 = 0x03;
  var CG_ALGOR_SHA256 = 0x04;

  var global_rtn = 0;

  var global_operationLog = "";

  function getLastErr() {
    return CGErrCodes(global_rtn);
  }

  function getLastErrCodes() {
    return global_rtn;
  }

  function appendLog(msg) {
    global_operationLog += "," + msg;
  }

  // 取得verifyToken時的記錄
  function getOperatorLog() {
    return global_operationLog;
  }

  // 中大型簽章
  function verifyToken(disableRePlug, pinpad) {
    // 元件偵測
    // debugger;
    global_operationLog = "";

    appendLog("verifyToken detectPlugin...");

    if (!detectPlugin()) {
      return false;
    }

    var xml_string = document.getElementById(token.orgXmlID);
    var signXml = document.getElementById(token.signXmlID);
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var signid = document.getElementById(token.signID).value;
    var signedids = document.getElementById(token.signedIDs).value;
    var strSubject = document.getElementById(token.subject).value;

    // 檢核是否插入Token

    appendLog("detectToken...");
    if (!detectToken()) {
      return false;
    }
    // 插拔測試
    if (token.replug) {
      appendLog("plugToken...");
      if (plugToken()) {
        //pinToken();
        appendLog("detectToken...");

        if (!detectToken()) {
          return false;
        }
      } else {
        return false;
      }
    }
    // 密碼長度+PIN碼檢核規則
    var loginFlag = pinpadMode(pinpad);
    appendLog("loginFlag..." + loginFlag);

    try {
      eSphinxObj.SetPasswordLength(token.pwdMaxLength);

      if (token.flagCheckPasswd || isESunCert(strSubject)) {
        loginFlag = loginFlag | CGP11_FLAG_CHECK_PASSWD;
      }
    } catch (err) {
      // Do Nothing
      console.log("err..." + err, err);
      appendLog("err..." + err);
      return false;
    }

    // P11登入
    appendLog("p11Login...");
    if (!p11Login("", TYPE_USER, loginFlag)) {
      appendLog("p11Login return false...");
      return false;
    }

    var selectFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_CHECKVALID;
    var iKeyUsage = CG_KU_DIGITAL_SIGNATURE | CG_KU_NON_REPUDIATION;
    // 選擇憑證

    appendLog("selectFlags..." + selectFlags);
    if (!p11SelectCert(selectFlags, strSubject, iKeyUsage)) {
      appendLog("p11SelectCert return false...");
      return false;
    }

    var iFlags = 0;
    // ignid=IFXSIG,signedids=SignOnRq,PaySvcRq

    appendLog(
      "7=xml_string=[" +
        xml_string.value +
        "],signid=" +
        signid +
        ",signedids=" +
        signedids +
        ",iFlags=" +
        iFlags
    );
    // 使用全景簽章元件,並帶入參數,所回傳值的型態是BSTR(UniCode)

    // console.log('selectFlags...'+selectFlags);

    var SignData = eSphinxObj.P11IFXSign(
      xml_string.value,
      signid,
      signedids,
      iFlags
    );

    // 判斷簽章成功與否,如果有成功則回傳簽完成的原文加簽章,不成功則使用元件回傳錯誤代碼!
    var rtn = eSphinxObj.GetErrorCode();

    appendLog("rtn====" + rtn);
    // P11登出
    p11Logout();

    if (rtn != CG_RTN_SUCCESS) {
      appendLog("not success====" + rtn);
      global_rtn = rtn;
      ////alert(CGErrCodes(rtn));
      return false;
    } else {
      appendLog(" success====" + SignData);
      signXml.value = SignData;
    }
    appendLog(" CG_RTN_SUCCESS====" + CG_RTN_SUCCESS);
    global_rtn = CG_RTN_SUCCESS;
    return true;
  }

  // FEDI 資料分隔字元
  var FEDI_MESSAGE_SPLIT_WORD = "~FEDI~";

  // FEDI驗章
  function verifyFedi(disableRePlug, pinpad) {
    // 元件偵測
    if (!detectPlugin()) {
      return false;
    }

    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    // 檢核是否插入Token
    if (!detectToken()) {
      return false;
    }
    // 插拔測試
    if (token.replug) {
      if (plugToken()) {
        //pinToken();
        if (!detectToken()) {
          return false;
        }
      } else {
        return false;
      }
    }

    //呼叫全景ActiveX 元件 Sign FEDI
    var signFedi = document.getElementById(token.orgXmlID).value;
    var subject = document.getElementById(token.subject).value;
    var issuer = "";
    var iKeyUsage = 0;
    var rtnCode = 0;

    // 密碼長度+PIN碼檢核規則
    var loginFlag = pinpadMode(pinpad);

    try {
      eSphinxObj.SetPasswordLength(token.pwdMaxLength);

      if (token.flagCheckPasswd || isESunCert(subject)) {
        loginFlag = loginFlag | CGP11_FLAG_CHECK_PASSWD;
      }
    } catch (err) {
      // Do Nothing
    }

    // P11登入
    if (!p11Login("", TYPE_USER, loginFlag)) {
      return false;
    }

    var selectFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_CHECKVALID;
    var iKeyUsage = CG_KU_DIGITAL_SIGNATURE | CG_KU_NON_REPUDIATION;
    // 選擇憑證
    if (!p11SelectCert(selectFlags, subject, iKeyUsage)) {
      return false;
    }

    //判斷是否為多筆傳送
    var signResult = "";
    //組合方式為  ( FEDI_MESSAGE_SPLIT_WORD + Key + FEDI_MESSAGE_SPLIT_WORD + EDI ) REPEAT
    var splitSignFEDI = signFedi.split(FEDI_MESSAGE_SPLIT_WORD);

    for (i = 1; i < splitSignFEDI.length; i++) {
      if (i % 2 == 1) {
        signResult = signResult + FEDI_MESSAGE_SPLIT_WORD + splitSignFEDI[i];
      } else {
        var signature = eSphinxObj.P11FEDISign(splitSignFEDI[i], 0);
        rtnCode = eSphinxObj.GetErrorCode();

        if (rtnCode != 0) {
          global_rtn = eSphinxObj.GetErrorCode();
          //alert(CGErrCodes(eSphinxObj.GetErrorCode()));
          return false;
        }

        signResult = signResult + FEDI_MESSAGE_SPLIT_WORD + signature;
      }
    }

    // P11登出
    p11Logout();

    if (signResult == "") {
      global_rtn = FSP11_RTN_UNKNOW_ERROR;
      //alert(CGErrCodes(FSP11_RTN_UNKNOW_ERROR) + '(' + FSP11_RTN_UNKNOW_ERROR + ')');
      return false;
    } else {
      //把簽署的結果放進 signXml 傳回Server
      document.getElementById(token.signXmlID).value = signResult;
      global_rtn = CG_RTN_SUCCESS;
      return true;
    }
  }

  // 跨交易簽章
  function verifyMultiXml(disableRePlug, pinpad) {
    // 元件偵測
    if (!detectPlugin()) {
      return false;
    }

    // 檢核是否插入Token
    if (!detectToken()) {
      return false;
    }
    // 插拔測試
    if (token.replug) {
      if (plugToken()) {
        //pinToken();
        if (!detectToken()) {
          return false;
        }
      } else {
        return false;
      }
    }

    var xml_string = document.getElementById(token.orgXmlID);
    // Parse IFX & FEDI XML
    var ifxXml = "";
    var fediXml = "";

    var ifxIndex = -1;
    var fediIndex = -1;

    var start = 0;
    var end = 0;

    var tmp = xml_string.value;

    while (tmp.length > 0) {
      ifxIndex = tmp.indexOf(IFX_MESSAGE_SPLIT_WORD);
      fediIndex = tmp.indexOf(FEDI_MESSAGE_SPLIT_WORD);

      if (ifxIndex == 0) {
        start = ifxIndex;
        end = fediIndex == -1 ? tmp.length : fediIndex;

        ifxXml += tmp.substring(start, end);
        tmp = tmp.substring(end);
        continue;
      }

      if (fediIndex == 0) {
        start = fediIndex;
        end = ifxIndex == -1 ? tmp.length : ifxIndex;

        fediXml += tmp.substring(start, end);
        tmp = tmp.substring(end);
        continue;
      }
    }
    // Sign XML
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var signid = document.getElementById(token.signID).value;
    var signedids = document.getElementById(token.signedIDs).value;
    var subject = document.getElementById(token.subject).value;
    var signResult = "";
    var issuer = "";
    var iKeyUsage = 0;
    var rtnCode = 0;

    // 密碼長度+PIN碼檢核規則
    var loginFlag = pinpadMode(pinpad);

    try {
      eSphinxObj.SetPasswordLength(token.pwdMaxLength);

      if (token.flagCheckPasswd || isESunCert(subject)) {
        loginFlag = loginFlag | CGP11_FLAG_CHECK_PASSWD;
      }
    } catch (err) {
      // Do Nothing
    }

    // P11登入
    if (!p11Login("", TYPE_USER, loginFlag)) {
      return false;
    }

    var selectFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_CHECKVALID;
    var iKeyUsage = CG_KU_DIGITAL_SIGNATURE | CG_KU_NON_REPUDIATION;
    // 選擇憑證
    if (!p11SelectCert(selectFlags, subject, iKeyUsage)) {
      return false;
    }

    if (ifxXml.length > 0) {
      var splitSignIFX = ifxXml.split(IFX_MESSAGE_SPLIT_WORD);

      for (i = 1; i < splitSignIFX.length; i++) {
        var signature = eSphinxObj.P11IFXSign(
          splitSignIFX[i],
          signid,
          signedids,
          0
        );
        rtnCode = eSphinxObj.GetErrorCode();

        if (rtnCode != 0) {
          global_rtn = eSphinxObj.GetErrorCode();
          //alert(CGErrCodes(eSphinxObj.GetErrorCode()));
          return false;
        }

        signResult += IFX_MESSAGE_SPLIT_WORD + signature;
      }
    }

    if (fediXml.length > 0) {
      var splitSignFEDI = fediXml.split(FEDI_MESSAGE_SPLIT_WORD);

      for (i = 1; i < splitSignFEDI.length; i++) {
        if (i % 2 == 1) {
          signResult = signResult + FEDI_MESSAGE_SPLIT_WORD + splitSignFEDI[i];
        } else {
          var signature = eSphinxObj.P11FEDISign(splitSignFEDI[i], 0);
          rtnCode = eSphinxObj.GetErrorCode();

          if (rtnCode != 0) {
            global_rtn = eSphinxObj.GetErrorCode();
            //alert(CGErrCodes(eSphinxObj.GetErrorCode()));
            return false;
          }

          signResult = signResult + FEDI_MESSAGE_SPLIT_WORD + signature;
        }
      }
    }

    // P11登出
    p11Logout();

    if (signResult == "") {
      global_rtn = FSP11_RTN_UNKNOW_ERROR;
      //alert(CGErrCodes(FSP11_RTN_UNKNOW_ERROR) + '(' + FSP11_RTN_UNKNOW_ERROR + ')');
      return false;
    } else {
      //把簽署的結果放進 signXml 傳回Server
      document.getElementById(token.signXmlID).value = signResult;
      global_rtn = CG_RTN_SUCCESS;
      return true;
    }
  }

  // 密碼鍵盤
  function pinpadMode(iMode) {
    if (typeof iMode == "undefined" || iMode == null) {
      iMode = PINPAD_KEYBOARD;
    }

    var iFlag = null;

    switch (iMode) {
      case NO_PINPAD:
        iFlag = CGP11_FLAG_PASSWD_KEYBOARD;
        break;
      case PINPAD_KEYBOARD:
        iFlag =
          CGP11_FLAG_PASSWD_KEYBOARD |
          CGP11_FLAG_PASSWD_KEYPAD |
          CGP11_FLAG_PASSWD_KEYBOARD_RANDOM_LETTER |
          CGP11_FLAG_CHECK_PASSWD;
        break;
      case PINPAD_ONLY:
        iFlag =
          CGP11_FLAG_PASSWD_KEYPAD | CGP11_FLAG_PASSWD_KEYBOARD_RANDOM_LETTER;
        break;
    }

    return iFlag;
  }

  // 載具初始化
  function initToken(
    id1,
    ido,
    id2,
    id3,
    id4,
    id5,
    checkPassword,
    lang,
    osType,
    bNPAPI
  ) {
    token = {
      driverName: "",
      objID: id1,
      orgXmlID: ido,
      signXmlID: id2,
      signID: id3,
      signedIDs: id4,
      subject: id5,
      flagCheckPasswd: checkPassword,
      replug: true,
      os: osType,
      pwdMaxLength: 10, // fix UAT #62027 ServiSign initToken 密碼長度檢核 長度放寬到 10 碼
      useNPAPI: bNPAPI,
    };

    // i18n
    return i18n(lang);
  }

  // 多國語系設定
  function i18n(lang) {
    // 簡中：GB
    // 英文：english
    // 繁中：big5
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }

    if (typeof eSphinxObj.GetErrorCode === "function") {
      global_rtn = eSphinxObj.GetErrorCode();
      if (
        global_rtn === SERVI_SIGN_RTN_CONNECTION_ERROR ||
        global_rtn === SERVI_SIGN_DISCONNECT_ERROR
      ) {
        return false;
      }
    }

    eSphinxObj.SetLanguage(lang);

    return true;
  }

  function getP11CN() {
    var data = "";
    var rtn;
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return "";
    }
    if (detectToken()) {
      eSphinxObj.P11Init(token.driverName);
      rtn = eSphinxObj.GetErrorCode();
      if (rtn != CG_RTN_SUCCESS) {
        global_rtn = rtn;
        return "";
      }

      eSphinxObj.P11SetCurrentSlot(0);
      rtn = eSphinxObj.GetErrorCode();
      if (rtn != CG_RTN_SUCCESS) {
        eSphinxObj.P11Final();
        global_rtn = rtn;
        return "";
      }

      eSphinxObj.P11SessionOpen();
      rtn = eSphinxObj.GetErrorCode();
      if (rtn != CG_RTN_SUCCESS) {
        eSphinxObj.P11Final();
        global_rtn = rtn;
        return "";
      }

      data = p11GetCN();
      rtn = eSphinxObj.GetErrorCode();
      if (rtn != CG_RTN_SUCCESS) {
        global_rtn = rtn;
      }
      // 將使用者登出
      p11Logout(true, true);
    }
    global_rtn = CG_RTN_SUCCESS;
    return data;
  }

  // 載具種類判斷
  function pinToken() {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return null;
    }
    var rtn1;
    var rtn2;
    var rtn3;
    var rtn4;

    rtn1 = eSphinxObj.DetectToken("ikey2032");
    rtn2 = eSphinxObj.DetectToken("e-gate");
    rtn3 = eSphinxObj.DetectToken("eToken");

    if (!rtn1 + !rtn2 + !rtn3 > 1) {
      // 載具重複
      return new Array(rtn1, rtn2, rtn3);
    } else if (rtn1 == CG_RTN_SUCCESS) {
      token.driverName = DRIVER_IKEY;
      return [rtn1];
    } else if (rtn2 == CG_RTN_SUCCESS) {
      eSphinxObj.P11Init(DRIVER_SLB);
      rtn3 = eSphinxObj.GetErrorCode();
      eSphinxObj.P11Final();

      eSphinxObj.P11Init(DRIVER_MS);
      rtn4 = eSphinxObj.GetErrorCode();
      eSphinxObj.P11Final();
      // console.log('rtn2 is sucess....' + rtn2);
      // console.log('rtn3 is sucess....' + rtn3);
      if (rtn3 == CG_RTN_SUCCESS && rtn4 == CG_RTN_SUCCESS) {
        // 載具重複
        return [rtn3, rtn4];
      } else if (rtn3 == CG_RTN_SUCCESS) {
        // 前三代的egate
        token.driverName = DRIVER_SLB;
        return [rtn3];
      } else if (rtn4 == CG_RTN_SUCCESS) {
        // 第四代以後的egate
        token.driverName = DRIVER_MS;
        return [rtn4];
      } else {
        // Error
        token.driverName = "";
        return null;
      }
    } else if (rtn3 == CG_RTN_SUCCESS) {
      // eToken

      if (mac) {
        token.driverName = DRIVER_ETOKEN_MAC;
      } else {
        token.driverName = DRIVER_ETOKEN_WIN;
      }

      return [rtn3];
    } else {
      // Not Found
      token.driverName = "";
      return null;
    }
  }

  // 載具偵測
  function detectToken() {
    var rtn = pinToken();

    if (rtn == null) {
      // 無插入任何載具
      if (plugToken()) {
        token.replug = false;

        rtn = pinToken();

        if (token.driverName == "") {
          if (token.os == "win64") {
            global_rtn = NOT_SUPPORT_64BIT;
            //alert(CGErrCodes(NOT_SUPPORT_64BIT));
          }
          if (token.os == "mac") {
            global_rtn = NOT_SUPPORT_TOKEN;
            //alert(CGErrCodes(NOT_SUPPORT_TOKEN));
          } else {
            // win32
            global_rtn = DRIVER_NOT_FOUND;
            //alert(CGErrCodes(DRIVER_NOT_FOUND));
          }

          return false;
        }

        return rtn != null && rtn.length == 1;
      } else {
        return false;
      }
    } else {
      // 僅插入一種
      if (rtn.length == 1) {
        if (rtn[0] == CG_RTN_SUCCESS) {
          global_rtn = CG_RTN_SUCCESS;
          return true;
        } else {
          // Error
          //alert(CGErrCodes(rtn[0]));
          global_rtn = rtn[0];
          return false;
        }
      } // 插入多種
      else {
        //alert(CGErrCodes(MULTIPLE_TOKEN));
        global_rtn = MULTIPLE_TOKEN;
        return false;
      }
    }
  }

  // Event Handler Attach
  function addEventHandler(elmObj, eventType, handlerFunction) {
    // Error Check
    if (!elmObj || eventType == "" || !handlerFunction) {
      return;
    }

    if (elmObj.addEventListener) {
      /* W3C */
      // Event Check
      eventType = eventType.toLowerCase();

      if (eventType.substr(0, 2) == "on") {
        eventType = eventType.substring(2);
      }

      elmObj.addEventListener(eventType, handlerFunction, false);
    } else if (elmObj.attachEvent) {
      // IE
      // Event Check
      eventType = eventType.toLowerCase();

      if (eventType.substr(0, 2) != "on") {
        eventType = "on" + eventType;
      }

      elmObj.attachEvent(eventType, handlerFunction);
    } else {
      /* OLDER BROWSERS (DOM0) */
      // Event Check
      eventType = eventType.toLowerCase();

      if (eventType.substr(0, 2) != "on") {
        eventType = "on" + eventType;
      }

      elmObj[eventType] = handler;
    }
  }

  // 載具拔插
  function plugToken() {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var replugTime = 60;

    if (replugTime > 0) {
      var wait = 5;
      replugTime = wait * 256 + replugTime;
    }

    eSphinxObj.DetectReplug("", CG_FLAG_USE_REPLUG2, replugTime);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn == CG_RTN_SUCCESS) {
      global_rtn = CG_RTN_SUCCESS;
      return true;
    } else {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));

      return false;
    }
  }

  // 是否為玉山憑證
  function isESunCert(subject) {
    // Ref. VAProxy.getVerifySubject(String, String, RAProxy)
    return !/\n[^\n]+\n$/.test(subject);
  }

  // 擷取 Subject 內 CN
  function getSubjectCN(subject) {
    var cn = subject.match("^CN=.*\n");
    ////alert(cn);
    return cn ? cn : "";
  }

  // 元件P11初始化+登入
  function p11Login(pin, type, flag) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }

    var rtn = null;

    try {
      eSphinxObj.P11Final();
    } catch (e) {}

    eSphinxObj.P11Init(token.driverName);
    rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      p11Logout(false, false);
      return false;
    }

    eSphinxObj.P11SetCurrentSlot(0);
    rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      p11Logout(false, false);
      return false;
    }

    eSphinxObj.P11SessionOpen();
    rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      p11Logout(false, false);
      return false;
    }

    // console.log('1...7........[' + pin + '],[type]=' + type + ',[flag]=' + flag);
    if (
      typeof pin !== "undefined" &&
      typeof type !== "undefined" &&
      typeof flag !== "undefined"
    ) {
      eSphinxObj.P11Login(pin, type, flag);
      rtn = eSphinxObj.GetErrorCode();

      if (rtn != CG_RTN_SUCCESS) {
        global_rtn = rtn;
        //alert(CGErrCodes(rtn));
        p11Logout(true, false);
        return false;
      }
    }
    global_rtn = CG_RTN_SUCCESS;
    return true;
  }

  // 選擇憑證
  function p11SelectCert(selectFlags, subject, iKeyUsage, label, skipErr) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var sLabel = label ? label : "";
    var sSubject = subject ? getSubjectCN(subject) : "";
    var sIssuer = "";
    var iP11Flags = selectFlags
      ? selectFlags
      : CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_CHECKVALID;
    var iP11KeyUsage = iKeyUsage ? iKeyUsage : 0;
    eSphinxObj.P11SelectCert(
      sLabel,
      sSubject.toString(),
      sIssuer,
      iP11Flags,
      iP11KeyUsage
    );

    if (skipErr) {
      return true;
    }

    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return false;
    }
    global_rtn = CG_RTN_SUCCESS;
    return true;
  }

  // 取得卡片中的CN
  function p11GetCN() {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return "";
    }
    var data = eSphinxObj.P11ReadData("CN", 0, 0);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return "";
    } else {
      return data;
    }
  }

  // 取得卡片中的SN
  function p11GetSN() {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return "";
    }
    var data = eSphinxObj.P11GetSerialNumber();
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return "";
    } else {
      return data;
    }
  }

  // 元件P11登出+關閉
  function p11Logout(open, login) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return;
    }
    var rtn = null;

    if (typeof login == "undefined" || login) {
      eSphinxObj.P11Logout();
    }

    if (typeof open == "undefined" || open) {
      eSphinxObj.P11SessionClose();
    }

    eSphinxObj.P11Final();
  }

  // P7簽章
  function p7Sign(csr) {
    // 選擇憑證
    var selectFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_CHECKVALID;

    if (!p11SelectCert(selectFlags)) {
      return "";
    }

    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return "";
    }
    var sign = eSphinxObj.P11Sign(csr, 0);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return "";
    } else {
      return sign;
    }
  }

  // 驗卡簽章
  function p11PureSign(data) {
    // 選擇憑證
    p11SelectCert(0, "", 0, "CMS_AUTH_KEY", true);

    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return "";
    }
    var sign = eSphinxObj.P11PureSign(
      data,
      CG_FLAG_DOHASH | CG_FLAG_HEX_ENCODE
    );
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return "";
    }

    return sign;
  }

  // 刪除垃圾金鑰
  function p11DelDirtyData() {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var rtn = eSphinxObj.P11DeleteNoCertRSAKey("CMS_AUTH_KEY");

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return false;
    } else {
      global_rtn = CG_RTN_SUCCESS;
      return true;
    }
  }

  // 載具密碼變更
  function p11ChgPassword(oldPwd, newPwd) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    // 登入
    if (!p11Login(oldPwd, TYPE_USER, pinpadMode())) {
      return false;
    }

    // 變更
    var rtn = eSphinxObj.P11ChangePin(oldPwd, newPwd, TYPE_USER, 0);
    var isSucess = false;

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
    } else {
      global_rtn = CG_RTN_SUCCESS;
      isSucess = true;
    }

    // 登出
    p11Logout();

    return isSucess;
  }

  // 憑證匯入
  function p11SaveCert(cert) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    eSphinxObj.P11AcceptCert(cert, 0);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return false;
    } else {
      global_rtn = CG_RTN_SUCCESS;
      return true;
    }
  }

  // 憑證匯入(匯入成功後會刪除多的憑證)  Sora
  function p11SaveCertEx(cert) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    eSphinxObj.P11AcceptCert(cert, 0);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return false;
    } else {
      //憑證下載成功,開始檢查憑證,刪除失敗回傳-1

      var certCount = eSphinxObj.P11GetObjectList(CGP11_CERTIFICATE_OBJECT);
      var rtn = eSphinxObj.GetErrorCode();

      if (rtn != CG_RTN_SUCCESS) {
        global_rtn = rtn;
        //alert(CGErrCodes(rtn));
        return false;
      } else {
        if (certCount > 3) {
          var selectFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_OLDEST;
          if (p11SelectCert(selectFlags)) {
            eSphinxObj.P11DeleteUsrCert();
            var rtn = eSphinxObj.GetErrorCode();
            if (rtn != CG_RTN_SUCCESS) {
              global_rtn = rtn;
              //alert(CGErrCodes(rtn));
              return false;
            }
            return true;
          } else {
            return false;
          }
        }
        global_rtn = CG_RTN_SUCCESS;
        return true;
      }
      global_rtn = CG_RTN_SUCCESS;
      return true;
    }
  }

  // 產生憑證請求檔(CSR)
  function p11GenCSR(sCN, keyLabel) {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return "";
    }
    var subject =
      sCN == "" ? sCN : "O=Finance\nOU=8080000-RA-CIB001\nC=TW\nCN=" + sCN;

    var iFlags =
      CGP11_FLAG_WRAP | CGP11_FLAG_UNWRAP | CGP11_FLAG_EXTRACTABLE_NONE;
    var iHashFlag = CG_ALGOR_SHA256;

    var csr = eSphinxObj.P11GenerateCertRequest(
      keyLabel,
      keyLabel,
      keyLabel,
      keyLabel,
      2048,
      subject,
      iFlags,
      iHashFlag
    );
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      if (
        rtn == FSP11_RTN_ATTRIBUTE_VALUE_INVALID ||
        rtn == FSP11_RTN_DEVICE_MEMORY
      ) {
        // 訊息轉換
        return "9017";
      }
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return "";
    }

    return csr;
  }

  // 列舉卡片中有幾張憑證(錯誤回傳 -1)
  function p11CountCert() {
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var certCount = eSphinxObj.P11GetObjectList(CGP11_CERTIFICATE_OBJECT);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return false;
    } else {
      return certCount;
    }
  }

  // 刪除過期憑證
  function deleteExpiredCert(expiredDateTime) {
    // 預設 有過期憑證
    var hasExpiredCert = true;

    // 重複執行直到沒有符合條件的憑證
    do {
      var label = "";
      var subject = "";
      var issuer = "";
      // P11SelectCert，透過此API將找出載具內最舊的憑證
      var iFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_OLDEST;
      //修正iFlags 帶第一個參數 eSphinxObj.P11SelectCert api 帶第4個
      p11SelectCert(iFlags, subject, issuer, label, 0);
      var eSphinxObj = getESphinxObj();
      if (eSphinxObj == null) {
        return false;
      }
      var rtnCode = eSphinxObj.GetErrorCode();
      if (rtnCode != CG_RTN_SUCCESS) {
        global_rtn = rtnCode;
        return false;
      }

      // GetCertificate，取得憑證資訊
      var cert = eSphinxObj.GetCertificate();
      var rtnCode = eSphinxObj.GetErrorCode();
      if (rtnCode != CG_RTN_SUCCESS) {
        global_rtn = rtnCode;
        return false;
      }

      // CryptCertGetNotAfter，取得憑證資訊中之載具到期日
      var notafter = eSphinxObj.CryptCertGetNotAfter(cert, 0);
      var rtnCode = eSphinxObj.GetErrorCode();
      if (rtnCode != CG_RTN_SUCCESS) {
        global_rtn = rtnCode;
        return false;
      }

      // 憑證到期日
      var Year = notafter.substring(0, 4);
      var Month = notafter.substring(4, 6);
      var Day = notafter.substring(6, 8);
      notafter = Year + "/" + Month + "/" + Day + " 23:59:59";

      // 比對「憑證到期日」若早於「指定日期」(即過期憑證)則執行憑證刪除(P11DeleteUsrCert)
      if (
        Date.parse(expiredDateTime).valueOf() > Date.parse(notafter).valueOf()
      ) {
        // 憑證刪除
        eSphinxObj.P11DeleteUsrCert();
        var rtnCode = eSphinxObj.GetErrorCode();
        if (rtnCode != CG_RTN_SUCCESS) {
          global_rtn = rtnCode;
          return false;
        }
      } else {
        // 無過期憑證
        hasExpiredCert = false;
      }
    } while (hasExpiredCert);
    return true;
  }

  // 刪除多餘舊憑證
  function p11DelOldCert() {
    var selectFlags = CGP11_FLAG_SELCERT_AUTO | CGP11_FLAG_SELCERT_OLDEST;

    if (p11SelectCert(selectFlags)) {
      var eSphinxObj = getESphinxObj();
      if (eSphinxObj == null) {
        return false;
      }
      eSphinxObj.P11DeleteUsrCert();
      var rtn = eSphinxObj.GetErrorCode();

      if (rtn != CG_RTN_SUCCESS) {
        global_rtn = rtn;
        //alert(CGErrCodes(rtn));
        return false;
      }
      global_rtn = CG_RTN_SUCCESS;
      return true;
    } else {
      return false;
    }
  }

  // 當安裝ActiveX錯誤時顯示以下訊息
  function installActiveXError() {
    global_rtn = ACTIVEX_LOAD_FAIL;
    //alert(CGErrCodes(ACTIVEX_LOAD_FAIL));
    return false;
  }

  // 元件安裝偵測
  function detectPlugin() {
    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > 0
    ) {
      // MSIE navigator.platform
      global_rtn = CG_RTN_SUCCESS;
      return true;
    } else if (navigator.platform.indexOf("Win") !== -1) {
      // Windows non-IE
      global_rtn = CG_RTN_SUCCESS;
      return true;
    } else {
      // Mac...
      global_rtn = CG_RTN_SUCCESS;
      return true;
    }
  }

  // 線上解卡
  function p11Unlock(serverKey, transportKey, userPin) {
    // debugger;
    var eSphinxObj = getESphinxObj();
    if (eSphinxObj == null) {
      return false;
    }
    var hexUserPin = eSphinxObj.HexEncode(userPin);

    eSphinxObj.P11SetUserPIN(serverKey, transportKey, hexUserPin, 0);
    var rtn = eSphinxObj.GetErrorCode();

    if (rtn != CG_RTN_SUCCESS) {
      global_rtn = rtn;
      //alert(CGErrCodes(rtn));
      return false;
    }
    global_rtn = CG_RTN_SUCCESS;
    return true;
  }

  function getESphinxObj() {
    // NPAPI
    if (token.useNPAPI == true) {
      if (ATLADPTObj == null) {
        if (mac) {
          ATLADPTObj = esunCryptModule.getESBXMLP11AdapterObj();
        } else {
          ATLADPTObj = esunCryptModule.getESUNCGP11CryptoATLADPTObj();
        }

        if (ATLADPTObj == null || typeof ATLADPTObj == "undefined") {
          global_rtn = DRIVER_NOT_FOUND;
          //alert(CGErrCodes(DRIVER_NOT_FOUND));
          return null;
        }
      }

      return ATLADPTObj;
    }
    // ActiveX or Applet
    else {
      return document.getElementById(
        document.getElementById(token.objID).value
      );
    }
  }

  function getSignData() {
    appendLog("token.signXmlID==" + token.signXmlID);
    var xml_string = document.getElementById(token.signXmlID);
    appendLog("xml_string==" + xml_string);
    return xml_string.value;
  }

  function CGErrCodes(errcode) {
    // Reset
    token.replug = true;
    //  alert(errcode);
    switch (errcode) {
      case CG_RTN_SUCCESS:
        return "執行成功";
      case EOI_RTN_ERROR:
        return "執行失敗";
      case EOI_RTN_OPENFILE_ERROR:
        return "檔案開啟失敗";
      case EOI_RTN_CRYPT_ERROR:
        return "IC卡存取錯誤";
      case EOI_RTN_APP_ERROR:
        return "碼別轉換錯誤或應用程式錯誤";
      case EOI_RTN_INVALID_FEDICERT:
        return "錯誤的憑證";
      case EOI_RTN_GETFEDIX509_ERROR:
        return "憑證解析失敗";
      case EOI_RTN_GETPUBKEY_ERROR:
        return "取公鑰失敗";
      case EOI_RTN_INVALID_CAPRIPK:
        return "錯誤的CA憑證";
      case EOI_RTN_VERIFYCACERT_ERROR:
        return "不合法的CA憑證";
      case EOI_RTN_VERIFYUSERCERT_ERROR:
        return "不合法的使用者憑證";
      case EOI_RTN_P11_NOTLOGIN:
        return "P11未登入";
      case EOI_RTN_KEY_NOTMATCH:
        return "金鑰不符合";
      case EOI_RTN_READ_PUBKEY_ERROR:
        return "公鑰讀取錯誤";
      case EOI_RTN_ENCRYPT_ERROR:
        return "加密失敗";
      case EOI_RTN_SET_PRIKEY_ERROR:
        return "私鑰設定錯誤";
      case EOI_RTN_DECRYPT_ERROR:
        return "解密失敗";
      case EOI_RTN_SIGN_ERROR:
        return "簽章失敗";
      case EOI_RTN_VERIFY_ERROR:
        return "驗章失敗";
      case EOI_RTN_WRITE_ERROR:
        return "檔案寫入失敗";
      case EOI_RTN_READ_ERROR:
        return "憑證檔案讀取失敗";
      case EOI_RTN_P11_ERROR:
        return "PKCS#11函式庫錯誤";
      case EOI_RTN_P11INIT_ERROR:
        return "PKCS#11函式庫初始化錯誤";
      case EOI_RTN_P11_NOTOKEN:
        return "IC卡不存在";
      case EOI_RTN_P11OPEN_ERROR:
        return "IC卡開啟失敗";
      case EOI_RTN_P11PIN_INVALID:
        return "IC卡PIN碼錯誤";
      case EOI_RTN_P11DELETE_ERROR:
        return "IC卡刪除失敗";
      case EOI_RTN_P11GENKEY_ERROR:
        return "IC卡產生金鑰失敗";
      case EOI_RTN_P11MEM_ERROR:
        return "IC卡記憶體錯誤";
      case EOI_RTN_P11PIN_LOCKED:
        return "IC卡鎖定";
      case EOI_RTN_MEMALLOC_ERROR:
        return "記憶體配置錯誤";
      case EOI_RTN_TWCA_2401:
        return "認證密碼錯誤";
      case EOI_RTN_TWCA_2404:
        return "未註冊用戶";
      case EOI_RTN_TWCA_2406:
        return "憑證尚未簽發";
      case EOI_RTN_TWCA_2420:
        return "憑證已經終止";
      case EOI_RTN_TWCA_2421:
        return "找不到憑證";
      case EOI_RTN_TWCA_2710:
        return "憑證已經展期或更新";
      case EOI_RTN_TWCA_2802:
        return "CA系統繁忙中，請稍候再試";
      case EOI_RTN_INVALID_PARAM:
        return "傳入參數錯誤";
      case EOI_RTN_WININET_ERROR:
        return "網路錯誤";
      case EOI_RTN_INVALID_FORMAT:
        return "參數格式錯誤";
      case EOI_RTN_LIBRARY_EXPIRED:
        return "程式庫過期";
      case EOI_RTN_CODEC_ERROR:
        return "碼別轉換錯誤";
      case EOI_RTN_BASE64_ERROR:
        return "Base64編碼錯誤";
      case EOI_RTN_WSTR2MCHAR_ERROR:
        return "Unicode轉ASCII轉換錯誤";
      case EOI_RTN_MCHAR2WSTR_ERROR:
        return "ASCII轉Unicode轉換錯誤";
      case CG_RTN_CMS_CARD_ISSUED:
        return "卡片已發出給使用者";
      case CG_RTN_CMS_CARD_CLEANED_OR_NO_USER:
        return "已清卡或是無此使用者";
      case CG_RTN_CMS_USER_EXIST:
        return "使用者已存在";
      case CG_RTN_CMS_DB_ERROR:
        return "資料庫錯誤";
      case CG_RTN_CMS_KEY_LENGTH_ERROR:
        return "金鑰長度不合";
      case CG_RTN_CMS_MAKE_MD5_DIGEST_ERROR:
        return "產生MD5摘要值錯誤";
      case CG_RTN_CMS_MAC_NOT_MATCH:
        return "MAC值比對失敗";
      case VB_OBJECT_REQUIRED:
        return "此處需要元件";
      case VB_OBJECT_DOES_NOT_SUPPORT:
        return "物件不支援此屬性或方法";
      case API_RTN_ACCESS_DENIED:
        return "元件存取被拒";
      case API_RTN_USER_CANCEL:
        return "使用者取消動作";
      case API_RTN_GENMAC_FAIL:
        return "產生MAC值失敗";
      case API_RTN_LABEL_NOT_EXIST:
        return "Label值不存在";
      case API_RTN_PARAMETER_EMPTY:
        return "該參數不可為空值";
      case API_RTN_PARAMETER_FORMAT_ERROR:
        return "參數格式錯誤";
      case API_RTN_INVALID_ENCODING:
        return "不合法的編碼方法";
      case API_RTN_FORMAT_ERROR:
        return "回傳訊息格式有問題, 無法解析";
      case API_RTN_NO_DATA:
        return "沒有回傳值";
      case API_RTN_NEWPIN_AND_REPEATPIN_NOT_MATCH:
        return "新PIN碼與舊PIN碼相同";
      case API_RTN_NEW_PIN_LENGTH_ERROR:
        return "新PIN碼長度不符";
      case API_RTN_NEWPIN_EQUAL_OLDPIN:
        return "新PIN碼與舊PIN碼相同";
      case API_RTN_NEWPIN_NO_NUMBER:
        return "新PIN碼未包含數字";
      case API_RTN_NEWPIN_NO_CAPITALLETTER:
        return "新PIN碼未包含大寫英文";
      case API_RTN_NEWPIN_NO_SMALLLETTER:
        return "新PIN碼未包含小寫英文";
      case API_RTN_NEWPIN_NO_SYMBOLMARK:
        return "新PIN碼未包含特殊符號";
      case API_RTN_NEWPIN_INCLUDE_SPACE:
        return "新PIN碼包含空白字元";
      case API_RTN_USER_NOT_FIRST_LOGIN:
        return "使用者非第一次登入";
      case API_RTN_LOGINCOUNT_CHANGED:
        return "Login Count已被其他系統更改過";
      case API_RTN_PARSE_ERROR:
        return "轉換錯誤";
      case API_RTN_NO_NEED_TO_DELETE:
        return "不需刪除憑證";
      case API_RTN_CONNECT_ERROR:
        return "網路連結錯誤";
      case CG_RTN_ERROR:
        return "一般性錯誤";
      case CG_RTN_MEMALLOC_ERROR:
        return "配置記憶體發生錯誤";
      case CG_RTN_BUFFER_TOO_SMALL:
        return "記憶體緩衝區太小";
      case CG_RTN_FUNCTION_UNSUPPORT:
        return "未支援函式";
      case CG_RTN_INVALID_PARAM:
        return "錯誤的參數";
      case CG_RTN_INVALID_HANDLE:
        return "無效的handle";
      case CG_RTN_LIB_EXPIRE:
        return "試用版函式庫已過期";
      case CG_RTN_BASE64_ERROR:
        return "Base64編碼解碼錯誤";
      case CG_RTN_CERT_NOT_FOUND:
        return "找不到憑證";
      case CG_RTN_CERT_EXPIRED:
        return "憑證已過期";
      case CG_RTN_CERT_NOT_YET_VALID:
        return "憑證時間尚未合法";
      case CG_RTN_CERT_EXPIRE_OR_NOT_YET_USE:
        return "憑證可能過期或無法使用";
      case CG_RTN_CERT_DENIED:
        return "憑證主旨錯誤";
      case CG_RTN_CERT_NOISSUER:
        return "無法找到憑證發行者";
      case CG_RTN_CERT_BAD_SIGNATURE:
        return "憑證上的簽章值是錯誤的";
      case CG_RTN_CERT_INVALID_KEYUSAGE:
        return "無效的憑證用途（加解密、簽驗章）";
      case CG_RTN_CERT_REVOKED:
        return "憑證已撤銷";
      case CG_RTN_CERT_KEY_COMPROMISED:
        return "憑證已撤銷（金鑰洩露）";
      case CG_RTN_CERT_CA_COMPROMISED:
        return "憑證已撤銷（CA compromised）";
      case CG_RTN_CERT_AFFILIATION_CHANGED:
        return "憑證已撤銷（聯盟已變更）";
      case CG_RTN_CERT_SUPERSEDED:
        return "憑證已撤銷（已取代）";
      case CG_RTN_CERT_CESSATION:
        return "憑證已撤銷（已停止）";
      case CG_RTN_CERT_HOLD:
        return "憑證保留或暫禁";
      case CG_RTN_CERT_REMOVEFROMCRL:
        return "憑證己撤銷（凍結）";
      case CG_RTN_CRL_EXPIRED:
        return "CRL 已過期";
      case CG_RTN_CRL_NOT_YET_VALID:
        return "CRL 尚未有效";
      case CG_RTN_CRL_NOT_FOUND:
        return "無法找到CRL";
      case CG_RTN_CRL_BAD_SIGNATURE:
        return "CRL上的簽章值無效";
      case CG_RTN_GET_DIGEST_ERROR:
        return "取得摘要值錯誤";
      case CG_RTN_BAD_SIGNATURE:
        return "不合法的簽章";
      case CG_RTN_BAD_CONTENT:
        return "內容錯誤";
      case CG_RTN_INVALID_CAPTCHA:
        return "圖形驗證碼錯誤";
      case CG_RTN_INVALID_CERT:
        return "憑證格式錯誤";
      case CG_RTN_INVALID_CRL:
        return "CRL 格式錯誤";
      case CG_RTN_INVALID_PKCS7:
        return "錯誤的PKCS7格式";
      case CG_RTN_INVALID_KEY:
        return "金鑰的格式錯誤";
      case CG_RTN_INVALID_CERTREQ:
        return "不合法的憑證請求檔格式(PKCS10)";
      case CG_RTN_INVALID_FORMAT:
        return "無效的格式";
      case CG_RTN_INVALID_PKCS12:
        return "無效的PKCS12格式";
      case CG_RTN_OBJ_NOT_FOUND:
        return "找不到指定物件，請至下載專區更新驅動程式 (第三、四、五代智慧卡驅動程式)";
      case CG_RTN_PKCS7_NO_CONTENT:
        return "簽章值中無原文";
      case CG_RTN_PKCS7_NO_CERTIFICATE:
        return "簽章值中無憑證";
      case CG_RTN_PKCS7_NO_SIGNERINFO:
        return "簽章值中無SignerInfo";
      case CG_RTN_UNMATCH_CERT_KEY:
        return "憑證與私密金鑰並非成對";
      case CG_RTN_SIGN_ERROR:
        return "簽章失敗";
      case CG_RTN_VERIFY_ERROR:
        return "驗章失敗";
      case CG_RTN_ENCRYPT_ERROR:
        return "加密失敗";
      case CG_RTN_DECRYPT_ERROR:
        return "解密失敗";
      case CG_RTN_GENKEY_ERROR:
        return "產生金鑰失敗";
      case CG_RTN_DELETE_USR_CERT_ERROR:
        return "刪除使用者憑證失敗";
      case CG_RTN_OPERATION_CANCELED:
        return "取消操作";
      case CG_RTN_PASSWD_INVALID:
        return "密碼不正確";
      case CG_RTN_PASSWORD_RULES_DENIED:
        return "輸入密碼不符合規則";
      case CG_RTN_SCARD_BLOCKED:
        return "Smart Card或者USB token已被鎖卡無法使用";
      case CG_RTN_REPLUG_TIMEOUT:
        return "卡片插拔逾時";
      case CG_RTN_NO_SCARD_SERVICE:
        return "Smart Card服務沒有啟動或者憑證載具裝置被停用";
      case CG_RTN_XMLPARSE_ERROR:
        return "XML文件格式錯誤";
      case CG_RTN_XMLTAG_NOTFOUND:
        return "XML標籤找不到";
      case CG_RTN_PKCS12_NO_AUTHSAFES:
        return "PKCS12不正確";
      case CG_RTN_PKCS12_DECODE_BAG_ERROR:
        return "PKCS12解碼失敗";
      case CG_RTN_PKCS12_DECRYPT_ERROR:
        return "PKCS12解密失敗";
      case CG_RTN_PKCS12_GETKEY_ERROR:
        return "PKCS12取得金鑰失敗";
      case CG_RTN_PKCS12_GETCERT_ERROR:
        return "PKCS12取得憑證失敗";
      case CG_RTN_INVALID_STATE:
        return "無效狀態";
      case CG_RTN_OUT_OF_RANGE:
        return "超出範圍";
      case FSCAPI_RTN_OPENSTORE_ERROR:
        return "無法開啟憑證儲存區";
      case FSCAPI_RTN_CREATECHAIN_ERROR:
        return "憑證鏈不存在";
      case FSCAPI_RTN_CRYPTCONTEXT_ERROR:
        return "無法開啟密碼模組(CSP)";
      case FSCAPI_RTN_NO_PRIVATE_KEY:
        return "找不到關聯的私密金鑰";
      case FSCAPI_RTN_UNEXPORTABLE:
        return "關聯的私密金鑰已被標記成不能匯出";
      case FSCAPI_RTN_STORE_ACCESSDENY:
        return "憑證儲存區存取被拒";
      case FSCRYPT_RTN_CRL_NOISSUER:
        return "CRL沒有發行者";
      case FSCRYPT_RTN_OCSP_NOSIGNATURE:
        return "OCSP沒有簽章值";
      case FSCRYPT_RTN_OCSP_NOSIGNCERT:
        return "OCSP沒有簽章憑證";
      case FSCRYPT_RTN_OCSP_NODATA:
        return "OCSP沒有原始資料";
      case FSCRYPT_RTN_OCSP_UNSUPPORTRESPONSE:
        return "OCSP回應不支援";
      case FSCRYPT_RTN_OCSP_INVALIDRESPONSE:
        return "OCSP無效的回應";
      case FSCRYPT_RTN_OCSP_NOMATCHCERTID:
        return "OCSP沒有對應的憑證編號";
      case FSCRYPT_RTN_OCSP_CERTSTATUS_UNKNOWN:
        return "OCSP未知的憑證狀態";
      case FSCRYPT_RTN_OCSP_INVALIDRESPID:
        return "OCSP無效的回應";
      case FSCRYPT_RTN_OCSP_INVALIDRESPNONCE:
        return "OCSP無效的回應";
      case FSCRYPT_RTN_OCSP_RSPSTATUS_INVALIDREQUEST:
        return "OCSP無效的請求";
      case FSCRYPT_RTN_OCSP_RSPSTATUS_INTERNALERROR:
        return "OCSP內部錯誤";
      case FSCRYPT_RTN_OCSP_RSPSTATUS_TRYLATER:
        return "OCSP忙碌中請稍後再試";
      case FSCRYPT_RTN_OCSP_RSPSTATUS_SIGREQUIRED:
        return "OCSP資料不完整";
      case FSCRYPT_RTN_OCSP_RSPSTATUS_UNAUTHORIZED:
        return "OCSP未授權";
      case FSCRYPT_RTN_OCSP_RSPSTATUS_UNKNOWN:
        return "OCSP未知的錯誤";
      case BAF_RTN_TIMEOUT:
        return "Socket 逾時";
      case CG_RTN_UNICODE_ERROR:
        return "Unicode錯誤";
      case CG_RTN_FILE_NOT_FOUND:
        return "找不到指定憑證載具";
      case CG_RTN_PATH_NOT_FOUND:
        return "找不到指定路徑";
      case CG_RTN_BAD_NETPATH:
        return "找不到指定網路路徑";
      case CG_RTN_LOGON_FAILURE:
        return "使用者登入帳號或密碼錯誤";
      case CG_RTN_ACCESS_DENIED:
        return "沒有權限存取";
      case CG_RTN_BAD_INITCODE:
        return "無效的initcode";
      case CG_RTN_INITCODE_NOT_VERIFY:
        return "元件尚未初始化";
      case RAF_RTN_ERROR:
        return "Servlet錯誤";
      case RAF_RTN_NO_DATA:
        return "Servlet沒有回傳任何資料";
      case RAF_RTN_INVALID_FORMAT:
        return "Servlet回傳資料型態或回傳格式錯誤";
      case RAF_RTN_CONNECT_ERROR:
        return "Servlet無法連結";
      case API_RTN_ACCESS_DENIED2:
        return "元件存取被拒";
      case SERVI_SIGN_RTN_CONNECTION_ERROR:
        return "您尚未安裝或未啟動ServiSign程式";
      case SERVI_SIGN_DISCONNECT_ERROR:
        return "您尚未安裝或未啟動ServiSign程式";
      case SERVER_RTN_GENERAL_ERROR:
        return "一般性失敗";
      case SERVER_RTN_ARGUMENT_MISSING:
        return "缺少需要的參數";
      case SERVER_RTN_ARGUMENT_ILLEGALE:
        return "不合法的參數";
      case SERVER_RTN_CONNECT_RA_ERROR:
        return "連線到 RA 失敗";
      case SERVER_RTN_CONNECT_CA_ERROR:
        return "連線到CA失敗";
      case SERVER_RTN_PERM_USEKEY_DENIED:
        return "不具有使用此金鑰的權限";
      case SERVER_RTN_PERM_USEFUNC_DENIED:
        return "不具有使用此功能的權限";
      case SERVER_RTN_CRTOKEN_EXPIRED:
        return "防重送驗證失敗，該序號失效";
      case SERVER_RTN_CA_ERROR:
        return "CA回傳錯誤";
      case SERVER_RTN_AUTH_FAIL:
        return "認證失敗";
      case SERVER_RTN_SERVER_ALREADY_RUNNING:
        return "伺服器狀態為已啟動";
      case SERVER_RTN_SERVER_NOT_START:
        return "伺服器狀態為未啟動";
      case SERVER_RTN_SERVER_STARTING:
        return "伺服器狀態為啟動中";
      case SERVER_RTN_SERVER_STOPPING:
        return "伺服器狀態為暫停中";
      case SERVER_RTN_SERVER_PASSWD_INCORRECT:
        return "在伺服器上的登入密碼錯誤";
      case SERVER_RTN_SERVER_PASSWD_REQUIRED:
        return "需要不只ㄧ組密碼,要求再輸入別組密碼";
      case SERVER_RTN_SERVER_TOKEN_LOGIN_REQUIRED:
        return "需再輸入其他密碼以登入PKCS11 Token";
      case SERVER_RTN_SERVER_HAS_NO_AVAILABLE_TOKEN:
        return "伺服器沒有可用的TOKEN";
      case SERVER_RTN_SERVER_FUNCTION_NOT_SUPPORT:
        return "伺服器未支援此項功能";
      case SERVER_RTN_ACCOUNT_DELETED:
        return "此帳號已刪除";
      case SERVER_RTN_ACCOUNT_LOCKED:
        return "此帳號已封鎖";
      case SERVER_RTN_ACCOUNT_NOT_EXIST:
        return "此帳號不存在";
      case SERVER_RTN_ACCOUNT_ALREADY_EXIST:
        return "此帳號已存在";
      case SERVER_RTN_ACCOUNT_NOT_LOGIN:
        return "此帳號尚未登入";
      case SERVER_RTN_ACCOUNT_SUSPEND:
        return "此帳號已被暫禁";
      case SERVER_RTN_ACCOUNT_DELAYED:
        return "此帳號驗証失敗次數過多, 此後的認證動作將被延遲, 直到執行重新同步成功";
      case SERVER_RTN_ACCOUNT_NORMAL:
        return "使用者狀態為正常";
      case SERVER_RTN_ACCOUNT_NOT_INIT:
        return "此帳號尚未初始化";
      case SERVER_RTN_ACCOUNT_NOT_OTP_USER:
        return "此帳號非OTP使用者";
      case SERVER_RTN_ACCOUNT_NOT_IN_INIT_STATUS:
        return "此帳號非處在INIT狀態,不需註冊";
      case SERVER_RTN_ACCOUNT_TEMPPASSWD_EXPIRED:
        return "使用者臨時密碼已過期";
      case SERVER_RTN_ACCOUNT_TEMPPASSWD_INCORRECT:
        return "使用者臨時密碼錯誤";
      case SERVER_RTN_ACCOUNT_OTP_INCORRECT:
        return "此帳號的動態密碼不正確";
      case SERVER_RTN_ACCOUNT_UNALLOWED_OPERATION:
        return "使用者不被授權此操作";
      case SERVER_RTN_ACCOUNT_UNTRUSTED_CA:
        return "簽章憑證的根憑證，並未被VA信任";
      case SERVER_RTN_CERTACCOUNT_DUPLICATE_KEY1:
        return "KEY1 重覆";
      case SERVER_RTN_INVALID_USER_OR_PASS:
        return "無效的使用者帳號或密碼";
      case SERVER_RTN_ACCOUNT_UNINIT_OTP_TOKEN_FOUND:
        return "系統發現使用者尚有未註冊的OTP token, 請先註冊或刪除後再繼續新增";
      case SERVER_RTN_ACCOUNT_TOKEN_NOT_FOUND:
        return "找不到指定的OTP token";
      case SERVER_RTN_ACCOUNT_HAS_NO_WORKING_TOKEN:
        return "使用者沒有已註冊的token";
      case SERVER_RTN_ACCOUNT_ROLENOTEXIST:
        return "該角色或群組不存在，請先新增指定的角色或群組";
      case SERVER_RTN_ACCOUNT_HAS_NO_UNUSED_TOKEN:
        return "使用者沒有未啟用的token";
      case SERVER_RTN_ACCOUNT_ALREADY_HAS_SMS_TOKEN:
        return "使用者已可使用簡訊OTP功能";
      case SERVER_RTN_LICENSE_SN_ERROR:
        return "授權檔的序號錯誤";
      case SERVER_RTN_LICENSE_UNALLOWED_IP:
        return "授權檔的使用IP為無效";
      case SERVER_RTN_UNALLOWED_IP:
        return "發出要求的IP不被允許";
      case SERVER_RTN_INVALID_RA:
        return "RA非發出此憑證的RA，或CA無此RA資料，或RA伺服器憑證無效";
      case SERVER_RTN_ALL_CACERT_EXPIRED:
        return "CA憑證均已過期, 或未設定任何CA憑證";
      case SERVER_RTN_LICENSE_MISUSE:
        return "授權檔非此產品所使用";
      case SERVER_RTN_LICENSE_EXPIRED_OR_NOT_YET_VALID:
        return "授權檔已過期或尚未合法";
      case SERVER_RTN_LICENSE_USER_EXCEEDED:
        return "使用者人數已超過授權檔限制";
      case SERVER_RTN_LICENSE_VERSION_NOT_MATCH:
        return "授權檔版本不符";
      case SERVER_RTN_SMS_QUOTA_EXHAUSTED:
        return "簡訊傳送功能餘額已用盡";
      case SERVER_RTN_SMS_SEND_FAILED:
        return "傳送SMS訊息失敗";
      case SERVER_RTN_SMTP_SEND_FAILED:
        return "傳送電子郵件失敗";
      case SERVER_RTN_SMS_SETTING_ERROR:
        return "簡訊傳送設定有誤";
      case SERVER_RTN_BACKUP_INVALID_SETTING:
        return "備份設定錯誤";
      case SERVER_RTN_INVALID_SETTING:
        return "無效的設定";
      case SERVER_RTN_SETTING_FILES_NOT_FOUND:
        return "找不到系統設定檔，請確認設定檔是否存在或存取路徑是否正確";
      case SERVER_RTN_LICENSE_MAC_NOT_MATCH:
        return "網路卡MAC不符";
      case SERVER_RTN_UNAUTHORIZED_FUNCTION:
        return "發出要求者(如RA)未被授權此項功能";
      case SERVER_RTN_DATABASE_FAIL:
        return "資料庫發生錯誤";
      case SERVER_RTN_DATABASE_NODATA:
        return "在資料庫中找不到指定的資料";
      case SERVER_RTN_DATABASE_DATA_EXIST:
        return "在資料庫中該筆資料已經存在";
      case SERVER_RTN_DATABASE_INVALID_FORMAT:
        return "資料庫回傳資料型態或回傳格式錯誤";
      case SERVER_RTN_CERT_STATE_EXPIRED:
        return "憑證尚未生效或者已過期";
      case SERVER_RTN_CERT_STATE_EXPIRING:
        return "憑證狀態為即將過期";
      case SERVER_RTN_CERT_STATE_REVOKED:
        return "憑證狀態為已被撤銷";
      case SERVER_RTN_CERT_STATE_REVOKING:
        return "憑證狀態為撤銷中";
      case SERVER_RTN_CERT_STATE_SUSPENDED:
        return "憑證狀態為已暫禁";
      case SERVER_RTN_CERT_STATE_SUSPENDING:
        return "憑證狀態為暫禁中";
      case SERVER_RTN_CERT_STATE_EXTENDING:
        return "展期或更新時發現憑證已在等候展期";
      case SERVER_RTN_CERT_STATE_EXTENDED:
        return "展期或更新時發現憑證已展期完成";
      case SERVER_RTN_CERT_STATE_RENEWING:
        return "展期或更新時發現憑證已在等候更新";
      case SERVER_RTN_CERT_STATE_RENEWED:
        return "展期或更新時發現憑證已更新完成";
      case SERVER_RTN_CERT_STATE_NOT_YET_VALID:
        return "憑證並非在有效期間";
      case SERVER_RTN_CERT_STATE_REMOVEFROMCRL:
        return "憑證已從 CRL 中移除";
      case SERVER_RTN_CERT_STATE_INVALID:
        return "此操作的憑證狀態為不允許的狀態";
      case SERVER_RTN_CERT_FORMAT_ERROR:
        return "憑證的格式錯誤";
      case SERVER_RTN_CERT_NOT_FOUND:
        return "找不到此指定憑證";
      case SERVER_RTN_CERT_BAD_SIGNATURE:
        return "憑證內的簽章是無效的";
      case SERVER_RTN_CERT_NOT_EXPIRING:
        return "展期時發現憑證未達即將過期時間";
      case SERVER_RTN_CERT_VALIDCERT_EXIST:
        return "憑證仍然有效";
      case SERVER_RTN_CERT_APPLYREQ_EXIST:
        return "申請憑證時發現相同申請要求已存在";
      case SERVER_RTN_CERT_INVALID_KEYUSAGE:
        return "無效的金鑰用途";
      case SERVER_RTN_CERT_APPLY_FAIL:
        return "申請憑證後抓取憑證時,回傳申請行動失敗";
      case SERVER_RTN_INVALID_CERTTYPE:
        return "展期或更新時,找不到原憑證的憑證類別";
      case SERVER_RTN_CERT_WAIT_APPLY:
        return "等待CA核准";
      case SERVER_RTN_INVALID_CSR:
        return "無效的憑證請求檔";
      case SERVER_RTN_CRL_DOWN_FAIL:
        return "CRL下載失敗";
      case SERVER_RTN_CRL_PARSE_ERROR:
        return "CRL解析失敗";
      case SERVER_RTN_RTNMSG_FORMAT_ERROR:
        return "回傳訊息格式錯誤";
      case SERVER_RTN_PROCESS_WAITING:
        return "申請憑證後抓取憑證時,回傳申請等待處理";
      case SERVER_RTN_PROCESS_FAIL:
        return "申請憑證後抓取憑證時,回傳申請處理失敗";
      case SERVER_RTN_UNAVAILABLE:
        return "申請憑證後抓取憑證時,因不明原因未能成功";
      case SERVER_RTN_PKCS7_FORMAT_ERROR:
        return "PKCS7 的格式錯誤";
      case SERVER_RTN_PKCS7_NO_CONTENT:
        return "PKCS7 中並沒有包含原文";
      case SERVER_RTN_VERIFY_BAD_CONTENT:
        return "原文錯誤，驗章失敗";
      case SERVER_RTN_UNMATCH_CERT_PRIKEY:
        return "使用的金鑰與憑證並非是成對的";
      case SERVER_RTN_USER_UNMATCH_ID_CERT:
        return "此憑證未登記於該使用者ID.";
      case SERVER_RTN_USER_CERTREGISTEDOTHER:
        return "此憑證已登記於其他使用者ID.";
      case SERVER_RTN_USER_NOT_REGISTER_CERT:
        return "使用者未註冊該憑證";
      case SERVER_RTN_CERT_EXIST:
        return "此憑證已存在";
      case SERVER_RTN_CARD_ALREADY_OPENED:
        return "卡片已開卡";
      case FSXML_RTN_ERROR:
        return "一般性錯誤";
      case FSXML_RTN_INVALID_ALGORITHM:
        return "錯誤的演算法";
      case FSXML_RTN_CRYPT_FAIL:
        return "執行的演算法失敗";
      case FSXML_RTN_INCORRECT_SIGNATURE:
        return "XML 簽章值錯誤";
      case FSXML_RTN_INCORRECT_REFERENCE:
        return "XML 指定參考的摘要值錯誤";
      case FSXML_RTN_C14N_FAIL:
        return "C14N 錯誤";
      case FSXML_RTN_TRANSFORM_FAIL:
        return "執行 Transform 演算法失敗";
      case FSXML_RTN_RESOLVER_FAIL:
        return "執行 resolver 失敗";
      case FSXML_RTN_NO_SIGNATURE:
        return "找不到簽章植";
      case FSXML_RTN_PARSER_ERROR:
        return "解析XML文件時發生錯誤";
      case FSXML_RTN_URI_NOT_EXIST:
        return "URI所指向的文件不存在或為空值";
      case FSXML_RTN_X509DATA_MISMATCH:
        return "憑證內容與的記載不符合";
      case FSXML_RTN_ERROR_XML_DOC:
        return "XML文件錯誤或格式錯誤";
      case FSXML_RTN_INVALID_PARAM:
        return "參數不正確";
      case FSXML_RTN_INVALID_C14N_ALG:
        return "不支援此C14N演算法";
      case FSXML_RTN_INVALID_SIGNATURE_ALG:
        return "不支援此簽章演算法";
      case FSXML_RTN_INVALID_DIGEST_ALG:
        return "不支援此摘要演算法";
      case FSXML_RTN_INVALID_ENCRYPTION_ALG:
        return "不合法的密碼學ALG";
      case FSXML_RTN_INVALID_ENCRYPTION_PARM:
        return "不合法的密碼學參數";
      case FSXML_RTN_INVALID_RETRIEVAL_TYPE:
        return "不合法的回覆型態";
      case FSXML_RTN_NO_ENCRYPTEDKEY:
        return "沒有加密金鑰";
      case FSXML_RTN_NO_ENCRYPTEDDATA:
        return "沒有加密資料";
      case FSXML_RTN_NO_CIPHERVALUE:
        return "沒有密碼值";
      case FSXML_RTN_LOSE_TRANSPORTKEY:
        return "遺失Transport Key";
      case E_ACCESSDENIED:
        return "一般存取錯誤";
      case E_ACCESS_DENIED:
        return "拒絕存取";
      case OPERATION_WAS_CANCELED:
        return "動作被使用者取消";
      case E_NO_ACCESS:
        return "使用者電腦程式未更新或者權限不足";
      case NTE_BAD_UID:
        return "錯誤的UID";
      case NTE_BAD_HASH:
        return "錯誤的Hash";
      case NTE_BAD_KEY:
        return "錯誤的Key";
      case NTE_BAD_LEN:
        return "錯誤的長度";
      case NTE_BAD_DATA:
        return "錯誤的資料";
      case NTE_BAD_SIGNATURE:
        return "不合法的簽章";
      case NTE_BAD_VER:
        return "錯誤的provider版本";
      case NTE_BAD_ALGID:
        return "不合法的演算法";
      case NTE_BAD_FLAGS:
        return "指定的參數無效";
      case NTE_BAD_TYPE:
        return "指定的型態無效";
      case NTE_BAD_KEY_STATE:
        return "指定的金鑰狀態無效";
      case NTE_BAD_HASH_STATE:
        return "指定的Hash狀態無效";
      case NTE_NO_KEY:
        return "Key不存在";
      case NTE_NO_MEMORY:
        return "記憶體不足";
      case NTE_EXISTS:
        return "物件已存在";
      case NTE_PERM:
        return "拒絕存取";
      case NTE_NOT_FOUND:
        return "找不到物件";
      case NTE_DOUBLE_ENCRYPT:
        return "資料已加密";
      case NTE_BAD_PROVIDER:
        return "指定的密碼模組無效";
      case NTE_BAD_PROV_TYPE:
        return "指定的密碼模組型態無效";
      case NTE_BAD_PUBLIC_KEY:
        return "密碼模組的公鑰無效";
      case NTE_BAD_KEYSET:
        return "Keyset不存在";
      case NTE_PROV_TYPE_NOT_DEF:
        return "密碼模組型態未定義";
      case NTE_PROV_TYPE_ENTRY_BAD:
        return "已註冊的密碼模組型態無效";
      case NTE_KEYSET_NOT_DEF:
        return "Keyset未定義";
      case NTE_KEYSET_ENTRY_BAD:
        return "已註冊的Keyset無效";
      case NTE_PROV_TYPE_NO_MATCH:
        return "密碼模組型態與已註冊的值不相符";
      case NTE_SIGNATURE_FILE_BAD:
        return "簽章值已被篡改";
      case NTE_PROVIDER_DLL_FAIL:
        return "密碼模組的DLL無法初始";
      case NTE_PROV_DLL_NOT_FOUND:
        return "找不到密碼模組的DLL";
      case NTE_BAD_KEYSET_PARAM:
        return "Keyset參數無效";
      case NTE_FAIL:
        return "內部錯誤";
      case NTE_SYS_ERR:
        return "一般錯誤";
      case NTE_SILENT_CONTEXT:
        return "密碼模組無法以背景模式運行";
      case NTE_TOKEN_KEYSET_STORAGE_FULL:
        return "Smart Card或者USB Token的空間已滿";
      case NTE_TEMPORARY_PROFILE:
        return "使用到暫存的profile";
      case NTE_FIXEDPARAMETER:
        return "CSP修正導致金鑰參數無法正常被設定";
      case CRYPT_E_BAD_LEN:
        return "輸出資料的長度超過限制";
      case CRYPT_E_BAD_ENCODE:
        return "編碼或解碼時發生錯誤";
      case CRYPT_E_FILE_ERROR:
        return "不合法的字元";
      case CRYPT_E_NOT_FOUND:
        return "金鑰不存在，請使用當初申請憑證的電腦，或者確認此電腦未重新格式化過";
      case CRYPT_E_EXISTS:
        return "物件或屬性已存在";
      case CRYPT_E_NO_PROVIDER:
        return "未指定密碼模組";
      case CRYPT_E_SELF_SIGNED:
        return "指定的憑證是自簽憑證";
      case CRYPT_E_DELETED_PREV:
        return "憑證或CRL內容已被刪除";
      case CRYPT_E_NO_MATCH:
        return "找不到符合的物件";
      case CRYPT_E_UNEXPECTED_MSG_TYPE:
        return "找不到憑證的私密金鑰參數";
      case CRYPT_E_NO_KEY_PROPERTY:
        return "因找不到憑證的私密金鑰導致解密失敗";
      case CRYPT_E_NO_DECRYPT_CERT:
        return "因找不到憑證導致解密失敗";
      case CRYPT_E_BAD_MSG:
        return "不是一個密文訊息格式";
      case CRYPT_E_NO_SIGNER:
        return "找不到signer";
      case CRYPT_E_PENDING_CLOSE:
        return "程序無法關閉可能是記憶體或磁碟空間不足夠";
      case SCARD_F_INTERNAL_ERROR:
        return "內部錯誤";
      case SCARD_E_CANCELLED:
        return "動作已取消";
      case SCARD_E_INVALID_HANDLE:
        return "無效的Handle";
      case SCARD_E_INVALID_PARAMETER:
        return "參數無效";
      case SCARD_E_INVALID_TARGET:
        return "無效的Target";
      case SCARD_E_NO_MEMORY:
        return "記憶體不足";
      case SCARD_F_WAITED_TOO_LONG:
        return "等待時間過長";
      case SCARD_E_INSUFFICIENT_BUFFER:
        return "暫存區不足夠";
      case SCARD_E_UNKNOWN_READER:
        return "無法識別的讀卡機";
      case SCARD_E_TIMEOUT:
        return "等待時間過久";
      case SCARD_E_SHARING_VIOLATION:
        return "因其他connection未結束導致連接不上smart card或者USB token";
      case SCARD_E_NO_SMARTCARD:
        return "Smart card或者USB token未插入到讀卡機中";
      case SCARD_E_UNKNOWN_CARD:
        return "無法識別的smart card或者USB token";
      case SCARD_E_CANT_DISPOSE:
        return "需求的媒體無法配置";
      case SCARD_E_PROTO_MISMATCH:
        return "使用的協定不相容";
      case SCARD_E_NOT_READY:
        return "讀卡機或卡片尚未準備好";
      case SCARD_E_INVALID_VALUE:
        return "無效的參數值";
      case SCARD_E_SYSTEM_CANCELLED:
        return "系統取消此操作";
      case SCARD_F_COMM_ERROR:
        return "內部溝通發生錯誤";
      case SCARD_F_UNKNOWN_ERROR:
        return "內部發生未知的錯誤";
      case SCARD_E_INVALID_ATR:
        return "無效的ATR";
      case SCARD_E_NOT_TRANSACTED:
        return "企圖結束一筆不存在的交易";
      case SCARD_E_READER_UNAVAILABLE:
        return "讀卡機無法使用";
      case SCARD_P_SHUTDOWN:
        return "操作中止";
      case SCARD_E_PCI_TOO_SMALL:
        return "PCI接收暫存區不足夠";
      case SCARD_E_READER_UNSUPPORTED:
        return "讀卡機驅動程式無法支援";
      case SCARD_E_DUPLICATE_READER:
        return "讀卡機驅動程式名稱重複";
      case SCARD_E_CARD_UNSUPPORTED:
        return "Smart card或者USB token不支援";
      case SCARD_E_NO_SERVICE:
        return "Smart Card服務無法執行";
      case SCARD_E_SERVICE_STOPPED:
        return "Smart Card服務被停止";
      case SCARD_E_UNEXPECTED:
        return "發生未預期的錯誤";
      case SCARD_E_ICC_INSTALLATION:
        return "找不到對應密碼模組";
      case SCARD_E_ICC_CREATEORDER:
        return "要求的物件順序不支援";
      case SCARD_E_UNSUPPORTED_FEATURE:
        return "要求feature的不支援";
      case SCARD_E_DIR_NOT_FOUND:
        return "在smart card中找不到DIR(identified directory)";
      case SCARD_E_FILE_NOT_FOUND:
        return "在smart card中找不到identified file";
      case SCARD_E_NO_DIR:
        return "提供的路徑不是一個smart card目錄";
      case SCARD_E_NO_FILE:
        return "提供的路徑沒有smart card檔案";
      case SCARD_E_NO_ACCESS:
        return "檔案拒絕存取";
      case SCARD_E_WRITE_TOO_MANY:
        return "Smart card的記憶體不足夠";
      case SCARD_E_BAD_SEEK:
        return "指定物件時發生錯誤";
      case SCARD_E_INVALID_CHV:
        return "PIN不正確";
      case SCARD_E_UNKNOWN_RES_MNG:
        return "出現未知的錯誤代碼";
      case SCARD_E_NO_SUCH_CERTIFICATE:
        return "找不到要求的憑證";
      case SCARD_E_CERTIFICATE_UNAVAILABLE:
        return "無法取得需求的憑證";
      case SCARD_E_NO_READERS_AVAILABLE:
        return "找不到要求的讀卡機";
      case SCARD_E_COMM_DATA_LOST:
        return "與smart card或者USB token溝通發生錯誤";
      case SCARD_E_NO_KEY_CONTAINER:
        return "找不到要求的金鑰";
      case SCARD_E_SERVER_TOO_BUSY:
        return "Smart card服務太忙碌";
      case SCARD_W_UNSUPPORTED_CARD:
        return "因為ATR衝突導致讀卡機無法與smart card溝通";
      case SCARD_W_UNRESPONSIVE_CARD:
        return "Smart card無反應";
      case SCARD_W_UNPOWERED_CARD:
        return "Smart card無電力導致溝通失敗";
      case SCARD_W_RESET_CARD:
        return "Smart card或者USB Token重置中";
      case SCARD_W_REMOVED_CARD:
        return "Smart card或者USB token被移除導致溝通失敗";
      case SCARD_W_SECURITY_VIOLATION:
        return "因為違反資訊安全導致拒絕存取";
      case SCARD_W_WRONG_CHV:
        return "輸入的PIN不正確";
      case SCARD_W_CHV_BLOCKED:
        return "Smart Card或者USB token已被鎖卡無法使用";
      case SCARD_W_EOF:
        return "未達到smart card的EOF";
      case SCARD_W_CANCELLED_BY_USER:
        return "使用者取消操作";
      case SCARD_W_CARD_NOT_AUTHENTICATED:
        return "Smart card尚未通過PIN code驗證";
      case FSP11_RTN_CANCEL:
        return "取消操作";
      case FSP11_RTN_HOST_MEMORY:
        return "記憶體不足";
      case FSP11_RTN_SLOT_ID_INVALID:
        return "指定的Slot是無效的";
      case FSP11_RTN_GENERAL_ERROR:
        return "一般性錯誤";
      case FSP11_RTN_FUNCTION_FAILED:
        return "要求的函式無法執行";
      case FSP11_RTN_ARGUMENTS_BAD:
        return "錯誤的參數";
      case FSP11_RTN_NO_EVENT:
        return "無事件";
      case FSP11_RTN_NEED_TO_CREATE_THREADS:
        return "需要建立Threads";
      case FSP11_RTN_CANT_LOCK:
        return "無法Lock";
      case FSP11_RTN_ATTRIBUTE_READ_ONLY:
        return "唯讀屬性";
      case FSP11_RTN_ATTRIBUTE_SENSITIVE:
        return "機密屬性";
      case FSP11_RTN_ATTRIBUTE_TYPE_INVALID:
        return "屬性型態不正確";
      case FSP11_RTN_ATTRIBUTE_VALUE_INVALID:
        return "屬性值不正確";
      case FSP11_RTN_DATA_INVALID:
        return "資料不正確";
      case FSP11_RTN_DATA_LEN_RANGE:
        return "資料長度不正確";
      case FSP11_RTN_DEVICE_ERROR:
        return "因智慧卡異常，請連繫玉山銀行現金管理人員處理";
      case FSP11_RTN_DEVICE_MEMORY:
        return "設備記憶體不足";
      case FSP11_RTN_DEVICE_REMOVED:
        return "設備移除";
      case FSP11_RTN_ENCRYPTED_DATA_INVALID:
        return "加密資料不正確";
      case FSP11_RTN_ENCRYPTED_DATA_LEN_RANGE:
        return "加密資料長度不正確";
      case FSP11_RTN_FUNCTION_CANCELED:
        return "功能已取消";
      case FSP11_RTN_FUNCTION_NOT_PARALLEL:
        return "功能無法並行";
      case FSP11_RTN_FUNCTION_NOT_SUPPORTED:
        return "功能不支援";
      case FSP11_RTN_KEY_HANDLE_INVALID:
        return "金鑰Handle不正確";
      case FSP11_RTN_KEY_SIZE_RANGE:
        return "金鑰長度不正確";
      case FSP11_RTN_KEY_TYPE_INCONSISTENT:
        return "金鑰種類不一致";
      case FSP11_RTN_KEY_NOT_NEEDED:
        return "金鑰已不需要";
      case FSP11_RTN_KEY_CHANGED:
        return "金鑰已變更";
      case FSP11_RTN_KEY_NEEDED:
        return "需要金鑰";
      case FSP11_RTN_KEY_INDIGESTIBLE:
        return "無法接受的金鑰";
      case FSP11_RTN_KEY_FUNCTION_NOT_PERMITTED:
        return "金鑰功能不被允許";
      case FSP11_RTN_KEY_NOT_WRAPPABLE:
        return "金鑰無法包裹";
      case FSP11_RTN_KEY_UNEXTRACTABLE:
        return "金鑰無法匯出";
      case FSP11_RTN_MECHANISM_INVALID:
        return "機制不正確";
      case FSP11_RTN_MECHANISM_PARAM_INVALID:
        return "機制參數不正確";
      case FSP11_RTN_OBJECT_HANDLE_INVALID:
        return "物件Handle不正確";
      case FSP11_RTN_OPERATION_ACTIVE:
        return "操作運作中";
      case FSP11_RTN_OPERATION_NOT_INITIALIZED:
        return "操作未初始化";
      case FSP11_RTN_PIN_INCORRECT:
        return "密碼不正確";
      case FSP11_RTN_PIN_INVALID:
        return "密碼不合法";
      case FSP11_RTN_PIN_LEN_RANGE:
        return "密碼長度不正確";
      case FSP11_RTN_PIN_EXPIRED:
        return "密碼已過期";
      case FSP11_RTN_PIN_LOCKED:
        return "密碼已經鎖住";
      case FSP11_RTN_SESSION_CLOSED:
        return "Session已結束";
      case FSP11_RTN_SESSION_COUNT:
        return "Session Count不正確";
      case FSP11_RTN_SESSION_HANDLE_INVALID:
        return "Session Handle不正確";
      case FSP11_RTN_SESSION_PARALLEL_NOT_SUPPORTED:
        return "Session不支援並行";
      case FSP11_RTN_SESSION_READ_ONLY:
        return "Session為唯讀";
      case FSP11_RTN_SESSION_EXISTS:
        return "Session已存在";
      case FSP11_RTN_SESSION_READ_ONLY_EXISTS:
        return "Session為唯讀已存在";
      case FSP11_RTN_SESSION_READ_WRITE_SO_EXISTS:
        return "Session可讀寫已存在";
      case FSP11_RTN_SIGNATURE_INVALID:
        return "簽章值不合法";
      case FSP11_RTN_SIGNATURE_LEN_RANGE:
        return "簽章值長度不正確";
      case FSP11_RTN_TEMPLATE_INCOMPLETE:
        return "樣板不完整";
      case FSP11_RTN_TEMPLATE_INCONSISTENT:
        return "樣板不一致";
      case FSP11_RTN_TOKEN_NOT_PRESENT:
        return "Token不存在";
      case FSP11_RTN_TOKEN_NOT_RECOGNIZED:
        return "Token無法辨識";
      case FSP11_RTN_TOKEN_WRITE_PROTECTED:
        return "Token有寫入保護";
      case FSP11_RTN_UNWRAPPING_KEY_HANDLE_INVALID:
        return "解包裹的金鑰Handle不合法";
      case FSP11_RTN_UNWRAPPING_KEY_SIZE_RANGE:
        return "解包裹的金鑰長度不正確";
      case FSP11_RTN_UNWRAPPING_KEY_TYPE_INCONSISTENT:
        return "解包裹的金鑰種類不一致";
      case FSP11_RTN_USER_ALREADY_LOGGED_IN:
        return "使用者已登入";
      case FSP11_RTN_USER_NOT_LOGGED_IN:
        return "使用者未登入";
      case FSP11_RTN_USER_PIN_NOT_INITIALIZED:
        return "密碼未初始化";
      case FSP11_RTN_USER_TYPE_INVALID:
        return "使用者種類不正確";
      case FSP11_RTN_USER_ANOTHER_ALREADY_LOGGED_IN:
        return "另一個使用者已登入";
      case FSP11_RTN_USER_TOO_MANY_TYPES:
        return "太多使用者種類";
      case FSP11_RTN_WRAPPED_KEY_INVALID:
        return "包裹的金鑰不合法";
      case FSP11_RTN_WRAPPED_KEY_LEN_RANGE:
        return "包裹的金鑰長度不正確";
      case FSP11_RTN_WRAPPING_KEY_HANDLE_INVALID:
        return "包裹的金鑰Handle不合法";
      case FSP11_RTN_WRAPPING_KEY_SIZE_RANGE:
        return "包裹中的金鑰長度不正確";
      case FSP11_RTN_WRAPPING_KEY_TYPE_INCONSISTENT:
        return "包裹中的金鑰種類不一致";
      case FSP11_RTN_RANDOM_SEED_NOT_SUPPORTED:
        return "不支援Random Seed";
      case FSP11_RTN_RANDOM_NO_RNG:
        return "無Random RNG";
      case FSP11_RTN_BUFFER_TOO_SMALL:
        return "記憶體緩衝區太小";
      case FSP11_RTN_SAVED_STATE_INVALID:
        return "儲存狀態失敗";
      case FSP11_RTN_INFORMATION_SENSITIVE:
        return "資訊為機密";
      case FSP11_RTN_STATE_UNSAVEABLE:
        return "狀態無法儲存";
      case FSP11_RTN_CRYPTOKI_NOT_INITIALIZED:
        return "函式庫尚未初始化過";
      case FSP11_RTN_CRYPTOKI_ALREADY_INITIALIZED:
        return "函式庫已經初始化過";
      case FSP11_RTN_MUTEX_BAD:
        return "MUTEX壞了";
      case FSP11_RTN_MUTEX_NOT_LOCKED:
        return "MUTEX無鎖住";
      case FSP11_RTN_VENDOR_DEFINED:
        return "廠商已定義";
      case FSP11_RTN_OBJECT_NOT_EXIST:
        return "指定物件不存在";
      case FSP11_RTN_OBJECT_EXIST:
        return "指定物件已存在";
      case FSP11_RTN_OBJECT_HAS_PROBLEM:
        return "相同物件超過一個";
      case FSP11_RTN_LOAD_LIBRARY_FAIL:
        return "載入函式庫失敗";
      case FSP11_RTN_LIBRARY_NOT_LOAD:
        return "函式庫尚未載入";
      case FSP11_RTN_SLOT_NOT_FOUND:
        return "slot找不到";
      case FSP11_RTN_FORCE_USER_CHANGE_PIN:
        return "強制更換密碼";
      case FSP11_RTN_UNKNOW_ERROR:
        return "未知的錯誤";
      case MULTIPLE_TOKEN:
        return "重覆插入兩種以上的憑證載具，請先移除";
      case DRIVER_NOT_FOUND:
        return "無法讀取載具，請確認載具是否已插上、以及已安裝載具驅動程式";
      case NOT_SUPPORT_64BIT:
        return "載具不支援64位元瀏覽器，請更換32位元版本執行";
      case ACTIVEX_LOAD_FAIL:
        return "ActiveX元件尚未安裝成功或IE安全性設定不允許執行ActiveX元件";
      case JAVA_DISABLE:
        return "瀏覽器設定請啟用Java支援";
      case JRE_VERSION:
        return "Java Runtime 版本過低";
      case SERVICE_WINDOW_2048:
        return "無法申請2048憑證，請洽詢往來分行或企網銀服務窗口";
      case NOT_SUPPORT_TOKEN:
        return "載具不支援";
      default:
        return "未定義的錯誤代碼(" + errcode + ")";
    }
  }

  return {
    pinToken: function () {
      return pinToken();
    },
    verifyToken: function (disableRePlug, pinpad) {
      return verifyToken(disableRePlug, pinpad);
    },
    getSignData: function () {
      return getSignData();
    },
    initToken: function (
      id1,
      ido,
      id2,
      id3,
      id4,
      id5,
      checkPassword,
      lang,
      osType,
      bNPAPI
    ) {
      return initToken(
        id1,
        ido,
        id2,
        id3,
        id4,
        id5,
        checkPassword,
        lang,
        osType,
        bNPAPI
      );
    },
    getESphinxObj: function () {
      return getESphinxObj();
    },
    detectToken: function () {
      return detectToken();
    },
    p11Login: function (pin, type, flag) {
      return p11Login(pin, type, flag);
    },
    p11Logout: function (open, login) {
      return p11Logout(open, login);
    },
    pinpadMode: function (iMode) {
      return pinpadMode(iMode);
    },
    p11GetCN: function () {
      return p11GetCN();
    },
    p11GetSN: function () {
      return p11GetSN();
    },
    CGErrCodes: function (errcode) {
      return CGErrCodes(errcode);
    },
    p11GetCnAsGuest: function () {
      return getP11CN();
    },
    p11PureSign: function (data) {
      return p11PureSign(data);
    },
    p11GenCSR: function (sCN, keyLabel) {
      return p11GenCSR(sCN, keyLabel);
    },
    p11SaveCert: function (cert) {
      return p11SaveCert(cert);
    },
    p11ChgPassword: function (oldPwd, newPwd) {
      return p11ChgPassword(oldPwd, newPwd);
    },
    getLastErr: function () {
      return getLastErr();
    },
    getLastErrCodes: function () {
      return getLastErrCodes();
    },
    p11Unlock: function (serverKey, transportKey, userPin) {
      return p11Unlock(serverKey, transportKey, userPin);
    },
    getToken: function () {
      return token;
    },
    p7Sign: function (csr) {
      return p7Sign(csr);
    },
    deleteExpiredCert: function (expiredDateTime) {
      return deleteExpiredCert(expiredDateTime);
    },
    getOperatorLog: function () {
      return getOperatorLog();
    },
  };
})($);

// 瀏覽器環境中，將 VAModule 設置為全域變數
if (typeof window !== "undefined") {
  window.VAModule = VAModule;
}

// Node.js 環境中，使用 module.exports
if (typeof module !== "undefined" && module.exports) {
  module.exports = VAModule;
}
